interface Translations extends types.redux.translations.translations {}

export const translations: Translations = {
	orderNow: {
		en: 'Order Now',
		ar: 'اطلب الان',
	},
	okey: {
		en: 'Okay',
		ar: 'تمام',
	},
	remove: {
		en: 'Remove',
		ar: 'يزيل',
	},
	retry: {
		en: 'Retry',
		ar: 'أعد المحاولة',
	},
	OMR: {
		en: ' OMR',
		ar: ' ريال',
	},
	confirm: {
		en: 'Confirm',
		ar: 'يرجى تأكيد',
	},
	all: {
		en: 'All',
		ar: 'الكل',
	},
	email: {
		en: 'E-mail',
		ar: 'البريد الإلكتروني',
	},
	type: {
		en: 'Type',
		ar: 'النوع',
	},
	documents: {
		en: 'Documents',
		ar: 'الوثائق',
	},
	amount: {
		en: 'Amount',
		ar: 'المبلغ',
	},
	date: {
		en: 'Date',
		ar: 'التاريخ',
	},
	one: {
		en: 'One',
		ar: 'واحد',
	},
	many: {
		en: 'Many',
		ar: 'عدة ارقام',
	},
	success: {
		en: 'Success',
		ar: 'نجاح',
	},
	unsubscribe: {
		en: 'Unsubscribe',
		ar: 'إلغاء الاشتراك',
	},
	finished: {
		en: 'Finished',
		ar: 'تم الانتهاء من',
	},
	ineligible: {
		en: 'Ineligible',
		ar: 'غير مؤهل',
	},
	'see.more': {
		en: 'see more',
		ar: 'شاهد المزيد',
	},
	// Errors
	'error.welcome': {
		en: 'Go to Welcome Page',
		ar: 'الذهاب إلى الصفحة الترحيبية',
	},
	'error.unexpected.exception': {
		en: 'Unexpected error',
		ar: 'حدث خطأ ما!',
	},
	'error.user.exists': {
		en: 'User already exists',
		ar: 'المستخدم موجود مسبقاً',
	},
	'error.invalid.department.or.insufficient.rights': {
		en: 'Invalid department or insufficient rights',
		ar: 'حدث خطأ في القسم أو الصلاحيات غير صحيحة!',
	},
	'error.invalid.account.or.insufficient.rights': {
		en: 'Invalid account or insufficient rights',
		ar: 'حدث خطأ في الحساب أو الصلاحيات غير صحيحة!',
	},
	'error.department.not.found': {
		en: 'Department not found',
		ar: 'القسم غير موجود',
	},
	'error.invalid-account': {
		en: 'Can’t create an account.',
		ar: 'لا يمكن إنشاء الحساب.',
	},
	'error.link-expired': {
		en: 'The link in your e-mail expired. Please register your account again.',
		ar: 'انتهت صلاحية الوصلة. يرجى إعادة تسجيل الحساب',
	},
	'error.generic-title': {
		en: 'Oops... something went wrong',
		ar: 'حدث خطأ ما..!',
	},
	'error.generic-text': {
		en: 'The application encountered an error processing the request. Logging to an application may fix the issue',
		ar: 'واجه التطبيق مشكلة في معالجة طلبك. يمكن للدخول إلى التطبيق حل هذه المشكلة',
	},
	'error.timeout': {
		en: 'A connection error occurred.',
		ar: 'حدثت مشكلة في الاتصال',
	},
	'error.occured': {
		en: 'An unexpected error occurred.',
		ar: 'حدث خطأ غير متوقع',
	},
	'error.invalid.omantel.number': {
		en: 'The mobile number is not an omantel number.',
		ar: 'الرقم المدخل ليس بشبكة عمانتل',
	},
	'error.sending.otp': {
		en: 'Sending OTP number failed.',
		ar: 'فشل في إرسال "كلمة المرور لمرة واحدة" "OTP"',
	},
	'error.profile.not.found.by.email': {
		en: 'User profile cannot be found or is inactive.',
		ar: 'لم نتمكن من العثور على اسم المستخدم أو أنه غير مفعل',
	},
	'error.getting.user.data': {
		en: 'Cannot get user data.',
		ar: 'ا يمكن الحصول على معلومات المستخدم',
	},
	'error.invalid.request': {
		en: 'Something went wrong.',
		ar: 'لقد حدث خطأ ما',
	},
	'error.invalid.user.login': {
		en: 'Invalid user login.',
		ar: 'بيانات دخول غير صحيحة',
	},
	'error.unverified.session': {
		en: 'Your session has expired.',
		ar: 'لقد انتهى الوقت ',
	},
	'error.invalid.otp.provider': {
		en: 'Invalid OTP token.',
		ar: '"كلمة المرور لمرة واحدة" "OTP" غير صحيحة',
	},
	'error.invalid.file.extension': {
		en: 'Invalid file extension',
		ar: 'ملحق الملف غير صالح',
	},
	'error.file.is.empty': {
		en: 'The uploaded file is empty',
		ar: 'الملف المضاف لا يحتوي على معلومات',
	},
	'upload.file': {
		en: 'Upload file',
		ar: 'تحميل الملف',
	},
	'error.insufficient.rights': {
		en: 'Insufficient rights',
		ar: 'حقوق غير كافية',
	},
	'error.number.not.found': {
		en: 'Number not found',
		ar: 'الرقم غير موجود',
	},
	'error.requesting.web.service': {
		en: 'Requesting web service',
		ar: 'طلب خدمة الويب',
	},
	'error.reading.main.config': {
		en: 'Reading main config',
		ar: 'قراءة التكوين الرئيسي',
	},
	'error.cr.number.not.found': {
		en: 'CR number not found',
		ar: 'رقم السجل التجاري غير موجود',
	},
	'error.validating.otp': {
		en: 'Problem during OTP token validation',
		ar: 'حدثت مشكلة أثناء المصادقة على "كلمة المرور لمرة واحدة"',
	},
	'error.invalid.credentials': {
		en: 'Password is incorrect. Please try again.',
		ar: 'كلمة المرور غير صحيحة، الرجاء المحاولة مرة أخرى',
	},
	'error.password.does.not.match': {
		en: 'Passwords not match',
		ar: 'كلمات المرور غير متطابقة',
	},
	'error.invalid.format': {
		en: 'Invalid msisdn format',
		ar: 'صيغة رقم msisdn غير صحيحة',
	},
	'error.password.can.not.be.empty': {
		en: 'Empty password provided',
		ar: 'لم يتم إدخال كلمة المرو',
	},
	'error.password.too.short': {
		en: 'Password too short',
		ar: 'كلمة المرو قصيرة جدا',
	},
	'error.password.too.long': {
		en: 'Password too long',
		ar: 'كلمة المرور طويلة جدا',
	},
	'error.password.contains.invalid.characters': {
		en: 'Password contains invalid characters',
		ar: 'كلمة المرور تتضمن أحرف غير مقبولة ',
	},
	'error.password.too.week': {
		en:
			'The password does not adhere to the password policies. Password Policy includes the following: Minimum of 10 characters, Min 1 upper case, Min 1 digit, and Min 1 special character @#$%^&+=!.',
		ar:
			'لا تلتزم كلمة المرور بسياسات كلمة المرور. تتضمن سياسة كلمة المرور ما يلي: الحد الأدنى 10 أحرف، والحد الأدنى حرف كبير واحد، والحد الأدنى رقم واحد، والحد الأدنى حرف خاص واحد @#$%^&+=!.',
	},
	'error.invalid.email.format': {
		en: 'Invalid email address ',
		ar: 'بريد إلكتروني غير صحيح',
	},
	'error.invalid.mobileNumber.format': {
		en: 'Invalid mobile number',
		ar: 'رقم الجوال غير صالح',
	},
	'error.invalid.username.format': {
		en: 'Username has to be between 8 to 16 characters long',
		ar: 'اسم المستخدم المقترح يجب أن يحتوي على 8 إلى 16 حرف',
	},
	'error.email-exists': {
		en: 'This email address is already in use',
		ar: 'البريد الإلكتروني مستخدم سابقا',
	},
	'error.querying.user.repository': {
		en: 'Error accesing LDAP',
		ar: 'حدث خطأ في الوصول إلى LDAP',
	},
	'error.email.is.already.used': {
		en: 'Email already used',
		ar: 'تم استخدام البريد الإلكتروني من قبل',
	},
	'error.querying.database': {
		en: 'Error getting data',
		ar: 'حدث خطأ في الحصول على المعلومات',
	},
	'error.communicating.with.bus': {
		en: 'Internal error has occurred',
		ar: 'حدث خطأ داخلي',
	},
	'error.invalid.token.provided': {
		en: 'Invalid token.',
		ar: 'رمز غير صحيح',
	},
	'error.validating.token': {
		en: 'Error during activation of user profile email address',
		ar: 'حدث خطأ أثناء تفعيل ملف البريد الإلكتروني بملف المستخدم',
	},
	'error.getting.ltpa.token': {
		en: 'Internal error has occurred',
		ar: 'حدث خطأ داخلي',
	},
	'error.invalid.ltpa.token': {
		en: 'Internal error has occurred',
		ar: 'حدث خطأ داخلي',
	},
	'error.getting.data.from.bus': {
		en: 'Internal error has occurred.',
		ar: 'حدث خطأ داخلي',
	},
	'error.active.token.doesnt.exists': {
		en: 'Internal error has occurred.',
		ar: 'حدث خطأ داخلي',
	},
	'error.account.not.found': {
		en: 'Problem with finding a user account',
		ar: 'توجد مشكلة في الحصول على حساب المستخدم',
	},
	'error.not.authorized.for.get.products': {
		en: 'Problem with getting products',
		ar: 'توجد مشكلة في الحصول على المنتجات',
	},
	'error.no.valid.account.found': {
		en: 'Problem with finding a user account',
		ar: 'توجد مشكلة في الحصول على حساب المستخدم',
	},
	'error.retrieving.bill.from.bus': {
		en: 'Internal error has occurred.',
		ar: 'حدث خطأ داخلي ',
	},
	'error.data.parse.result.exception': {
		en: 'Internal error has occurred.',
		ar: 'حدث خطأ داخلي ',
	},
	'error.um.get.current.user.data.exception': {
		en: 'Cannot get user data',
		ar: 'ا يمكن الحصول على بيانات المستخدم',
	},
	'error.could.not.generate.photo.response': {
		en: 'Internal error has occurred',
		ar: 'حدث خطأ داخلي ',
	},
	'error.authentication.code.not.found': {
		en: 'Cannot get logged user',
		ar: 'ا يمكن الحصول على المستخدم الذي قام بالدخول',
	},
	'error.request.topup.invalid.action.type': {
		en: 'Internal error has occurred',
		ar: 'حدث خطأ داخلي ',
	},
	'error.request.creating.device': {
		en: 'Device creation failed',
		ar: 'فشل في إنشاء الجهاز',
	},
	'error.request.device.operation.failed': {
		en: 'Operation of add or remove device failed',
		ar: 'فشلت عملية إضافة/ حذف جهاز',
	},
	'error.wrong.response': {
		en: 'An unexpected error occurred.',
		ar: 'حدث خطأ غير متوقع',
	},
	'error.request.corp.user.not.found': {
		en: 'User not found',
		ar: 'لم يتم العثور على المستخدم ',
	},
	'error.something.went.wrong.please.try.again': {
		en: 'Something went wrong. Please try again.',
		ar: 'حدث خطأ ما، الرجاء المحاولة مرة أخرى',
	},
	'add.user.add.number': {
		en: 'Add number for new user',
		ar: 'أضف رقمًا للمستخدم الجديد',
	},
	'error.request.bill.data.not.found': {
		en: 'Bill data not found.',
		ar: 'بيانات الفاتورة غير موجودة',
	},
	'error.no.file.data': {
		en: 'No file data found',
		ar: 'لم يتم العثور على الملف',
	},
	'error.invalid.file.size': {
		en: 'Invalid file size',
		ar: 'حجم الملف غير صالح',
	},
	'error.company.already.registered': {
		en: 'Company number already registered',
		ar: 'رقم الشركة مسجل مسبقا',
	},
	'error.language.not.found': {
		en: 'Language not found',
		ar: 'لم يتم العثور على اللغة ',
	},
	'error.sending.email': {
		en: 'Sending email failed',
		ar: 'فشل إرسال البريد الالكتروني',
	},
	'error.invalid.username.length': {
		en: 'Invalid username length',
		ar: 'طول اسم المستخدم غير صالح',
	},
	'error.get.user.data': {
		en: 'Getting user data',
		ar: 'الحصول على بيانات المستخدم',
	},
	'error.executing.action': {
		en: 'Executing action',
		ar: 'تنفيذ العمل',
	},
	'error.retrieving.user.data': {
		en: 'Retrieving user data',
		ar: 'استرجاع بيانات المستخدم',
	},
	'error.maximum.admins.limit.exceeded': {
		en: 'You are only allowed to add a maximum of two Admins',
		ar: 'يُسمح لك بإضافة مشرفين كحد أقصى',
	},
	'auth.en': {
		en: 'English',
		ar: 'English',
	},
	'auth.ar': {
		en: 'العربية',
		ar: 'Arabic',
	},
	'register.signup': {
		en: 'Sign up for a business account',
		ar: 'تسجيل حساب تجاري',
	},
	'login.welcome': {
		en: 'Hello, welcome to:',
		ar: 'مرحباً بك:',
	},
	'login.enterprise': {
		en: 'Omantel Enterprise',
		ar: 'وحدة الأعمال التجارية بعمانتل',
	},
	'login.unsuccessfulLogin': {
		en: 'You entered an incorrect email, password, or both. Please, try again.',
		ar: 'لقد قمت بإدخال عنوان بريد إلكتروني غير صحيح أو كلمة مرور غير صحيحة أو كليهما، الرجاء المحاولة مرة أخرى',
	},
	'login.insufficient-rights': {
		en: 'This account has insufficient rights to operate, please contact administator.',
		ar: 'لا يمكن المتابعة بسبب الصلاحيات الخاصة بهذا الحساب، يرجى التواصل معنا.',
	},
	'login.email': {
		en: 'Email address or username',
		ar: 'عنوان البريد الإلكتروني أو اسم المستخدم',
	},
	'login.password': {
		en: 'Password',
		ar: 'كلمة المرور',
	},
	'login.button': {
		en: 'Log in',
		ar: 'الدخول',
	},
	'login.forgotPassword': {
		en: 'Forgot Password?',
		ar: 'نسيت كلمة المرور؟',
	},
	'login.reset': {
		en: 'Reset',
		ar: 'إعادة تعيين',
	},
	'login.wantJoin': {
		en: 'Want to join Omantel Enterprise?',
		ar: 'ترغب في الانضمام إلى وحدة المشتريكن التجاريين بعمانتل؟',
	},
	'login.register': {
		en: 'Register',
		ar: 'التسجيل',
	},
	'login.checking.title': {
		en: 'Almost there...',
		ar: 'بقى القليل..',
	},
	'login.checking.body': {
		en: 'Redirecting to Omantel Enterprise...',
		ar: 'إعادة التوجيه إلى عمانتل للشركات',
	},
	'forgot.form.header': {
		en: 'Forgot password?',
		ar: 'نسيت كلمة المرور؟',
	},
	'forgot.form.body': {
		en: 'Enter your email or username to reset it',
		ar: 'ادخل البريد الإلكتروني أو اسم المستخدم لإستعادة كلمة المرور:',
	},
	'email.address': {
		en: 'Email address',
		ar: 'البريد الإلكتروني',
	},
	'forgot.last.4.digits': {
		en: 'CR number last 4 digits',
		ar: 'آخر أربع أرقام من الوثيقة',
	},
	'forgot.form.reset': {
		en: 'Reset password',
		ar: 'إعادة تعيين كلمة المرور',
	},
	'forgot.confirmation.header': {
		en: 'Check your Email',
		ar: 'الرجاء الإطلاع على بريدك الإلكتروني',
	},
	'forgot.confirmation.body': {
		en: 'You should receive it soon',
		ar: 'ستقوم باستلامه قريبا',
	},
	'forgot.confirmation.instructions': {
		en: 'Instructions have been sent to:',
		ar: 'تم إرسال التعليمات إلى',
	},
	'forgot.password.changed': {
		en: 'Your password has been changed',
		ar: 'تم تغيير كلمة السر الخاصة بك',
	},
	'forgot.backLogin': {
		en: 'Back to Log in page',
		ar: 'الرجوع إلى صفحة الدخول',
	},
	'forgot.unsuccessfulReset': {
		en: 'You entered an incorrect email, last four document digits, or both. Please, try again.',
		ar:
			'لقد قمت بإدخال عنوان بريد إلكتروني غير صحيح أو آخر أربع أرقام غير صحيحة أو كليهما، الرجاء المحاولة مرة أخرى',
	},
	'lock.screen.enter.password': {
		en: 'Enter your password',
		ar: 'أدخل كلمة المرور',
	},
	'lock.screen.unlock': {
		en: 'Unlock',
		ar: 'إلغاء القفل',
	},
	'lock.screen.unlock.screen': {
		en: 'Unlock screen',
		ar: 'إلغاء قفل الشاشة',
	},
	'lock.screen.hello': {
		en: 'Hello',
		ar: 'مرحبا بكم',
	},
	'lock.screen.unsuccessfulLogin': {
		en: 'You entered an incorrect password. Please, try again.',
		ar: 'لقد قمت بإدخال كلمة مرور غير صحيحة، الرجاء المحاولة مرة أخرى',
	},
	'passwordForm.subheader': {
		en: 'Password must contain:',
		ar: 'يجب أن تحتوي كلمة المرور على',
	},
	'passwordForm.mustContain': {
		en: 'Password must meet the following criteria for strength:',
		ar: 'يجب أن تستوفي كلمة المرور معايير القوة التالية:',
	},
	'passwordForm.password': {
		en: 'Your password',
		ar: 'كلمة المرور',
	},
	'passwordForm.repeatPassword': {
		en: 'Repeat password',
		ar: 'أعد إدخال كلمة المرور',
	},
	'passwordForm.button': {
		en: 'Reset password',
		ar: 'إعادة تعيين كلمة المرور',
	},
	'passwordForm.rules.characters': {
		en: 'Be a minimum of %% characters in length.',
		ar: 'أن لا يقل طوله عن %% أحرف.',
	},
	'passwordForm.rules.uppercase': {
		en: 'Include at least one uppercase letter',
		ar: 'قم بتضمين حرف كبير واحد على الأقل',
	},
	'passwordForm.rules.number': {
		en: 'Include at least one number',
		ar: 'قم بتضمين رقم واحد على الأقل',
	},
	'passwordForm.rules.specialCharacter': {
		en: 'Include at least one special character',
		ar: 'قم بتضمين حرف خاص واحد على الأقل',
	},
	'setPassword.subheader': {
		en: 'Hello %%',
		ar: 'مرحبا %%',
	},
	'setPassword.header': {
		en: 'Set your password',
		ar: 'إعادة تعين كلمة المرور',
	},
	'navbar.profile': {
		en: 'Profile',
		ar: 'الملف الشخصي',
	},
	'navbar.log.out': {
		en: 'Log out',
		ar: 'الخروج',
	},
	'navbar.change.password': {
		en: 'Change password',
		ar: 'غير كلمة السر',
	},
	'table.rows': {
		en: '%% rows',
		ar: 'صفوف %%',
	},
	'table.pagesOf': {
		en: 'of',
		ar: 'من',
	},
	'table.show': {
		en: 'Show:',
		ar: 'عرض:',
	},
	'table.download': {
		en: 'Download as %%',
		ar: 'التنزيل بصيغة %%',
	},
	'table.date.time': {
		en: 'Date & Time',
		ar: 'Date & Time',
	},
	'table.download.pdf': {
		en: 'Download PDF',
		ar: 'التنزيل بصيغة PDF',
	},
	'table.results': {
		en: '%% Results',
		ar: 'النتائج %%',
	},
	'path.contact.us': {
		en: 'Contact Us',
		ar: 'تواصل معنا',
	},
	'path.old.selfcare': {
		en: 'Old Portal',
		ar: 'الموقع القديم',
	},
	'path.pay.any.bill': {
		en: 'Pay any bill',
		ar: 'ادفع أي فاتورة',
	},
	'path.user.details': {
		en: 'User Details',
		ar: 'تفاصيل المستخدم',
	},
	'path.topup': {
		en: 'Top Up',
		ar: 'إعادة التعبئة',
	},
	'path.addons': {
		en: 'Add-ons',
		ar: 'الإضافات',
	},
	'path.TU': {
		en: 'TU',
		ar: '[AR] TU',
	},
	'path.all': {
		en: 'All',
		ar: 'الكل',
	},
	'path.mobile': {
		en: 'Mobile',
		ar: 'الهاتف النقال',
	},
	'path.internet': {
		en: 'Internet',
		ar: 'إنترنت',
	},
	'path.fixed.voice': {
		en: 'Fixed Voice',
		ar: 'خط مكالمات ثابت',
	},
	'path.connectivity': {
		en: 'Connectivity',
		ar: 'الربط',
	},
	'path.ict.solutions': {
		en: 'ICT Solutions',
		ar: 'حلول تقنية المعلومات و الإتصالات',
	},
	'path.data.only': {
		en: 'Data only',
		ar: 'بيانات فقط',
	},
	'path.accounts': {
		en: 'Accounts',
		ar: 'الحسابات',
	},
	'path.account': {
		en: 'Account',
		ar: 'الحساب',
	},
	'path.account.details': {
		en: 'Account Details',
		ar: 'تفاصيل الحساب',
	},
	'path.account.packageDetails': {
		en: 'Package Details',
		ar: 'تفاصيل الحساب',
	},
	'path.organizations': {
		en: 'Organizations',
		ar: 'المؤسسات',
	},
	'path.my.organizations': {
		en: 'My Organizations',
		ar: 'مؤسساتي',
	},
	'path.organization': {
		en: 'Organization',
		ar: 'المؤسسة',
	},
	'path.my.organization': {
		en: 'My Organization',
		ar: 'مؤسستي',
	},
	'path.billing.accounts': {
		en: 'Billing Accounts',
		ar: 'حساب الفوترة',
	},
	'path.users': {
		en: 'Users',
		ar: 'المستخدمين',
	},
	'path.my.users': {
		en: 'My Users',
		ar: 'المستخدمين',
	},
	'path.numbers': {
		en: 'Numbers',
		ar: 'الأرقام',
	},
	'path.orders': {
		en: 'Orders Tracking',
		ar: 'تتبع الطلبات',
	},
	'path.my.numbers': {
		en: 'My Numbers',
		ar: 'أرقامي',
	},
	'path.services': {
		en: 'Services',
		ar: 'الخدمات',
	},
	'path.new.services': {
		en: 'Add New Services',
		ar: 'إضافة خدمة جديدة',
	},
	'path.my.services': {
		en: 'My Services',
		ar: 'خدماتي',
	},
	'path.try.and.buy': {
		en: 'Try and Buy',
		ar: 'جرب واشترك',
	},
	'path.payments': {
		en: 'Payments',
		ar: 'المدفوعات',
	},
	'path.my.active.services': {
		en: 'My Active Services',
		ar: 'الخدمات المفعلة',
	},
	'path.my.payments': {
		en: 'My Payments',
		ar: 'المدفوعات',
	},
	'path.payments.history': {
		en: 'Payments History',
		ar: 'سجل الدفع',
	},
	'path.my.payments.history': {
		en: 'My Payments History',
		ar: 'سجل الدفع',
	},
	'path.my.payments.receipts': {
		en: 'Receipts',
		ar: 'سجل الدفع', // need to change
	},
	'path.billing.payment.track': {
		en: 'Offline Payment - Bank Transfer',
		ar: 'تفاصيل السداد - التحويل البنكي',
	},
	'path.my.wallet': {
		en: 'My Wallet',
		ar: 'محفظتي',
	},
	'path.PH': {
		en: 'PH',
		ar: '[AR] PH',
	},
	'path.N': {
		en: 'N',
		ar: '[AR] N',
	},
	'path.U': {
		en: 'U',
		ar: '[AR] U',
	},
	'path.bills': {
		en: 'Bills',
		ar: 'الفواتير',
	},
	'path.my.bills': {
		en: 'My Bills',
		ar: 'فواتيري',
	},
	'path.my.payment.request': {
		en: 'Payment Request Status',
		ar: 'حالة طلبات الدفع',
	},
	'path.dashboard': {
		en: 'Dashboard',
		ar: 'الصفحة الرئيسية',
	},
	'path.number.details': {
		en: 'Number Details',
		ar: 'تفاصيل الرقم',
	},
	'path.voice.usage.details': {
		en: 'Voice Usage Details',
		ar: 'تفاصيل استخدام المكالمات',
	},
	'path.data.usage.details': {
		en: 'Data Usage Details',
		ar: 'تفاصيل استخدام البيانات',
	},
	'path.sms.usage.details': {
		en: 'SMS Usage Details',
		ar: 'بيانات استخدام الرسائل النصية القصيرة',
	},
	'path.usage': {
		en: 'Usage',
		ar: 'الإستهلاك',
	},
	'path.sim.management': {
		en: 'SIM Management',
		ar: 'إدارة شريحة الهاتف',
	},
	'path.active.commitments': {
		en: 'Active Commitments',
		ar: 'الالتزامات الجارية',
	},
	'path.settings': {
		en: 'Settings',
		ar: 'إعدادات',
	},
	'path.aamali.services': {
		en: "A'amali+ Services",
		ar: 'خدمات أعمالي+',
	},
	'path.AS': {
		en: 'AS',
		ar: '[AR] AS',
	},
	'path.B': {
		en: 'B',
		ar: '[AR] B',
	},
	'path.error.page': {
		en: 'Error Page',
		ar: 'حدث خطأ في الصفحة',
	},
	'path.organization.details': {
		en: 'Organization Details',
		ar: 'تفاصيل المؤسسة',
	},
	'path.departments': {
		en: 'Departments',
		ar: 'الأقسام',
	},
	'path.by.sector': {
		en: 'By Sector',
		ar: 'وفقا للقطاع',
	},
	'path.list.of.activities': {
		en: 'History of requests',
		ar: 'قائمة الخدمات المفعلة',
	},
	'path.purchase.bulk.devices': {
		en: 'Purchase Devices',
		ar: 'شراء الأجهزة الذكية',
	},
	'path.history.of.complaints': {
		en: 'History of complaints',
		ar: 'تاريخ الشكاوى',
	},
	'path.users.service.requests': {
		en: 'Users Service Requests',
		ar: 'طلبات خدمة المستخدمين',
	},
	'table.service.name': {
		en: 'Service Name / Account No. / Mobile No.',
		ar: 'اسم الخدمة/ رقم الحساب/ رقم الهاتف',
	},
	'table.organization.name': {
		en: 'Organization Name',
		ar: 'اسم المؤسسة',
	},
	'table.no.accounts': {
		en: 'No. of Account',
		ar: 'عدد الحسابات',
	},
	'table.payment.deadline': {
		en: 'Payment Deadline',
		ar: 'آخر تاريخ للدفع',
	},
	'table.billed.for.last.month': {
		en: 'Billed for last month',
		ar: 'تم إصدار فاتورة الشهر السابق',
	},
	'table.phone.number': {
		en: 'Mobile Number',
		ar: 'رقم الهاتف المحمول',
	},
	'table.department': {
		en: 'Department',
		ar: 'القسم',
	},
	'table.user.name': {
		en: 'User Name',
		ar: 'اسم المستخدم',
	},
	'table.service.type': {
		en: 'Service Type',
		ar: 'نوع الخدمة',
	},
	'table.tariff.plan': {
		en: 'Tariff Plan',
		ar: 'خطة التعرفة',
	},
	'table.credit.limit': {
		en: 'Credit Limit',
		ar: 'حدود الإستخدام',
	},
	'table.date': {
		en: 'Date',
		ar: 'التاريخ',
	},
	'table.user.performedBy': {
		en: 'Performed by',
		ar: 'تم بواسطة',
	},
	'table.activity': {
		en: 'Requests details',
		ar: 'تفاصيل الخدمات المفعلة',
	},
	'table.accountId': {
		en: 'Account ID',
		ar: 'رقم الحساب',
	},
	'table.businessId': {
		en: 'Numbers',
		ar: 'ارقام الهواتف',
	},
	'numbers.allOrganizations': {
		en: 'All Organizations',
		ar: 'جميع المؤسسات',
	},
	'numbers.accounts': {
		en: 'Accounts',
		ar: 'الحسابات',
	},
	'numbers.serviceType': {
		en: 'Service Type',
		ar: 'نوع الخدمة',
	},
	'user.type': {
		en: 'User Type',
		ar: 'نوع المستخدم',
	},
	'numbers.user.ADMIN': {
		en: 'Admin',
		ar: 'المشرف',
	},
	'numbers.user.MANAGER': {
		en: 'Manager',
		ar: 'المدير',
	},
	'numbers.user.ENDUSER': {
		en: 'End-user',
		ar: 'المستخدم',
	},
	'numbers.user.SUPERADMIN': {
		en: 'Superadmin',
		ar: 'المشرف الفائق', // need to change
	},
	'numbers.user.NONE': {
		en: 'Not Assigned',
		ar: 'لم يتم التعيين',
	},
	'numbers.department': {
		en: 'Department',
		ar: 'القسم',
	},
	'numbers.all': {
		en: 'All',
		ar: 'الكل',
	},
	'numbers.mobile-postpaid': {
		en: 'Mobile - Postpaid',
		ar: 'رقم آجل الدفع',
	},
	'numbers.mixed': {
		en: 'Aamali',
		ar: 'أعمالي',
	},
	'numbers.internet-postpaid': {
		en: 'FBB',
		ar: 'الانترنت الثابت',
	},
	'numbers.wfbb': {
		en: 'WFBB',
		ar: 'WFBB',
	},
	'numbers.fix-postpaid': {
		en: 'Fixed Line',
		ar: 'خط ثابت',
	},
	'numbers.mobile-prepaid': {
		en: 'Mobile - Prepaid',
		ar: 'رقم مسبق الدفع',
	},
	'numbers.aamali-plus-fbb': {
		en: "A'amali+ FBB",
		ar: 'أعمالي+ الانترنت فائق السرعة ',
	},
	'numbers.fixed-line': {
		en: 'Fixed Line',
		ar: 'خط ثابت',
	},
	numbersList: {
		en: 'Numbers List',
		ar: 'قائمة الأرقام',
	},
	'numbers.internet': {
		en: 'Internet',
		ar: 'إنترنت',
	},
	'numbers.fbb': {
		en: 'FBB',
		ar: 'الانترنت الثابت',
	},
	'numbers.details.notAssigned': {
		en: 'Not Assigned',
		ar: 'لم يتم التعيين',
	},
	'numbers.details.assign.user': {
		en: 'Assign user to number',
		ar: 'تخصيص مستخدم للرقم',
	},
	'numbers.details.credit': {
		en: 'Min %%, max %% OMR',
		ar: 'الأدنى %%, الأعلى %% ريال',
	},
	'numbers.details.minimumCredit': {
		en: 'Min %% OMR',
		ar: 'الحد الأدنى %% ر.ع',
	},
	'number.details.user.name': {
		en: 'User Name',
		ar: 'اسم المستخدم',
	},
	'number.details.detach.user': {
		en: 'Detach User',
		ar: 'فصل الرقم عن المستخدم',
	},
	'number.details.detach.user.confirmation.title': {
		en: 'Detach the user?',
		ar: 'افصل المستخدم؟',
	},
	'number.details.detach.user.confirmation.description': {
		en: 'Are you sure you want to detach user from this number?',
		ar: 'هل  تريد فصل المستخدم عن هذا الرقم؟',
	},
	'no.results': {
		en: 'No Results.',
		ar: 'لا توجد نتائج',
	},
	'numberDetails.usage.internetType': {
		en: 'Internet Connection',
		ar: 'اتصال إنترنت',
	},
	'numbers.usage.data': {
		en: 'Data',
		ar: 'التاريخ',
	},
	'numbers.usage.noCalls': {
		en: 'There is no call details for this number yet',
		ar: 'لا توجد تفاصيل المكالمات لهذا الرقم',
	},
	'numbers.usage.connectionType.DATA': {
		en: 'Data',
		ar: 'التاريخ',
	},
	'numbers.usage.connectionType.SMS': {
		en: 'SMS',
		ar: 'الرسائل القصيرة',
	},
	'numbers.usage.connectionType.VOICELOCAL': {
		en: 'Voice Local',
		ar: 'مكالمات محلية',
	},
	'numbers.usage.connectionType.VOICEINTERNATIONAL': {
		en: 'Voice International',
		ar: 'مكالمات دولية',
	},
	'numbers.usage.connectionType.CPN': {
		en: 'CPN',
		ar: 'CPN',
	},
	'numbers.usage.dataNoPackage': {
		en: 'No Data available',
		ar: 'لا توجد بيانات',
	},
	'numbers.usage.dataUnlimited': {
		en: 'Unlimited Data',
		ar: 'بيانات غبر محدودة',
	},
	'numbers.usage.dataBreakdown': {
		en: 'Data usage breakdown',
		ar: 'ملخص استخدام البيانات',
	},
	'numbers.usage.voice': {
		en: 'Voice',
		ar: 'المكالمات',
	},
	'numbers.usage.voiceNoPackage': {
		en: 'No minutes available',
		ar: 'لا توجد دقائق إتصالات',
	},
	'numbers.usage.voiceUnlimited': {
		en: 'Unlimited Minutes',
		ar: 'دقائق لامحدودة',
	},
	'numbers.usage.sms': {
		en: 'SMS',
		ar: 'رسائل نصية لامحدودة',
	},
	'numbers.usage.smsNoPackage': {
		en: 'No SMS available',
		ar: 'الرسائل النصية غير متوفرة',
	},
	'numbers.usage.smsUnlimited': {
		en: 'Unlimited SMS',
		ar: 'رسائل نصية قصيرة غير محدودة',
	},
	'numbers.usage.showDetails': {
		en: 'Show Details',
		ar: 'عرض التفاصيل',
	},
	'numbers.usage.unlimited': {
		en: 'Unlimited',
		ar: 'لامحدود',
	},
	'numbers.usage.connectionList': {
		en: 'Call Details',
		ar: 'تفاصيل المكالمات',
	},
	'numbers.usage.lastDays': {
		en: 'for last %% days',
		ar: 'آخر %% أيام ',
	},
	'numbers.usage.lastUpdate': {
		en: 'Last update: %%',
		ar: 'تم تحديثه : %%',
	},
	'dashboard.last.days': {
		en: 'Last %% months',
		ar: 'آخر %% شهر / أشهر',
	},
	'numbers.usage.periodAccordion': {
		en: 'Period',
		ar: 'المدة',
	},
	'numbers.usage.all': {
		en: 'All',
		ar: 'الكل',
	},
	'numbers.usage.included': {
		en: 'Included in subscription',
		ar: 'ضمن الإشتراك',
	},
	'numbers.usage.extra': {
		en: 'Paid extra',
		ar: 'استهلاك إضافي',
	},
	'numbers.usage.currentPeriod': {
		en: 'Current Bill Period',
		ar: 'فترة الفاتورة الحالية',
	},
	'numbers.usage.customPeriod': {
		en: 'Custom Date Range',
		ar: 'مدة استخدام محددة',
	},
	'numbers.usage.billPeriod': {
		en: 'Bill Period',
		ar: 'فترة الفاتورة',
	},
	'numbers.usage.costsAccordion': {
		en: 'Costs',
		ar: 'التكلفة',
	},
	'numbers.usage.typeAccordion': {
		en: 'Type',
		ar: 'النوع',
	},
	'numbers.usage.onlyData': {
		en: 'Only Data',
		ar: 'بيانات فقط',
	},
	'numbers.usage.onlySMS': {
		en: 'Only SMS',
		ar: 'رسائل نصية فقط',
	},
	'numbers.usage.onlyVoice': {
		en: 'Only Voice',
		ar: 'مكالمات فقط',
	},
	'numbers.usage.totalTransfer': {
		en: 'Total transfer',
		ar: 'إجمالي التحويلات',
	},
	'numbers.usage.topUp': {
		en: 'Top Up',
		ar: 'إعادة التعبئة',
	},
	'numbers.usage.mainBalanceValue': {
		en: 'Current balance',
		ar: 'الرصيد الحالي',
	},
	'numbers.usage.bonusBalanceValue': {
		en: 'Bonus balance',
		ar: 'الرصيد الإضافي',
	},
	'numbers.usage.dataDelays': {
		en: 'Due to data delays, the list may not be complete',
		ar: 'بسبب تأخر البيانات، قد لا تكون القائمة مكتملة',
	},
	'numbers.usage.voiceLeft': {
		en: 'Minutes left',
		ar: 'الدقائق المتبقية',
	},
	'numbers.usage.dataLeft': {
		en: 'Data left',
		ar: 'البيانات المتبقية',
	},
	'numbers.usage.smsLeft': {
		en: 'SMS left',
		ar: 'الرسائل النصية القصيرة المتبقية',
	},
	'numbers.usage.bundleLeft': {
		en: '%% LEFT',
		ar: '%% متبقية',
	},
	'numbers.usage.special': {
		en: 'Add-ons',
		ar: 'الخدمات الإضافية',
	},
	'numbers.usage.roaming': {
		en: 'Roaming',
		ar: 'التجوال',
	},
	'numbers.usage.international': {
		en: 'International',
		ar: 'دولي',
	},
	'numbers.usage.noBundle': {
		en: 'No active bundle',
		ar: 'لا توجد باقة مفعلة',
	},
	'numbers.usage.currentUsage': {
		en: 'Current usage',
		ar: 'الاستخدام الحالي',
	},
	'numbers.usage.details.data.header': {
		en: 'Data general usage',
		ar: 'الاستخدام العام للبيانات',
	},
	'numbers.usage.details.voice.header': {
		en: 'Voice general usage',
		ar: 'الاستخدام العام للمكالمات ',
	},
	'numbers.usage.details.sms.header': {
		en: 'SMS general usage',
		ar: 'الاستخدام العام',
	},
	'usage.unit.MB': {
		en: 'MB',
		ar: 'ميجابايت',
	},
	'usage.unit.GB': {
		en: 'GB',
		ar: 'جيجابايت',
	},
	'usage.unit.Minutes': {
		en: 'MIN',
		ar: 'دقائق',
	},
	'usage.unit.SMS': {
		en: 'SMS',
		ar: 'رسائل',
	},
	'numbers.details.numberInformation': {
		en: 'Number information',
		ar: 'تفاصيل الرقم',
	},
	'numbers.details.numberRelated': {
		en: 'Number is related to private profile',
		ar: 'الرقم مرتبط بالملف الشخصي الخاص',
	},
	'numbers.details.numberRelated.delete': {
		en: 'Delete',
		ar: 'حذف',
	},
	'numbers.details.numberRelated.dialog.header': {
		en: 'Delete connection?',
		ar: 'حذف الاتصال',
	},
	'numbers.details.numberRelated.dialog.description': {
		en: 'Do you want to delete the connection to private number?',
		ar: 'هل تريد حذف الاتصال برقم خاص?',
	},
	'numbers.details.numberRelated.dialog.close': {
		en: 'Close',
		ar: 'يغلق',
	},
	'numbers.details.numberRelated.dialog.succesMessage': {
		en: 'The connection was successfully deleted',
		ar: 'تم حذف الاتصال بنجاح',
	},
	'numbers.details.billingAccount': {
		en: 'Billing account',
		ar: 'حساب الفوترة',
	},
	'numbers.details.tariff': {
		en: 'Tariff plan',
		ar: 'خطة التعرفة',
	},
	'numbers.details.new.tariff': {
		en: 'NEW Tariff plan',
		ar: 'التعرفة الجديدة',
	},
	'numbers.details.new.tariff.will.end': {
		en: 'Your free trial will end on: %%',
		ar: 'ستنتهي الفترة التجريبية المجانية في: %%',
	},
	'numbers.details.base.tariff.will.end': {
		en: 'Your plan expires on: ',
		ar: 'ستنتهي الفترة التجريبية المجانية في:', // nee dto change
	},
	'numbers.details.boost.plan.number.of.months': {
		en: 'Try no-commitment upgrade for %% months',
		ar: 'جرب الترقية لمدة %% بدون عقد التزام ',
	},
	'numbers.details.boost.plan.one.month': {
		en: 'Try no-commitment upgrade for 1 month for free',
		ar: 'جرب الترقية بدون عقد لمدة شهر واحد',
	},
	'numbers.details.boost.your.plan': {
		en: 'Boost your plan to',
		ar: 'قم بترقية باقتك إلى',
	},
	'numbers.details.boost.your.plan.button': {
		en: 'Try for free',
		ar: 'جرب مجانًا',
	},
	'numbers.details.change-plan': {
		en: 'Change Plan',
		ar: 'خطة التغيير',
	},
	'numbers.details.upgrade-plan': {
		en: 'Upgrade Plan',
		ar: 'خطة الترقيه',
	},
	'numbers.details.change-plan.dialog-changed.successed': {
		en: 'Change plan request was submitted successfully and will be implemented once the order is completed.',
		ar: 'تم إرسال طلب تغيير الخطة بنجاح وسيتم تنفيذه بمجرد اكتمال الطلب',
	},
	'numbers.details.change-plan.pending': {
		en: 'Change plan - request under process.',
		ar: 'تغيير الخطة - الطلب قيد المتابعة.',
	},
	'numbers.details.userInformation': {
		en: 'User information',
		ar: 'تفاصيل المستخدم',
	},
	'numbers.details.perMonth': {
		en: '/ month',
		ar: 'الشهر',
	},
	'numbers.details.nationalMinutes': {
		en: 'National minutes',
		ar: 'الدقائق المحلية',
	},
	'numbers.details.nationalData': {
		en: 'National data',
		ar: 'البيانات المحلية',
	},
	'numbers.details.nationalSMS': {
		en: 'National SMS',
		ar: 'الرسائل المحلية',
	},
	'numbers.details.nationalMMS': {
		en: 'National MMS',
		ar: 'رسائل الوسائط المحلية',
	},
	'numbers.details.assign': {
		en: 'Assign',
		ar: 'تعيين',
	},
	'numbers.settings.sim.details': {
		en: 'SIM/ESIM Details',
		ar: 'فاصيل SIM / ESIM',
	},
	'numbers.sim.replacement': {
		en: 'SIM card replacement',
		ar: 'استبدال شريحة الهاتف',
	},
	'numbers.settings.pin1': {
		en: 'Pin 1',
		ar: 'الرقم السري 1',
	},
	'numbers.settings.new.sim.number': {
		en: 'New SIM Serial Number',
		ar: 'رقم شريحة متسلسل جديد',
	},
	replace: {
		en: 'Replace',
		ar: 'استبدال',
	},
	'replace.sim': {
		en: 'Replace SIM',
		ar: 'SIM يستبدل',
	},
	'replace.esim': {
		en: 'Replace ESIM',
		ar: 'ESIM يستبدل',
	},
	cancel: {
		en: 'Cancel',
		ar: 'إلغاء',
	},
	discard: {
		en: 'Discard',
		ar: 'تجاهل',
	},
	questionMark: {
		en: '?',
		ar: '؟',
	},
	'numbers.settings.pin2': {
		en: 'Pin 2',
		ar: 'Pin 2',
	},
	'numbers.settings.puk1': {
		en: 'Puk 1',
		ar: 'Puk 1',
	},
	'numbers.settings.puk2': {
		en: 'Puk 2',
		ar: 'Puk 2',
	},
	'numbers.settings.sim': {
		en: 'SIM',
		ar: 'SIM',
	},
	'numbers.settings.sim.temporary.disconnection': {
		en: 'SIM card temporary disconnection',
		ar: 'تم إيقاف الشريحة مؤقتاً',
	},
	'numbers.settings.replace.sim.card': {
		en: 'Replace to SIM Card',
		ar: 'اسبدال الشريحة',
	},
	'numbers.settings.replace.sim.card.invalid': {
		en: 'Serial number entered seems to be invalid/used',
		ar: 'يبدو أن الرقم التسلسلي الذي تم إدخاله غير صالح / مستخدم',
	},
	'numbers.settings.replace.sim.card.invalid.COULD_NOT_SEND_ORDER_TO_BUS': {
		en:
			'We are currently experiencing technical difficulties and are unable to proceed with your request. Please try again later.',
		ar: 'نواجه حاليًا صعوبات تقنية ولا يمكننا متابعة طلبك. يرجى المحاولة مرة أخرى لاحقًا.',
	},
	'numbers.settings.replace.sim.card.invalid.ERROR_SUBMITTING_PRODUCT_ORDER_TO_ESB': {
		en:
			'We would like to inform you that your order is still pending in the queue. Please wait until the previous order is completed before proceeding or reach out to customer care 1235',
		ar:
			'نود أن نعلمكم أن طلبكم لا يزال معلقًا في قائمة الانتظار. يرجى الانتظار حتى يتم الانتهاء من الطلب السابق قبل المتابعة أو التواصل مع خدمة العملاء على الرقم 1235',
	},
	'numbers.settings.replace.sim.card.validation.message': {
		en: 'Checking serial number...',
		ar: 'التحقق من الرقم التسلسلي...',
	},
	'numbers.settings.check.sim.details': {
		en: 'SIM/ESIM details',
		ar: 'تفاصيل SIM / ESIM',
	},
	'numbers.settings.are.you.sure': {
		en: 'Are you sure your card number is',
		ar: 'هل أنت متأكد من أن رقم البطاقة هو ',
	},
	'numbers.settings.replace.esim.card': {
		en: 'Replace to ESIM Card',
		ar: 'استبدل بطاقة ESIM',
	},
	'numbers.settings.replace.esim.card.unavailable': {
		en: 'ESIM replacement is temporarily unavailable. Only one Sim replacement is allowed per day.',
		ar: 'غير متاح موقتاE-Sim استبدل شريحة. يُسمح باستبدال شريحة واحدة فقط في اليوم.',
	},
	'numbers.settings.esim.qr': {
		en: 'ESIM QR code',
		ar: 'رمز الاستجابة السريعة ESIM',
	},
	'numbers.settings.esim.qr.download.pdf': {
		en: 'Download QR as PDF',
		ar: 'تنزيل QR كملف PDF',
	},
	'numbers.settings.data.sim.details': {
		en: 'Data SIM',
		ar: 'شريحة بيانات',
	},
	'numbers.settings.sawa.sim.details': {
		en: 'Sawa SIM',
		ar: 'شريحة سوى',
	},
	'numbers.settings.sim.details.add.new': {
		en: 'Add new sim card',
		ar: 'إضافة شريحة جديدة',
	},
	'numbers.settings.sim.details.add.new.error.exists': {
		en: 'Serial number entered seems to be invalid/used',
		ar: 'يبدو أن الرقم التسلسلي الذي تم إدخاله غير صالح / مستخدم',
	},
	'numbers.settings.sim.details.add.new.error': {
		en: 'Error while adding new sim card',
		ar: 'خطأ أثناء إضافة شريحة جديدة',
	},
	'numbers.settings.sim.details.delete.error': {
		en: 'Error while deleting sim card',
		ar: 'خطأ أثناء حذف الشريحة',
	},
	'numbers.settings.data.sim.add.success': {
		en: 'Data Sim added sucessfully',
		ar: 'تمت إضافة شريحة البيانات بنجاح',
	},
	'numbers.settings.sawa.sim.add.success': {
		en: 'Sawa Sim added sucessfully',
		ar: 'تمت إضافةشريحة سوى بنجاح',
	},
	'numbers.settings.data.sim.delete.success': {
		en: 'Data Sim deleted sucessfully',
		ar: 'تم حذف شريحة البيانات بنجاح',
	},
	'numbers.settings.sawa.sim.delete.success': {
		en: 'Sawa Sim deleted sucessfully',
		ar: 'تم حذف شريحة سوى بنجاح',
	},
	'numbers.settings.sawa.sim.delete.dialog.header': {
		en: 'Delete Sawa Sim',
		ar: 'حذف شريحة سوى',
	},
	'numbers.settings.data.sim.delete.dialog.header': {
		en: 'Delete Data Sim',
		ar: 'حذف شريحة البيانات',
	},
	'numbers.settings.sawa.sim.delete.dialog.body': {
		en: 'Do you want delete Sawa Sim?',
		ar: 'هل تود حذف حذف شريحة سوى؟',
	},
	'numbers.settings.data.sim.delete.dialog.body': {
		en: 'Do you want delete Data Sim?',
		ar: 'هل تود حذف حذف شريحة البيانات؟',
	},
	'numbers.esim.replacement': {
		en: 'ESIM card replacement',
		ar: 'استبدال بطاقة ESIM',
	},
	'numbers.esim.replacement.success': {
		en: 'Your ESIM replacement is successful. You can find QR Code details below.',
		ar: 'بنجاح  E Sim تم استبدال شريحة ال. يمكنك العثور على تفاصيل رمز الاستجابة السريعة أدناه.',
	},
	'numbers.esim.replacement.error': {
		en: 'Error while replacing ESIM card',
		ar: 'خطأ أثناء استبدال بطاقة ESIM',
	},
	'numbers.esim.replacement.supported.devices': {
		en: 'To see list of supported devices, click here',
		ar: 'لمشاهدة قائمة الأجهزة المدعومة ، انقر هنا',
	},
	'numbers.esim.replacement.supported.devices.accept': {
		en: 'Accept if your phone support ESIM cards',
		ar: 'اقبل إذا كان هاتفك يدعم بطاقات ESIM',
	},
	'numbers.esim.email.title': {
		en: 'Esim QR Code',
		ar: 'ESIM رمز الاستجابة السريعة',
	},
	'numbers.settings.replace.esim.are.you.sure1': {
		en: 'Are you sure you want to replace your current card with E-Sim?',
		ar: 'هل أنت متأكد أنك تريد استبدال بطاقتك الحالية بـ E-Sim؟',
	},
	'numbers.settings.replace.esim.are.you.sure2': {
		en: 'The number already has an E-Sim, please confirm if you want to continue.',
		ar: 'الرقم يحتوي بالفعل على E-Sim ، يرجى التأكيد إذا كنت تريد المتابعة.',
	},
	'numbers.settings.replace.esim.are.you.sure.note': {
		en: 'Note: Service will be interrupted until E-SIM is Installed in the End User device.',
		ar: 'ملاحظة: سيتم قطع الخدمة حتى يتم تفعيل في جهاز المستخدم النهائي E-sim',
	},
	'numbers.settings.replace.esim.card.message': {
		en: 'Checking data...',
		ar: 'جاري التحقق من البيانات …',
	},
	'numbers.settings.replace.esim.card.qr.code.title': {
		en: 'Your ESIM QR code for number %%',
		ar: 'رمز الاستجابة السريعة ESIM للرقم ٪٪',
	},
	'numbers.settings.esim.card.instruction.title': {
		en: 'How to activate ESIM?',
		ar: 'كيف يتم تفعيل ESIM؟',
	},
	'numbers.settings.esim.card.instruction.subtitle': {
		en: 'Turn on camera, next scan QR code',
		ar: 'قم بتشغيل الكاميرا ، ثم امسح رمز الاستجابة السريعة ضوئيًا',
	},
	'numbers.settings.esim.card.instruction.email': {
		en: 'Enter email address',
		ar: 'أدخل عنوان البريد الالكتروني',
	},
	'numbers.services.voice.sms': {
		en: 'Voice and SMS',
		ar: 'المكالمات والرسائل',
	},
	'numbers.services.data': {
		en: 'Data',
		ar: 'البيانات',
	},
	'numbers.services.roaming': {
		en: 'Roaming',
		ar: 'التجوال',
	},
	'numbers.services.roaming.subtitle': {
		en: 'Are you going abroad? User our roaming services',
		ar: 'هل تسافر خارج السلطنة؟ استخدم خدماتنا للتجوال',
	},
	'badge.active': {
		en: 'Active',
		ar: 'مفعل',
	},
	'badge.inactive': {
		en: 'Inactive',
		ar: 'غير مفعل',
	},
	'badge.pending': {
		en: 'Pending...',
		ar: 'الطلب قيد المعالجة...',
	},
	'badge.PENDING_TERMINATION': {
		en: 'Pending Termination',
		ar: 'في انتظار الإنهاء',
	},
	'badge.PENDING_ACTIVATION': {
		en: 'Pending Activation',
		ar: 'في انتظار التفعيل',
	},
	'badge.awaiting': {
		en: 'Awaiting',
		ar: 'في الانتظار',
	},
	'status.order.placed.on': {
		en: 'Order placed on ',
		ar: 'تم تقديم الطلب في ',
	},
	'numbers.services.turn.off': {
		en: 'Turn OFF',
		ar: 'إيقاف',
	},
	'numbers.services.turn.on': {
		en: 'Turn ON',
		ar: 'تفعيل',
	},
	'numbers.services.refresh': {
		en: 'Refresh',
		ar: 'تحديث',
	},
	'numbers.services.activate': {
		en: 'Activate',
		ar: 'تفعيل',
	},
	'numbers.services.activated': {
		en: 'Activated',
		ar: 'مفعل',
	},
	'error.page.text': {
		en: "Sorry, this page doesn't exist :(",
		ar: 'عذرا، لا توجد هذه الصفحة',
	},
	'organizations.account.name': {
		en: 'Organization name',
		ar: 'اسم المؤسسة',
	},
	departments: {
		en: 'Departments',
		ar: 'القسم',
	},
	'accounts.no.departments': {
		en: "You don't have any yet",
		ar: 'لا توجد لديك أي خدمة حتى الآن',
	},
	'add.image': {
		en: 'Add image',
		ar: 'إضافة صورة',
	},
	'edit.image': {
		en: 'Edit image',
		ar: 'تعديل الصورة',
	},
	'organization.name': {
		en: 'Organization Name',
		ar: 'اسم المؤسسة',
	},
	edit: {
		en: 'Edit',
		ar: 'تعديل',
	},
	'account.details.contact.information': {
		en: 'Contact Information',
		ar: 'تفاصيل التواصل',
	},
	'account.details.account.managers': {
		en: 'Omantel Account Managers',
		ar: 'مدراء حسابات عمانتل',
	},
	'account.details.account.manager.email': {
		en: 'Email: %%',
		ar: 'البريد الإلكتروني: %%',
	},
	'account.details.account.manager.phone': {
		en: 'Mobile Number: %%',
		ar: 'رقم الهاتف المحمول: %%',
	},
	'account.details.bill.address': {
		en: 'Bill Address',
		ar: 'عنوان الفواتير ',
	},
	'organization.details.organization.address': {
		en: 'Organization Address',
		ar: 'عنوان المؤسسة',
	},
	'organization.details.organization.admins': {
		en: 'Organization Admins',
		ar: 'أسماء المشرفين',
	},
	'organization.details.organization.managers': {
		en: 'Organization Managers',
		ar: 'المديرون بالمؤسسة',
	},
	'organization.details.provide.address': {
		en: 'Please provide missing address information',
		ar: ' يرجى تقديم معلومات العنوان المفقودة',
	},
	'organization.details.more.details': {
		en: 'More details',
		ar: 'للمزيد من المعلومات',
	},
	'organization.details.organization.tax.id': {
		en: 'Organization TAX ID',
		ar: 'رقم التسجيل الضريبي للشركة',
	},
	'organization.details.tax.id': {
		en: 'TAX ID',
		ar: 'رقم التسجيل الضريبي',
	},
	'organization.details.tax.id.certificate': {
		en: 'TAX ID Certificate',
		ar: 'شهادة التسجيل الضريبي',
	},
	'organization.details.empty.tax.id': {
		en: "You don't have a TAX ID added yet",
		ar: 'لم يتم إضافة رقم التسجيل الضريبي',
	},
	'organization.details.tax.id.description': {
		en:
			'Customer is responsible for the information provided. Omantel is not responsible for any wrong information given by the customer.',
		ar: 'العميل مسؤول عن المعلومات المقدمة. عمانتل لن تكون مسؤولة عن أي معلومات خاطئة قدمها العميل.',
	},
	'organization.details.tax.upload.add': {
		en: 'Add TAX ID',
		ar: 'اضافة رقم التسجيل الضريبي',
	},
	'organization.details.tax.upload.edit': {
		en: 'Edit TAX ID',
		ar: 'تعديل رقم التسجيل الضريبي',
	},
	'organization.details.tax.upload.success.added': {
		en: 'Added:',
		ar: 'مضاف',
	},
	'organization.details.tax.upload.success.edited': {
		en: 'Edited:',
		ar: 'تم تحريره',
	},
	'organization.details.tax.upload.success.organization': {
		en: 'Organisation tax ID will be updated within 24 hours',
		ar: 'سيتم تحديث المعرّف الضريبي للمؤسسة في غضون 24 ساعة',
	},
	'organization.details.tax.upload.certificate': {
		en: 'Upload TAX ID Certificate',
		ar: 'تحميل شهادة التسجيل الضريبي',
	},
	'organization.details.tax.upload.file.types': {
		en: 'Accepted file formats: PDF, PNG, JPG',
		ar: 'صيغ الملفات المقبولة: ( PDF, PNG , JPG )',
	},
	'organization.details.tax.upload.id.error': {
		en: 'Tax Id is required',
		ar: 'رقم التسجيل الضريبي مطلوب',
	},
	'organization.details.tax.upload.file.error': {
		en: 'This file is required',
		ar: 'هذا الملف مطلوب',
	},
	numbers: {
		en: 'Numbers',
		ar: 'الأرقام',
	},
	users: {
		en: 'Users',
		ar: 'المستخدمين',
	},
	managers: {
		en: 'Managers',
		ar: 'المدراء',
	},
	manager: {
		en: 'Manager',
		ar: '[المدير',
	},
	create: {
		en: 'Create',
		ar: 'إنشاء',
	},
	assign: {
		en: 'Assign',
		ar: 'تخصيص',
	},
	error: {
		en: 'Error',
		ar: 'خطأ',
	},
	'user.name': {
		en: 'User Name',
		ar: 'اسم المستخدم',
	},
	'departments.no.managers': {
		en: 'No managers assigned',
		ar: 'لم يتم تخصيص مدراء',
	},
	'departments.add.department': {
		en: 'Add department',
		ar: 'إضافة قسم',
	},
	'departments.add.first.department': {
		en: 'Add first department',
		ar: 'إضافة أول دائرة',
	},
	'departments.new.department': {
		en: 'New department',
		ar: 'دائرة جديدة',
	},
	'departments.edit.department': {
		en: 'Edit department',
		ar: 'تعديل الدائرة',
	},
	'departments.department.name': {
		en: 'Department Name',
		ar: 'اسم الدائرة',
	},
	'departments.department.color': {
		en: 'Department Color (optional)',
		ar: 'لون الدائرة (اختياري)',
	},
	'departments.choose.managers.optional': {
		en: 'Choose department managers (optional).',
		ar: 'اختيار مديرين للدائرة (اختياري)',
	},
	'departments.choose.managers': {
		en: 'Choose Department Managers.',
		ar: 'اختيار مديرين الدائرة ',
	},
	'departments.only.managers': {
		en: 'Only Manager user type.',
		ar: 'فقط نوع المستخدم للمدير',
	},
	'departments.dont.have.departments': {
		en: 'You don’t have any departments yet.',
		ar: 'ا توجد لديكم أي دائرة حتى الآن. ',
	},
	'departments.only.admins.can.create': {
		en: 'Only Admins can create one.',
		ar: 'يمكن إضافة مشرف واحد فقط.',
	},
	'departments.make.work.easier': {
		en: 'Make your work easier!',
		ar: 'تسهل أعمالك!',
	},
	'departments.create.departments': {
		en: 'Create departments, assign numbers and users.',
		ar: 'إنشاء دوائر، تخصيص أرقام ومستخدمين',
	},
	'departments.do.you.want.delete': {
		en: 'Do you want to delete this department?',
		ar: 'هل ترغب في حذف هذه الدائرة؟',
	},
	'departments.number.users.will.not.be.assigned': {
		en: 'All numbers/users from this department will be not assigned to any department.',
		ar: 'لن يتم تخصيص جميع الأرقام/ السمتخدمين من هذه الدائرة إلى أي دائرة أخرى',
	},
	'departments.numbers.users.can.be.assigned': {
		en: 'Numbers/users can be assigned to one department only.',
		ar: 'يمكن تخصيص الأرقام / المستخدمين إلى دائرة واحدة فقط',
	},
	'departments.do.you.want.to.change': {
		en: 'Do you want to change the department for selected numbers/users?',
		ar: 'هل ترغب في تغيير الدائرة للأرقام/ المستخدمين المختارين؟',
	},
	'departments.do.you.want.to.add.them': {
		en: 'Some of the users you have been selected have more numbers. Do you want to add them too?',
		ar: 'بعض المستخدمين الذين قمت باختيارهم لديهم أرقام اكثر، هل ترغب في إضافتهم أيضا؟',
	},
	'departments.if.you.will.add': {
		en: 'If you will not add them they will be no longer assigned to the user.',
		ar: 'إذا لم تقم بإضافتم فإنه لن يتم تخصيصهم إلى المستخدم',
	},
	'departments.number.users.will.not.be.removed': {
		en: 'Numbers and users will not be removed.',
		ar: 'لن يتم حذف الأرقام والمستخدمين',
	},
	'departments.number.users': {
		en: 'Numbers and users',
		ar: 'الأرقام والمستخدمين',
	},
	'departments.only.not.assigned': {
		en: 'Only not assigned to department',
		ar: 'لم يتم التعيين إلى أي دائرة',
	},
	marketing: {
		en: 'Marketing',
		ar: 'التسويق',
	},
	hr: {
		en: 'HR',
		ar: 'الموارد البشرية',
	},
	finance: {
		en: 'Finance',
		ar: 'المالية',
	},
	'departments.no.manager.user.type': {
		en: 'You don’t have manager user type yet',
		ar: 'ليس لديك نوع مدير مستخدم حتى الآن',
	},
	'departments.assign.manager': {
		en: 'You can create manager user type and assign him to the department in “User” section.',
		ar: 'يمكنك إنشاء نوع مستخدم مدير وتخصيصه للدائرة في قسم "المستخدم"',
	},
	'users.permissions.billing.account': {
		en: 'Billing Accounts',
		ar: 'حساب الفوترة',
	},
	'users.permissions.billing.account.add.title': {
		en: 'Add Billing Accounts permissions',
		ar: 'إضافة أذونات حسابات الفواتير',
	},
	'users.permissions.billing.account.added': {
		en: 'Billing Accounts permissions addedd',
		ar: 'تمت إضافة أذونات حسابات الفواتير',
	},
	'users.permissions.billing.account.detached': {
		en: 'Billing Accounts permissions detached',
		ar: 'تم فصل أذونات حسابات الفواتير',
	},
	'users.permissions.billing.account.no.permissions': {
		en: "This user doesn't have any Billing Accounts Permissions",
		ar: 'لا يمتلك هذا المستخدم أي أذونات لحسابات الفوترة',
	},
	'users.permissions.billing.account.add.first': {
		en: 'Add first Billing Account permission',
		ar: 'إضافة إذن حساب الفواتير الأول',
	},
	'users.permissions.billing.account.create.user.reason': {
		en: 'Select as many accounts as you would like to have access to in order to pay through them.',
		ar: 'يرجى تحديد أي عدد تريده من الحسابات للدفع من خلالها.',
	},
	'users.permissions.billing.account.create.user.select': {
		en: 'Select billing account',
		ar: 'حدد حساب الفواتير',
	},
	'users.permissions.topup.updated': {
		en: 'User permissions have been updated',
		ar: 'تم تحديث أذونات المستخدم',
	},
	'add.numbers': {
		en: 'Add Numbers',
		ar: 'إضافة أرقام',
	},
	'add.number': {
		en: 'Add Number',
		ar: 'أضف رقم',
	},
	undefined: {
		en: 'Undefined',
		ar: 'غير معرف',
	},
	search: {
		en: 'Search',
		ar: 'بحث',
	},
	next: {
		en: 'Next',
		ar: 'التالي',
	},
	'numbers.settings.will.be.available': {
		en: 'Will be available soon!',
		ar: 'سيتوفر قريباً!',
	},
	'replace.it': {
		en: 'Yes, replace it',
		ar: 'نعم، قم باستبداله',
	},
	'change.it': {
		en: 'Yes, change it',
		ar: 'نعم، قم بتغييره',
	},
	'delete.it': {
		en: 'Yes, delete it',
		ar: 'نعم، قم بحذفه',
	},
	'numbers.setting.sim.number.changed': {
		en: 'The SIM Number was changed successfully',
		ar: 'تم تغيير رقم الشريحة بنجاح',
	},
	'numbers.services.updated': {
		en: 'Your services were successfully updated',
		ar: 'تم تحديث الخدمة بنجاح',
	},
	changed: {
		en: 'Changed',
		ar: 'تم التغيير',
	},
	change: {
		en: 'Change',
		ar: 'تغيير',
	},
	'numbers.services.no.services.available': {
		en: 'No services available.',
		ar: 'لا توجد خدمات.',
	},
	'number.details.change.credit.limit': {
		en: 'Change credit limit',
		ar: 'تغيير سقف الإئتمان',
	},
	'number.details.do.you.want.to.change': {
		en: 'Do you want to change credit limit from %% OMR to %% OMR for %%?',
		ar: 'هل ترغب في تغيير سقف الإئتمان من %% ر.ع إلى %% ر.ع لــ %%؟',
	},
	'numbers.setting.user.assigned': {
		en: 'User assigned successfully.',
		ar: 'تم تخصيص المستخدم بنجاح',
	},
	'numbers.setting.user.detached': {
		en: 'User detached successfully.',
		ar: 'تم فصل المستخدم بنجاح.',
	},
	assigned: {
		en: 'Assigned',
		ar: 'تعيين',
	},
	detached: {
		en: 'Detached',
		ar: 'منفصل',
	},
	'numbers.details.credit.limit': {
		en: 'Credit Limit',
		ar: 'سقف الأئتمان',
	},
	'numbers.details.credit.limit.value': {
		en: 'Credit Limit: %% OMR',
		ar: 'سقف الأئتمان: %% ريال',
	},
	'numbers.setting.credit.limit.changed': {
		en: 'Credit Limit changed successfully.',
		ar: 'تم تغيير سقف الإئتمان بنجاح',
	},
	hayyak: {
		en: 'Hayyak',
		ar: 'حياك،',
	},
	delete: {
		en: 'Delete (%%)',
		ar: 'حذف (%%)',
	},
	'delete.photo': {
		en: 'Delete',
		ar: 'حذف',
	},
	'delete.without.number': {
		en: 'Delete',
		ar: 'حذف',
	},
	'items.selected': {
		en: '%% items selected',
		ar: 'تم اختيار %%',
	},
	'item.selected': {
		en: '1 item selected',
		ar: 'تم إختيار عنصر 1',
	},
	'table.are.you.sure': {
		en: 'Are you sure you want to delete selected elements?',
		ar: 'هل أنت متأكد أنك ترغب في حذف العناصر المختارة؟',
	},
	'topup.donate.header': {
		en: 'Donate to charity',
		ar: 'التبرع للجمعيات الخيرية',
	},
	'topup.payment.header': {
		en: 'Enter credit card details',
		ar: 'أدخل تفاصيل بطاقة الائتمان',
	},
	'topup.pleaseWait': {
		en: 'Please wait, processing the payment.',
		ar: 'يرجى الانتظار، جاري الدفع.',
	},
	'topup.table.are.you.sure': {
		en: 'Are you sure you want to delete selected numbers?',
		ar: 'هل أنت متأكد أنك ترغب في حذف الأرقام المختارة؟',
	},
	'table.delete.elements': {
		en: 'Delete elements',
		ar: 'حذف عناصر',
	},
	'topup.table.delete.elements': {
		en: 'Delete numbers',
		ar: 'حذف أرقام',
	},
	'topup.value.limit': {
		en: '1 - 100 OMR',
		ar: '1 - 100 ريال',
	},
	'number.details.change.department': {
		en: 'Change department?',
		ar: 'تغير الدائرة',
	},
	'departments.missing.numbers': {
		en: 'Add missing numbers?',
		ar: 'إضافة أرقام مفقودة؟',
	},
	'number.details.same.department': {
		en: 'Number and user have to be in the same department.',
		ar: 'يجب أن يكون الرقم والمستخدم في نفس الدائرة',
	},
	'number.details.move.department': {
		en: 'Do you want to move %% number to user department?',
		ar: 'هل ترغب في نقل %% رقم إلى دائرة المستخدم؟',
	},
	'payments.bills.date': {
		en: 'Bill Month',
		ar: 'شهر الفاتورة',
	},
	'payments.bills.number': {
		en: 'Bill No',
		ar: 'رقم الفاتورة',
	},
	'payments.bills.organizationName': {
		en: 'Organization Name',
		ar: 'اسم المؤسسة',
	},
	'payments.bills.category': {
		en: 'Category',
		ar: 'الفئة',
	},
	'payments.bills.accountNumber': {
		en: 'Billing Account No',
		ar: 'رقم حساب الفوترة',
	},
	'payments.bills.totalDue': {
		en: 'Total Due',
		ar: 'إجمالي المستحقات',
	},
	'payments.bills.PDF': {
		en: 'PDF',
		ar: 'PDF',
	},
	'payments.bills.interactive': {
		en: 'Interactive bill',
		ar: 'فاتورة تفاعلية',
	},
	'payments.bills.paymentStatus': {
		en: 'Payment Status',
		ar: 'حالة الدفع',
	},
	'payments.bills.limit': {
		en: 'Bill history is limited to a maximum of 18 months',
		ar: 'يمتد تاريخ الفاتورة إلى18 شهر كحد أقصى',
	},
	'payments.bills.header': {
		en: 'Bills List',
		ar: 'قائمة الفواتير ',
	},
	'payments.bills.download.request': {
		en: 'Download ZIP with bills',
		ar: 'تنزيل الفواتير من الشهر الماضي',
	},
	'payments.bills.merging': {
		en: 'Merging list of bills to ZIP',
		ar: 'ZIP دمج قائمة الفواتير في ملف',
	},
	'payments.bills.download': {
		en: 'Download ZIP with bills',
		ar: 'تنزيل ZIP مع الفواتير',
	},
	'payments.bills.download.info': {
		en: 'The access to download will expires in %% days (%%). Next request to download ZIP will be after (%%)',
		ar: 'ستنتهي صلاحية الإمكانية إلى التنزيل في غضون %% أيام (%%). الطلب التالي لتنزيل ملف ZIP يكون بعد (%%) ',
	},
	'payments.bills.download.request.success': {
		en:
			'We received a request to merged bills from %% to ZIP. Please be aware it can take a few minutes to a few hours',
		ar:
			'ZIP تلقينا طلب دمج الفواتير من الشهر الماضي إلى ملف . يرجى الانتباه إلى أن الأمر قد يستغرق بضع دقائق إلى بضع ساعات',
	},
	'payments.bills.download.request.fail': {
		en: 'We are unable to download bills, please try again.',
		ar: 'لا يمكننا تحميل الفواتير ، يرجى المحاولة مرة أخرى.',
	},
	'payments.bills.period': {
		en: 'Period',
		ar: 'الفترة',
	},
	'payments.bills.paid': {
		en: 'Paid',
		ar: 'تم السداد',
	},
	'payments.bills.notPaid': {
		en: 'Not paid',
		ar: 'لم يتم السداد',
	},
	'payments.method': {
		en: 'Payment method',
		ar: 'طريقة الدفع',
	},
	'payment.dialog.select': {
		en: 'Select card',
		ar: 'اختر البطاقة',
	},
	'payments.add.ons.addNumbers': {
		en: 'Add Numbers to Add-ons',
		ar: 'أضف أرقامًا إلى الوظائف الإضافية',
	},
	'payments.topup.addNumbers': {
		en: 'Add Numbers to Top Up',
		ar: 'إضافة أرقام لتعبئة الرصيد',
	},
	'payments.topup.cantAdd': {
		en: "Can't add this number. Remember you can add only prepaid numbers.",
		ar: 'ا يمكن إضافة هذا الرقم. يمكنك إضافة أرقام مسبقة الدفع فقط.',
	},
	'payments.topup.asMany': {
		en: 'As many as you want',
		ar: 'لعدة أرقام مثلما تشاء',
	},
	'payments.topup.addNumbersButton': {
		en: 'Add Numbers',
		ar: 'إضافة الأرقام',
	},
	'payments.topup.addNumbersHeader': {
		en: 'Add Numbers',
		ar: 'إضافة الأرقام',
	},
	'payments.topup.byNumbers': {
		en: 'By Numbers',
		ar: 'بالأرقام',
	},
	'payments.topup.byDepartments': {
		en: 'By Departments',
		ar: 'وفق الدوائر',
	},
	'payments.topup.wrongCVV': {
		en: 'CVV code is invalid. Please verify the code.',
		ar: 'رقم البطاقة السري غير صحيح.',
	},
	'payments.topup.wrongEmail': {
		en: 'Please enter a valid email address.',
		ar: 'يرجى إدخال عنوان بريد إلكتروني صحيح',
	},
	phoneNumber: {
		en: 'Mobile Number',
		ar: 'رقم الهاتف المحمول',
	},
	username: {
		en: 'Username',
		ar: 'اسم المستخدم ',
	},
	'payments.topup.userName': {
		en: 'User Name',
		ar: 'اسم المستخدم',
	},
	'payments.topup.cancel': {
		en: 'Cancel',
		ar: 'إلغاء',
	},
	'payments.topup.add': {
		en: 'Add (%%)',
		ar: 'إضافة (%%)',
	},
	'payments.topup.topupValue': {
		en: 'Top Up Value',
		ar: 'مبلغ تعبئة الرصيد',
	},
	'payments.topup.customTopupValue': {
		en: 'Custom Value',
		ar: 'مبلغ مخصص',
	},
	'payments.topup.selectedNumbers': {
		en: 'Selected Numbers',
		ar: 'الأرقام المختارة',
	},
	'payments.topup.totalAmount': {
		en: 'Total Amount',
		ar: 'المبلغ الإجمالي',
	},
	'payments.topup': {
		en: 'Top Up',
		ar: 'إعادة التعبئة',
	},
	'payments.topup.departments': {
		en: 'Departments',
		ar: 'الدوائر',
	},
	'payments.topup.numbersAmount': {
		en: 'Number Of Lines',
		ar: 'عدد الأرقام',
	},
	'payments.topup.department': {
		en: 'Department',
		ar: 'الدائرة',
	},
	'payments.topup.set': {
		en: 'Set',
		ar: 'مجموعة',
	},
	'payments.topup.deleted': {
		en: 'Deleted',
		ar: 'حذف',
	},
	'payments.topup.numbers': {
		en: 'Numbers',
		ar: 'الأرقام',
	},
	'payments.topup.cardNumber': {
		en: 'Card Number',
		ar: 'رقم البطاقة',
	},
	'payments.topup.cardHolder': {
		en: 'Card Holder Name',
		ar: 'إسم صاحب البطاقة',
	},
	'payments.topup.expDate': {
		en: 'Exp. Date',
		ar: 'تاريخ الانتهاء',
	},
	'payments.topup.securityCode': {
		en: 'CVV Code',
		ar: 'رمز الأمان الثلاثي للبطاقة',
	},
	'payments.topup.toppedUpSuccessfully': {
		en: 'You have topped up successfully',
		ar: 'تم تعبئة الرصيد بنجاح',
	},
	'payments.topup.paymentConfirmed': {
		en: 'Payment confirmed',
		ar: 'تم تأكيد الدفع',
	},
	'payments.topup.customNumberLabel': {
		en: 'Any Mobile Number',
		ar: 'أي رقم هاتف',
	},
	'payments.topup.invoiceSent': {
		en: 'The invoice was sent to your email address',
		ar: 'تم إرسال تفاصيل الدفع إلى بريدك الإلكتروني',
	},
	'payments.topup.seePayments': {
		en: `You can see your payments in section:
		My Payments / My Payments History.`,
		ar: `يمكنك الإطلاع على تفاصيل المدفوعات:
		المدفوعات / سجل الدفع`,
	},
	'payments.topup.pleaseContact': {
		en: 'Please contact Customer Service',
		ar: 'يرجى الاتصال بخدمة المشتركين',
	},
	'payments.topup.customerService': {
		en: 'For Customer Service call 1235',
		ar: 'لخدمة المشتركين، اتصل بـ 1235',
	},
	'payments.topup.paymentRejected': {
		en: 'Payment rejected',
		ar: 'تم رفض المعاملة',
	},
	'payments.topup.paymentRejected.description': {
		en: 'Your payment has been rejected – please contact customer service on 1235.',
		ar: 'تم رفض عملية الدفع الخاصة بك - يرجى الاتصال بخدمة العملاء على 1235.',
	},
	'payments.topup.payAgain': {
		en: 'Pay again',
		ar: 'الدفع مره أخرى',
	},
	'payments.topup.noDepartments': {
		en: "Sorry, you don't have any departments created",
		ar: 'عذراً، لم تقم بإنشاء إي دائرة',
	},
	'payments.topup.noNumbersInDepartment': {
		en: 'There are no prepaid numbers in your departments.',
		ar: 'لا يوجد رقم مسبق الدفع في هذه الدائرة.',
	},
	'payments.topup.brand.visaError': {
		en: 'It’s not a correct credit card number.',
		ar: 'رقم البطاقة غير صحيح.',
	},
	'payments.topup.brand.mastercardError': {
		en: 'Enter a 16 digit card number.',
		ar: 'أدخل رقم البطاقة المكون من 16 رقم.',
	},
	'payments.topup.brand.Error': {
		en: 'Enter a valid card number.',
		ar: 'رقم البطاقة غير صحيح.',
	},
	'payments.topup.wrongDate': {
		en: 'Wrong format (MM/YY).',
		ar: 'تاريخ صلاحية البطاقة غير صحيح.',
	},
	'payments.topup.cvv1': {
		en: 'The ',
		ar: 'الـ ',
	},
	'payments.topup.cvv2': {
		en: '3 digits ',
		ar: '3 أرقام',
	},
	'payments.topup.cvv2.amex': {
		en: '4 digits ',
		ar: '4 أرقام',
	},
	'payments.topup.cvv3': {
		en: 'on the back of the credit card',
		ar: 'خلف بطاقة الأئتمان',
	},
	'payments.topup.navigation.header': {
		en: 'Attention',
		ar: 'انتباه',
	},
	'payments.topup.navigation.areYouSure': {
		en: 'Are you sure you want to leave the process? All of the typed/selected data will be lost.',
		ar: 'هل أنت متأكد أنك تريد ترك العملية؟ ستفقد جميع البيانات المكتوبة / المحددة.',
	},
	'payments.billingAccounts.verificationRequired': {
		en: 'Verification required',
		ar: 'مطلوب التحقق',
	},
	'payments.billingAccounts.deleteManyTooltip': {
		en: 'You can’t delete multiple billing accounts at once.',
		ar: 'لا يمكنك حذف حسابات فوترة متعددة في وقت واحد',
	},
	'payments.billingAccounts.deleteHeader': {
		en: 'Delete billing account?',
		ar: 'حذف حساب الفواتير؟',
	},
	'payments.billingAccounts.filterHeader': {
		en: 'Billing Accounts list',
		ar: 'قائمة حسابات الفوترة',
	},
	'payments.billingAccounts.billingAccountName': {
		en: 'Billing Account Name',
		ar: 'اسم الحساب للفواتير',
	},
	'payments.billingAccounts.billingAccountType': {
		en: 'Billing Account Type',
		ar: 'نوع حساب الفواتير',
	},
	'payments.billingAccounts.billingAccountNumber': {
		en: 'Billing Account Number',
		ar: 'رقم الحساب للفواتير',
	},
	'payments.billingAccounts.account.name': {
		en: 'Account Name',
		ar: 'اسم الحساب',
	},
	'payments.billingAccounts.name.edit.title': {
		en: 'Edit billing account name',
		ar: 'تعديل اسم الحساب للفواتير ',
	},
	'payments.billingAccounts.no-name': {
		en: 'No name',
		ar: 'لا يوجد اسم',
	},
	'payments.billingAccounts.serviceType': {
		en: 'Service type',
		ar: 'نوع الخدمة',
	},
	'payments.billingAccounts.organizationName': {
		en: 'Organization Name',
		ar: 'اسم المؤسسة',
	},
	'payments.billingAccounts.linesAmount': {
		en: 'Number Of Lines',
		ar: 'عدد الخطوط',
	},
	'payments.billingAccounts.information': {
		en: 'Billing Account information',
		ar: 'تفاصيل حساب الفوترة',
	},
	'payments.billingAccounts.invoiceType': {
		en: 'Invoice type',
		ar: 'نوع الفواتير',
	},
	'payments.billingAccounts.invoiceAddress': {
		en: 'Invoice address',
		ar: 'عنوان الفواتير',
	},
	'payments.billingAccounts.ebill': {
		en: 'E-bill',
		ar: 'الفاتورة الإلكترونية',
	},
	'payments.billingAccounts.paper': {
		en: 'Paper',
		ar: 'ورقي',
	},
	'payments.billingAccounts.ebillRecipients': {
		en: 'E-bill invoice recipients',
		ar: 'مستلمي الفاتورة الإلكترونية ',
	},
	'payments.billingAccounts.ebill.thankyou': {
		en: 'Thank you for choosing E-bill!',
		ar: 'شكرا لكم لاختياركم الفاتورة الإلكترونية ',
	},
	'payments.billingAccounts.ebill.beeco': {
		en: 'Be eco. Apply for E-bill.',
		ar: 'ساهم في الحفاظ على البيئة، احصل على فاتورتك الإلكترونية ',
	},
	'payments.billingAccounts.ebill.toActivate': {
		en: 'To activate contact our Business Call Center:',
		ar: 'يرجى الاتصال بمركز الاتصال من أجل التفعيل',
	},
	'payments.billingAccounts.ebill.orText': {
		en: 'or text:',
		ar: ' او ارسل',
	},
	'payments.billingAccounts.ebill.text': {
		en: 'E-bill to 80514',
		ar: 'فاتورة" في رسالة نصية الى 80514',
	},
	'payments.billingAccounts.serviceType.postpaid': {
		en: 'Mobile - Postpaid',
		ar: 'هاتف نقال - آجل الدفع',
	},
	'payments.billingAccounts.serviceType.prepaid': {
		en: 'Mobile - Prepaid',
		ar: 'هاتف نقال - مسبق الدفع',
	},
	'payments.billingAccounts.serviceType.internet': {
		en: 'Mobile - Data only',
		ar: 'الهاتف النقال - البيانات فقط',
	},
	'payments.billingAccounts.serviceType.fixed-line': {
		en: 'Fixed Voice',
		ar: 'مكالمات فقط',
	},
	'payments.billingAccounts.recipientEmailAddress': {
		en: 'Recipient email address',
		ar: 'البريد الإلكتروني للمستلمين',
	},
	'payments.billingAccounts.expirationDate': {
		en: 'Access expiration date',
		ar: 'تاريخ انتهاء صلاحية الإستخدام',
	},
	'payments.billingAccounts.seeProfile': {
		en: 'See profile',
		ar: 'عرض الملف',
	},
	'payments.billingAccounts.delete.areYouSure': {
		en: 'Are you sure you want to delete billing account %% (%%) from your organization?',
		ar: 'Are you sure you want to delete billing account %% (%%) from your organization?',
	},
	'payments.billingAccounts.delete.success': {
		en: 'Selected billing accounts deleted',
		ar: 'تم حذف حسابات الفوترة المحددة',
	},
	'payments.saveCard': {
		en: 'Save card to My Wallet',
		ar: 'حفظ البطاقة في محفظتي',
	},
	'payments.dialog.useCard': {
		en: 'Use card',
		ar: 'استخدم البطاقة',
	},
	'payments.dialog.useAndSaveCard': {
		en: 'Use and save card',
		ar: 'استخدام وحفظ البطاقة',
	},
	'payments.dialog.newCard': {
		en: 'New payment card',
		ar: 'بطاقة دفع جديدة',
	},
	'accounts.department.added': {
		en: 'Department added successfully.',
		ar: 'تم إضافة الدائرة بنجاح',
	},
	'accounts.department.updated': {
		en: 'Department updated successfully.',
		ar: 'تم تحديت الدائرة بنجاح',
	},
	'accounts.department.deleted': {
		en: 'Department deleted successfully.',
		ar: 'تم حذف الدائرة بنجاح ',
	},
	added: {
		en: 'Added',
		ar: 'تمت الإضافة',
	},
	deleted: {
		en: 'Deleted',
		ar: 'تم الحذف ',
	},
	lines: {
		en: 'Lines',
		ar: 'الخطوط ',
	},
	updated: {
		en: 'Updated',
		ar: 'تم التحديث',
	},
	skip: {
		en: 'Skip',
		ar: 'تجاهل',
	},
	'departments.no.manager.account': {
		en: "You don't have any manager account created yet.",
		ar: 'ا يوجد لديك أي حساب مدير تم إنشاء حتى الآن',
	},
	'departments.no.manager.for.department': {
		en: 'You don’t have any managers added yet.',
		ar: 'ا يوجد لديك أي مديرين تم إضافتهم حتى الآن',
	},
	'departments.add.first.manager': {
		en: 'Add first manager',
		ar: 'إضافة أول مدير',
	},
	'departments.add.manager': {
		en: 'Add manager',
		ar: 'إضافة مدير',
	},
	'departments.delete.department': {
		en: 'Delete department',
		ar: 'حذف الدائرة',
	},
	'departments.change.department': {
		en: 'Change department',
		ar: 'تغيير الدائرة',
	},
	'departments.no.department': {
		en: 'No department',
		ar: 'ا توجد دائرة',
	},
	'departments.all.users': {
		en: 'All users',
		ar: 'جميع المستخدمين',
	},
	'departments.all.numbers.users': {
		en: 'All numbers / users',
		ar: 'جميع أرقام/ مستخدمين',
	},
	'add.user': {
		en: 'Add user',
		ar: 'إضافة مستخدم',
	},
	'contact.number': {
		en: 'Contact number',
		ar: 'رقم التواصل',
	},
	'alt.contact.number': {
		en: 'Alt. contact number',
		ar: 'رقم اتصال بديل',
	},
	'cr.number': {
		en: 'CR Number',
		ar: 'رقم السجل التجاري',
	},
	'embassy.id': {
		en: 'Embassy Id',
		ar: 'Embassy Id',
	},
	'government.id': {
		en: 'Government Id',
		ar: 'Government Id',
	},
	region: {
		en: 'Region',
		ar: 'المنطقة',
	},
	city: {
		en: 'City',
		ar: 'المدينة',
	},
	'way.number': {
		en: 'Way Number',
		ar: 'رقم السكة',
	},
	'house.number': {
		en: 'House Number',
		ar: 'رقم المنزل',
	},
	'apartment.number': {
		en: 'Apartment Number',
		ar: 'رقم الشقة',
	},
	save: {
		en: 'Save',
		ar: 'حفظ',
	},
	governorate: {
		en: 'Governorate',
		ar: 'المحافظة',
	},
	landmark: {
		en: 'Landmark',
		ar: 'مكان معروف',
	},
	add: {
		en: 'Add',
		ar: 'إضافة',
	},
	'add.count': {
		en: 'Add (%%)',
		ar: 'إضافة (%%)',
	},
	'departments.add.users.numbers': {
		en: 'Add numbers / users',
		ar: 'إضافة أرقام/ مستخدمين',
	},
	'not.added': {
		en: 'not added',
		ar: 'لم تتم الإضافة',
	},
	'departments.numbers.added': {
		en: 'Numbers successfully added to department.',
		ar: 'تم إضافة الأرقام بنجاح إلى الدائرة',
	},
	'departments.no.admins.added': {
		en: 'You don’t have any admins added yet.',
		ar: 'ا يوجد لديك أي مشرفين تم إضافتهم حتى الآن',
	},
	'departments.no.managers.added': {
		en: 'You don’t have any managers added yet.',
		ar: 'لم يتم إضافة أي مدير.',
	},
	'add.admin': {
		en: 'Add admin',
		ar: 'إضافة مشرف',
	},
	'add.enduser': {
		en: 'Add end-user',
		ar: 'إضافة مستخدم نهائي',
	},
	'add.manager': {
		en: 'Add manager',
		ar: 'إضافة مدير',
	},
	'see.all': {
		en: 'See all',
		ar: 'عرض الكل ',
	},
	'organizations.organization.managers': {
		en: 'Organization Managers',
		ar: 'مدراء المؤسسة',
	},
	'organizations.organization.admins': {
		en: 'Organization Admins',
		ar: 'مشرفي المؤسسة',
	},
	'table.permissions': {
		en: 'Permissions',
		ar: 'الصلاحيات',
	},
	'accounts.edit.contact.information': {
		en: 'Edit contact information',
		ar: 'تعديل معلومات التواصل',
	},
	'add.next.number': {
		en: 'Add next number',
		ar: 'إضافة الرقم التالي',
	},
	'add.max.three.numbers': {
		en: 'You can add max 3 Mobile Numbers.',
		ar: 'يمكنك إضافة 3 أرقام بحد أقصى',
	},
	'contact.error.text': {
		en: 'Contact number should contain 8 digits',
		ar: 'يجب أن يتكون رقم التواصل من 8 أرقام',
	},
	'select.expiration.date': {
		en: 'Select access expiration date',
		ar: 'قم باختيار تاريخ انتهاء الدخول',
	},
	'department.details.expiration.date': {
		en: 'Expiration date',
		ar: 'تاريخ الإنتهاء',
	},
	unlimited: {
		en: 'Unlimited',
		ar: 'غير محدود',
	},
	back: {
		en: 'Back',
		ar: 'الرجوع',
	},
	permissions: {
		en: 'Permissions',
		ar: 'التصاريح',
	},
	'department.permissions': {
		en: 'Departments permissions',
		ar: 'أذونات القسم',
	},
	'billing.account.permissions': {
		en: 'Billing Accounts permissions',
		ar: 'أذونات حساب الفواتير',
	},
	permission: {
		en: 'Permission',
		ar: 'تصريح',
	},
	'monthly.costs': {
		en: 'Monthly Costs',
		ar: 'التكاليف الشهرية',
	},
	'dashboard.active.services': {
		en: 'Active Services',
		ar: 'الخدمات المفعلة',
	},
	'dashboard.tryAndBuy.offers': {
		en: 'Offers',
		ar: 'عروض',
	},
	'dashboard.billing.account.this.year': {
		en: 'Billing Account this year',
		ar: 'حساب الفواتير هذا العام',
	},
	'all.accounts': {
		en: 'All Accounts',
		ar: 'جميع الحسابات ',
	},
	'all.organizations': {
		en: 'All Organizations',
		ar: 'جميع المؤسسات',
	},
	'all.departments': {
		en: 'All Departments',
		ar: 'جميع أقسام الشركة',
	},
	'dashboard.current.bill': {
		en: 'Current Bill total',
		ar: 'مجموع الفاتورة الحالية',
	},
	'dashboard.last.bill': {
		en: 'Last Bill total',
		ar: 'مجموع الفاتورة السابقة',
	},
	'dashboard.summary.bill.corporate': {
		en: 'Bills Summary',
		ar: 'ملخص الفواتير',
	},
	'dashboard.summary.bill.enterprise': {
		en: 'Bills summary (for all organizations)',
		ar: 'ملخص الفواتير (لجميع المؤسسات)',
	},
	account: {
		en: 'Account',
		ar: 'الحساب',
	},
	accounts: {
		en: 'Accounts',
		ar: 'الحسابات',
	},
	organization: {
		en: 'Organization',
		ar: 'المؤسسة',
	},
	organizations: {
		en: 'Organizations',
		ar: 'المؤسسات',
	},
	'account.permissions': {
		en: '%% permissions',
		ar: '%% التصاريح',
	},
	department: {
		en: 'Department',
		ar: 'الدوائر',
	},
	'multiple.selected': {
		en: 'Multiple selected',
		ar: 'تم اختيار عدة خيارات',
	},
	postpaid: {
		en: 'Postpaid',
		ar: 'آجل الدفع',
	},
	prepaid: {
		en: 'Prepaid',
		ar: 'مسبق الدفع',
	},
	'fixed.services': {
		en: 'Fixed Services',
		ar: 'الخدمات الثابتة',
	},
	'data.only': {
		en: 'Data only',
		ar: 'بيانات فقط',
	},
	'messaging.services': {
		en: 'Messaging services',
		ar: 'خدمات الرسائل',
	},
	'services.add.ons': {
		en: 'Services and add-ons',
		ar: 'الخدمات والخدمات الإضافية',
	},
	'no.data.available': {
		en: 'No data available.',
		ar: 'لا توجد بيانات متوفرة.',
	},
	'add.line': {
		en: 'Add line',
		ar: 'إضافة خط',
	},
	'add.line.plan': {
		en: 'Plan',
		ar: 'الباقة',
	},
	'add.line.billing.account': {
		en: 'Billing Account',
		ar: 'حساب الفوترة',
	},
	'add.line.services': {
		en: 'Services',
		ar: 'الخدمات',
	},
	'add.line.sim': {
		en: 'SIM',
		ar: 'الشريحة',
	},
	'add.line.number': {
		en: 'Number',
		ar: 'الرقم',
	},
	'user.and.number': {
		en: 'User and number',
		ar: 'المستخدم والرقم',
	},
	'add.line.contact.details': {
		en: 'Contact Details',
		ar: 'بيانات المتصل',
	},
	'add.line.contact.files': {
		en: 'Files',
		ar: 'الملفات',
	},
	'add.line.contact.workingNumber': {
		en: 'Enter your working fixed-line number',
		ar: 'أدخل رقم الخط الثابت العامل الخاص بك',
	},
	summary: {
		en: 'Summary',
		ar: 'ملخص',
	},
	'pleaseUpload.file': {
		en: 'Please upload required file below:',
		ar: 'الرجاء تحميل الملف المطلوب أدناه:',
	},
	'new.line': {
		en: 'New line',
		ar: 'خط جديد',
	},
	'billing.account.name.number': {
		en: 'Billing Account Name / Number',
		ar: 'اسم/ رقم حساب الفاتورة',
	},
	'serial.number': {
		en: 'Serial Number',
		ar: 'الرقم المتسلسل',
	},
	'user.name.optional': {
		en: 'User Name (optional)',
		ar: 'اسم المستخدم (اختياري)',
	},
	'billing.account': {
		en: 'Billing Account',
		ar: 'حساب الفوترة',
	},
	'service.name': {
		en: 'Service Name',
		ar: 'اسم الخدمة',
	},
	tariff: {
		en: 'Tariff',
		ar: 'التعرفة',
	},
	'credit.limit': {
		en: 'Credit Limit',
		ar: 'سقف الأئتمان',
	},
	services: {
		en: 'Services',
		ar: 'الخدمات',
	},
	'schedule.date': {
		en: 'Schedule Date',
		ar: 'تاريخ الجدول الزمني',
	},
	'active.lines': {
		en: 'Active lines',
		ar: 'الخطوط المفعلة',
	},
	'available.lines': {
		en: 'Available lines',
		ar: 'الخطوط المتوافرة',
	},
	'nama.plans': {
		en: 'Nama plans',
		ar: 'خطط نماء',
	},
	'show.only.active': {
		en: 'Show only active',
		ar: 'عرض المفعل فقط',
	},
	pay: {
		en: 'Pay',
		ar: 'الدفع',
	},
	billingAddress: {
		en: 'Billing Address',
		ar: 'عنوان الفواتير',
	},
	street: {
		en: 'Street',
		ar: 'الشارع',
	},
	'billing.accounts': {
		en: 'Billing Accounts',
		ar: 'حساب الفوترة',
	},
	sim: {
		en: 'SIM',
		ar: 'الشريحة',
	},
	'tariff.plan': {
		en: 'Tariff Plan',
		ar: 'خطة التعرفة',
	},
	'phone.number': {
		en: 'Mobile Number',
		ar: 'رقم الهاتف المحمول',
	},
	'services.gsm.roaming.services.optional': {
		en: 'GSM Roaming Services (optional)',
		ar: 'خدمات تجوال الهاتف المتنقل العالمي (اختياري)',
	},
	'services.gsm.international.services.optional': {
		en: 'GSM International Services (optional)',
		ar: 'خدمات الهاتف المتنقل العالمي الدولية (اختياري)',
	},
	'services.gsm.international.minutes': {
		en: 'International Minutes',
		ar: 'دقائق دولية',
	},
	'services.gsm.international.minutes.description': {
		en: 'Requires international service.',
		ar: 'تتطلب خدمة دولية.',
	},
	'services.international.minutes.turn.on.confirmation': {
		en:
			'Are you sure you want to turn on International Minutes package? Please check if the country you are interested in is on the list.',
		ar:
			'هل أنت متأكد أنك تريد تشغيل باقة الدقائق الدولية؟ يرجى التحقق مما إذا كانت الدولة التي تريدها  مدرجة في القائمة.',
	},
	'services.international.minutes.turn.off.confirmation': {
		en: 'Are you sure you want to turn off International Minutes package?',
		ar: 'هل أنت متأكد أنك تريد إيقاف  باقة الدقائق الدولية؟',
	},
	'services.gsm.roaming.services': {
		en: 'GSM Roaming Services',
		ar: 'خدمات تجوال الهاتف المتنقل العالمي',
	},
	'services.gsm.international.services': {
		en: 'GSM International Services',
		ar: 'خدمات الهاتف المتنقل العالمي الدولية ',
	},
	'services.new.postpaid.line.added': {
		en: 'New postpaid line added successfully',
		ar: 'تم إضافة خط آجل الدفع بنجاح',
	},
	'organization.and.department': {
		en: 'Organization and department',
		ar: 'المؤسسة والدائرة',
	},
	'assign.to.organization': {
		en: 'Assign to Organization',
		ar: 'تخصيص لمؤسسة',
	},
	'assign.to.department.optional': {
		en: 'Assign to Department (optional)',
		ar: 'تخصيص الدائرة (أختياري)',
	},
	'organizations.no.departments.in.this.organization': {
		en: 'No departments in this organization',
		ar: 'لا توجد دوائر بهذه المؤسسة',
	},
	'accounts.assign.permissions': {
		en: 'Assign permissions by selecting accounts',
		ar: 'تخصيص تصاريح من قبل الحسابات المختارة',
	},
	'accounts.assign.full-access': {
		en: 'The user will receive access to edit mode and full account information.',
		ar: 'سيحصل المستخدم على إمكانية الدخول لتعديل وضع وجميع معلومات الحساب',
	},
	'user.details': {
		en: 'User Details',
		ar: 'تفاصيل المستخدم',
	},
	'access.expiration.date': {
		en: 'Access expiration date',
		ar: 'تاريخ انتهاء صلاحية الوصول',
	},
	'user.type.admin': {
		en: 'Admin (can create users and edit data)',
		ar: 'المشرف (يمكنه إنشاء مستخدمين وتعديل البيانات)',
	},
	'user.type.manager': {
		en: 'Manager (can view and download data)',
		ar: 'المدير (يمكنه عرض وتنزيل البيانات)',
	},
	'user.type.enduser': {
		en: 'End-user (no access to this portal) ',
		ar: 'المستخدم النهائي (لا يمكنه الوصول إلى البوابة)',
	},
	'select.user.type': {
		en: 'Select user type',
		ar: 'اختر نوع المستخدم',
	},
	'admin.user.added': {
		en: 'Admin added successfully.',
		ar: 'تم إضافة المشرف بنجاح',
	},
	'manager.user.added': {
		en: 'Manager added successfully.',
		ar: 'تم إضافة المدير بنجاح',
	},
	'role.MANAGER': {
		en: 'Manager',
		ar: 'المدير',
	},
	'role.ENDUSER': {
		en: 'End-user',
		ar: 'المستخدم النهائي',
	},
	'role.ADMIN': {
		en: 'Admin',
		ar: 'المشرف',
	},
	'users.details.maxAmountAdmin': {
		en: 'You have reached the max amount of admin users for all accounts.',
		ar: 'تم إضافة العدد المسموح به للمشرفين في جميع الدوائر.',
	},
	'users.details.maxTwoAdmin': {
		en: 'An organization can only have a maximum of two admins already assigned to it.',
		ar: 'لا يمكن للمؤسسة أن يكون لديها سوى اثنين من المسؤولين المعينين لها كحد أقصى.',
	},
	'users.details.userType': {
		en: 'User type',
		ar: 'نوع المستخدم',
	},
	'users.details.userInformation': {
		en: 'User information',
		ar: 'معلومات المستخدم',
	},
	'enduser.user.added': {
		en: 'End-user added successfully.',
		ar: 'تم إضافة المستخدم النهائي بنجاح ',
	},
	'user.added': {
		en: 'User added successfully.',
		ar: 'تم إضافة المستخدم بنجاح',
	},
	'numbers.added': {
		en: 'Numbers added successfully.',
		ar: 'تم إضافة الأرقام بنجاح إلى الدائرة',
	},
	'numbers.no.description.available': {
		en: 'Tariff plan description is unavailable.',
		ar: 'ا يوجد وصف لتعرفة الخطة ',
	},
	'users.list': {
		en: 'Users list',
		ar: 'قائمة المستخدمين',
	},
	'access.expDate': {
		en: 'Access expiration date',
		ar: 'تاريخ انتهاء الدخول',
	},
	'users.details.noPermissions': {
		en: 'No permissions added',
		ar: 'لم يتم إضافة أي تصاريح ',
	},
	'users.details.addPermissions': {
		en: 'Add permissions',
		ar: 'إضافة تصاريح',
	},
	'users.details.editUserInformation': {
		en: 'Edit user information',
		ar: 'تعديل معلومات المستخدم',
	},
	'users.details.editUserOrganization': {
		en: 'Edit user organization',
		ar: 'تعديل مؤسسة المستخدم',
	},
	'users.details.assignedToOrganization': {
		en: 'Assigned to organization',
		ar: 'تم تخصيصه إلى مؤسسة ',
	},
	'users.details.assignToDepartment': {
		en: 'Assign to department (optional)',
		ar: 'تخصيص إلى دائرة (اختياري)',
	},
	'users.details.noDepartments': {
		en: 'No departments in this account',
		ar: 'ا توجد دوائر في هذا الحساب',
	},
	'users.details.changeDepartmentAccept': {
		en: 'Are you sure you want to change the department where the user is assigned to?',
		ar: 'هل أنت متأكد أنك ترغب في تغيير الدائرة التي تم تخصيص هذا المستخدم إليها؟',
	},
	'users.details.changeDepartmentWarning': {
		en: 'The numbers will be transferred with the user to the new department.',
		ar: 'سيتم نقل الأرقام مع المستخدم إلى الدائرة الجديدة',
	},
	'users.details.editType': {
		en: 'Edit user type',
		ar: 'تعديل نوع المستخدم',
	},
	'users.details.changeUserTypeHeader': {
		en: 'Change user type?',
		ar: 'تغيير نوع المسنخدم؟',
	},
	'users.details.changeUserTypeSubheader': {
		en: 'Are you sure you want to change user type from %% to %%?',
		ar: 'هل أنت متأكد أنك ترغب في تغيير نوع المستخدم من %% إلى %%؟',
	},
	'users.details.changeUserTypeWarning.manager': {
		en: 'The user will receive access to preview mode and selected account information.',
		ar: 'سيحصل المستخدم على إمكانية الدخول لوضع الإطلاع وبعض معلومات الحساب',
	},
	'users.details.changeUserTypeWarning.admin': {
		en: 'The user will receive access to edit mode and full account information',
		ar: 'سيحصل المستخدم على إمكانية الدخول لوضع التعديل وجميع معلومات الحساب',
	},
	'users.details.changeUserTypeWarning.toEndUser': {
		en: 'The user will lose all assigned permissions.',
		ar: 'سيفقد المستخدم جميع التصاريح المخصصة له',
	},
	'users.details.changeUserTypeWarning.toManager': {
		en: 'The user will lose access to edit mode.',
		ar: 'سيفقد المستخدم حق الوصول إلى وضع التعديل ',
	},
	'users.details.editPermissions': {
		en: 'Edit permissions',
		ar: 'تعديل التصاريح',
	},
	'users.details.changeOrganization': {
		en: 'Change Organization?',
		ar: 'تغيير المؤسسة؟',
	},
	'users.details.changeOrganizationSubheader': {
		en: 'Are you sure you want to change the organization where the user is assigned to?',
		ar: 'هل أنت متأكد أنك ترغب في تغيير المؤسسة التي تم تخصيص المستخدم إليها؟',
	},
	'users.details.changeOrganizationWarning': {
		en: 'His numbers will be transferred to the new organization',
		ar: 'سيتم نقل رقمه إلى المؤسسة الجديدة',
	},
	'users.details.deletePermissions': {
		en: 'Delete permissions?',
		ar: 'حذف التصاريح؟',
	},
	'users.details.deletePermissionsSubheader': {
		en: 'Are you sure you want to delete all access permissions?',
		ar: 'هل أنت متأكد أنك ترغب في حذف جميع تصاريح الدخول؟',
	},
	'users.details.userTypeChanged': {
		en: 'User type changed to %%',
		ar: 'تم تغيير نوع المستخدم إلى %%',
	},
	'users.details.userDepartmentChanged': {
		en: 'User department changed to %%',
		ar: 'تم تغيير قسم المستخدم إلى %%',
	},
	'users.edit.changeUserHeader': {
		en: 'Change user?',
		ar: 'هل تود تغيير المستخدم؟',
	},
	'users.edit.user.changed': {
		en: 'User changed',
		ar: 'تغير المستخدم',
	},
	'users.edit.changeUserSubheader': {
		en: 'Are you sure you want to change this user?',
		ar: 'هل أنت متأكد أنك تريد تغيير هذا المستخدم؟',
	},
	'end.user.description': {
		en:
			'The end-user account was created for identifying users numbers. It may be your employees or other mobile number users.',
		ar: 'تم إنشاء حساب المستخدم لتحديد أرقام المستخدمين. قد يكون موظفيك أو مستخدمين آخرين لرقم الهاتف. ',
	},
	'manager.description': {
		en: 'The manager account is a preview mode where the user can see and download information.',
		ar: 'إن حساب المدير هو حساب يمكنه من خلاله الإطلاع والتنزيل ',
	},
	'admin.description': {
		en: 'The admin account is the highest access level which allows managing users accounts, numbers and services.',
		ar: 'إن حساب المشرف هو أعلى مستوى من الصلاحيات والذي يمكن من إدارة حسابات المستخدمين والأرقام والخدمات',
	},
	'end.user.no.access': {
		en: 'End-user has no access to this portal.',
		ar: 'لا يمكن للمستخدم النهائي الوصول إلى البوابة ',
	},
	'manager.can': {
		en: 'Manager can:',
		ar: 'يمكن للمدير ',
	},
	'admin.can': {
		en: 'Admin can:',
		ar: 'يمكن للمشرف',
	},
	'download.data': {
		en: 'Download data',
		ar: 'تنزيل البيانات',
	},
	'view.data': {
		en: 'View data',
		ar: 'الإطلاع على البيانات',
	},
	'edit.data': {
		en: 'Edit data',
		ar: 'تعديل البيانات',
	},
	'create.users': {
		en: 'Create new users accounts',
		ar: 'إنشاء حسابات مستخدمين جديدة ',
	},
	'users.permissions.select.departments': {
		en: 'Assign permissions by selecting accounts and their departments',
		ar: 'منح تصاريح من خلال اختيار حسابات والدوائر التابعة لها ',
	},
	'show.details': {
		en: 'Show details',
		ar: 'عرض التفاصيل',
	},
	'service.details': {
		en: 'Service details',
		ar: 'تفاصيل الخدمة',
	},
	'tariff.plan.name': {
		en: 'Tariff plan name',
		ar: 'اسم خطة التعرفة',
	},
	costs: {
		en: 'Costs',
		ar: 'التكاليف الشهرية',
	},
	'services.month.per.line': {
		en: 'month per line',
		ar: 'شهر لكل خط',
	},
	'users.deleted': {
		en: 'Users deleted successfully',
		ar: 'تم حذف المستخدمين بنجاح',
	},
	'department.edit.expiration.date': {
		en: 'Edit access expiration date',
		ar: 'تعديل تاريخ انتهاء الدخول',
	},
	none: {
		en: 'None',
		ar: 'لا يوجد',
	},
	'usage.unit.none': {
		en: 'None',
		ar: 'لا يوجد',
	},
	'add.first.number': {
		en: 'Add first number',
		ar: 'إضافة أول رقم',
	},
	'user.doesnt.have.numbers': {
		en: "This user doesn't have any numbers yet.",
		ar: 'لا يوجد لدى المستخدم أي أرقام حتى الآن',
	},
	loading: {
		en: 'Loading...',
		ar: 'تحميل...',
	},
	'users.numbers.have.to.be.assigned': {
		en: 'Users numbers have to be assigned to the same department as the user.',
		ar: 'يجب تخصيص أرقام المستخدمين إلى نفس الدائرة التي يتبع لها المستخدم ',
	},
	'users.do.you.want.to.change.department': {
		en: 'Do you want to change the department for selected numbers?',
		ar: 'هل ترغب في تغيير الدائرة للأرقام المختارة؟',
	},
	'users.user.is.not.assigned': {
		en: 'Your user is not assigned to any department yet.',
		ar: 'لم يتم تخصيص اسم المستخدم الخاص بك إلى أي دائرة حتى الآن',
	},
	'users.do.you.want.to.add.numbers': {
		en: 'Do you want to add this numbers without assigned department?',
		ar: 'هل ترغب في إضافة هذه الأرقام بدون تخصيص دائرة؟ ',
	},
	'not.assigned.to.department': {
		en: 'Not assigned to the department',
		ar: 'لم يتم تخصيصها إلى الدائرة ',
	},
	edited: {
		en: 'Edited:',
		ar: 'تم تعديلها',
	},
	'no.permissions': {
		en: 'No permissions',
		ar: 'لا توجد تصاريح',
	},
	'create.departments.to.add.permissions': {
		en: '(create departments to add permissions)',
		ar: '(إنشاء دوائر لإضافة تصاريح)',
	},
	'service.details.lines.from.to': {
		en: '%% - %% lines',
		ar: '%% - %% خطوط',
	},
	'service.details.lines': {
		en: '%% lines',
		ar: '%% خطوط',
	},
	'billing.account.numbers.list': {
		en: 'Billing account numbers list',
		ar: 'قائمة أرقام حساب الفواتير ',
	},
	'payments.history.selected.one.more.download.invoice': {
		en: 'Select One Or More Invoices To Download',
		ar: 'Select One Or More Invoices To Download',
	},
	'payment.history.download.selected.invoices': {
		en: 'Download Selected Invoices',
		ar: 'Download Selected Invoices',
	},
	'payment.history.invoice.selected': {
		en: '%% Receipts selected',
		ar: '%% Receipts selected',
	},
	'payments.history.recieptList': {
		en: 'Receipts',
		ar: 'قائمة المدفوعات', // need to change
	},
	'payments.history.rowType.TOP_UP': {
		en: 'Top Up',
		ar: 'إعادة التعبئة',
	},
	'payments.history.rowType.GROUP_TOP_UP': {
		en: 'Bulk Top Up',
		ar: 'جملة المدفوعات',
	},
	'payments.history.rowType.PAY_BILL': {
		en: 'Pay Bill',
		ar: 'دفع الفواتير',
	},
	'payments.history.rowType.BILL': {
		en: 'Bill',
		ar: 'الفاتورة',
	},
	'payments.history.rowType.PAY_ALL_BILLS': {
		en: 'Bill',
		ar: 'الفاتورة',
	},
	'payment.details': {
		en: 'Payment details',
		ar: 'تفاصيل المدفوعات',
	},
	'service.type': {
		en: 'Service type',
		ar: 'نوع الخدمة',
	},
	'monthly.fee': {
		en: 'Monthly Fee',
		ar: 'رسوم شهرية',
	},
	'installation.fee': {
		en: 'Installation Fee',
		ar: 'رسوم التركيب',
	},
	'top.up.many': {
		en: 'Bulk Payment',
		ar: 'جملة المدفوعات',
	},
	period: {
		en: 'Period',
		ar: 'الفترة',
	},
	'last.days': {
		en: 'Last %% days',
		ar: 'آخر  %% يوم',
	},
	'custom.date.range': {
		en: 'Custom date range',
		ar: 'فترة التاريخ',
	},
	'required.field': {
		en: 'Required field',
		ar: 'الحقل مطلوب',
	},
	mobile: {
		en: 'Mobile',
		ar: 'الهاتف النقال',
	},
	internet: {
		en: 'Internet',
		ar: 'إنترنت',
	},
	'fixed.line': {
		en: 'Fixed line',
		ar: 'الهاتف الثابت',
	},
	'fixed.business.broadband': {
		en: 'Fixed Business Broadband',
		ar: 'النطاق العريض الثابت للشركات',
	},
	'add.new.services': {
		en: 'Add new services',
		ar: 'إضافة خدمة جديدة',
	},
	'add.new.services.nama.plans': {
		en: 'Add New Lines - Nama Plans',
		ar: 'إضافة أرقام جديدة - باقات نماء',
	},
	'add.new.services.add.new.postpaid.line': {
		en: 'Add Postpaid line',
		ar: 'إضافة خط اجل دفع',
	},
	'add.new.services.nama.packages': {
		en: 'Add New Lines - Nama Packages',
		ar: 'إضافة خطوط جديدة - باقات نماء',
	},
	'add.new.services.business.prepaid': {
		en: 'Add New Lines - Business Prepaid',
		ar: 'إضافة أرقام جديدة - الأعمال مسبقة الدفع',
	},
	'add.new.services.business.data': {
		en: 'Add New Lines - Business Data Only',
		ar: 'إضافة أرقام جديدة - بيانات الأعمال فقط',
	},
	'add.new.services.fiber.pro': {
		en: 'Add Fiber Pro',
		ar: 'إضافة إنترنت الأعمال الثابتة',
	},
	'add.new.services.fiber.pro.label': {
		en: '(New plans available)',
		ar: '(تتوفر احترافية جديدة)',
	},
	'add.new.services.aamali': {
		en: 'Add New Lines - Aamali',
		ar: 'إضافة خطوط جديدة - أعمالي',
	},
	'add.new.services.fixed': {
		en: 'Add Fixed line',
		ar: 'إضافة خط ثابت',
	},
	'users.you.dont.have.users': {
		en: "You don't have any users yet.",
		ar: 'لا يوجد لديك أي مستخدمين حتى الآن',
	},
	'users.you.can.upload.csv': {
		en:
			'You can upload a CSV file with the list of your users and numbers.\n' +
			'By default, uploaded users will be end-users and will not have access to this portal.' +
			'You can create managers and admins accounts later.',
		ar:
			'يمكنك تحميل ملف بصيغة CSV مع قائمة المستخدمين والأرقام الخاصة بك. \n' +
			'سيكون المستخدمون الذين تم تحمل بياناتهم مستخدمين نهائيين تلقائيا ولن يتمكنوا من الدخول إلى هذه البوابة' +
			'يمكنك إنشاء حسابات مدراء ومشرفين لاحقا',
	},
	'csv.drag.and.drop': {
		en: 'Drag and drop a CSV file here to upload or click to select',
		ar: 'اسحب ملف بصيغة CSV وضعه هنا لتحميل أو أضغط للاختيار ',
	},
	'users.dropdown.add.new.user': {
		en: 'Add new user',
		ar: 'إضافة مستخدم جديد',
	},
	'users.dropdown.import.from.file': {
		en: 'Import users from file',
		ar: 'استيراد مستخدمين من الملف',
	},
	'users.dialog.import.from.file': {
		en: 'Import users from file',
		ar: 'استيراد مستخدمين من الملف',
	},
	'dialog.how.file.needs.to.look.like': {
		en: 'I don’t know how this file needs to look like',
		ar: 'لا أعرف كيف يجب أن يبدو هذا الملف؟',
	},
	'click.to.download.sample': {
		en: 'Click here to download sample file.',
		ar: 'اضغط هنا لتنزيل ملف عينة',
	},
	'department.details.users.deleted': {
		en: 'Users successfully deleted.',
		ar: 'تم حذف المستخدمين بنجاح',
	},
	'department.details.users.table.delete.elements': {
		en: 'Delete users',
		ar: 'حذف مستخدمين',
	},
	'department.details.users.table.are.you.sure': {
		en: 'Are you sure you want to delete selected users?',
		ar: 'هل أنت متأكد أنك ترغب في حذف المستخدمين الذين تم اختبارهم؟',
	},
	'services.coming.soon': {
		en: 'Coming soon!',
		ar: 'ستتوفر هذه الخدمة قريباً',
	},
	'dashboard.billing.account.name': {
		en: 'Billing Account Name / Number',
		ar: 'اسم/ رقم حساب الفاتورة',
	},
	'dashboard.no.billing.accounts': {
		en: 'No Billing Accounts available',
		ar: 'لا يوجد حساب فواتير ',
	},
	'dashboard.in.comparison.to.previous.month': {
		en: 'In comparison to the previous month',
		ar: 'مقارنة بالشهر الماضي ',
	},
	'organization.details': {
		en: 'Organization Details',
		ar: 'تفاصيل المؤسسة',
	},
	'importing.users': {
		en: 'Importing users',
		ar: 'استيراد المستخدمين',
	},
	'it.can.take.a.while': {
		en: 'Please wait, it can take a while',
		ar: 'الرجاء الإنتظار، يمكن أن يأخذ وقتا ',
	},
	'users.incorrect.csv.format': {
		en: 'Incorrect file format. You can download sample file below.',
		ar: 'صيغة ملف غير صحيحة، يمكنك تنزيل ملف عينة أدناه',
	},
	'users.csv.something.went.wrong': {
		en: 'Something went wrong. Please try again.',
		ar: 'حدث خطأ ما. يرجى المحاولة مرة أخرى.',
	},
	'users.you.have.imported.new.users': {
		en: 'You have imported new users.',
		ar: 'لقد قمت باستيراد مستخدمين جدد ',
	},
	'users.some.errors.occurred': {
		en: 'Some errors occurred (%%):',
		ar: 'حدثت بعض الأخطاء (%%)',
	},
	'users.row.number': {
		en: 'Row number: %%',
		ar: 'رقم الصف (%%)',
	},
	'users.error.type': {
		en: 'Error type: %%',
		ar: 'نوع الخطأ : %%',
	},
	'users.download.errors.list': {
		en: 'Download errors list',
		ar: 'تنزيل قائمة الأخطاء',
	},
	'users.something.went.wrong': {
		en: 'Something went wrong.',
		ar: 'لقد حدث خطأ ما',
	},
	'dashboard.no.data.available': {
		en: 'Sorry, no data available for this period',
		ar: 'عذرا، لا توجد بيانات لهذه الفترة ',
	},
	'organizations.admins.deleted': {
		en: 'Admin users have been deleted',
		ar: 'تم حذف حسابات المشرفين ',
	},
	'organizations.managers.deleted': {
		en: 'Manager users have been deleted',
		ar: 'تم حذف حسابات المدراء ',
	},
	'try.again.button': {
		en: 'Try again',
		ar: 'المحاولة مرة أخرى',
	},
	'organizations.try.again': {
		en: "We couldn't download your organizations now. Please try again soon.",
		ar: 'لا يمكن تنزيل تفاصيل المؤسسة الآن. الرجاء المحاولة لاحقاً.',
	},
	'numbers.settings.try.again': {
		en: "We couldn't download number settings now.\nPlease try again soon.",
		ar: 'لم نتمكن من تنزيل إعدادت الرقم الآن، الرجاء المحاولة مرة أخرى لاحقا ',
	},
	'numbers.settings.try.again.button': {
		en: 'Try again',
		ar: 'الرجاء المحاولة مرة أخرى',
	},
	'users.delete.users': {
		en: 'Delete users?',
		ar: 'حذف المستخدم؟',
	},
	'users.are.you.sure.you.want.delete.all.users': {
		en: 'Are you sure you want to delete All users?',
		ar: 'هل أنت متأكد من رغبتك في حذف جميع المستخدمين؟',
	},
	'users.numbers.wont.be.assigned': {
		en: 'Numbers will be not assigned to any user anymore.',
		ar: 'الأرقام لن يتم تخصيصها للمستخدمين.',
	},
	'users.your.account.wont.be.deleted': {
		en: 'Your account will be not deleted.',
		ar: 'سيتم حذف الحساب.',
	},
	'users.are.you.sure.you.want.delete.selected.users': {
		en: 'Are you sure you want to delete selected users?',
		ar: 'هل أنت متأكد من رغبتك في حذف المستخدمين؟',
	},
	Morning: {
		en: 'Morning',
		ar: 'صباح',
	},
	Afternoon: {
		en: 'Afternoon',
		ar: 'بعد الظهر',
	},
	Evening: {
		en: 'Evening',
		ar: 'مساء',
	},
	'good.morning': {
		en: 'Good Morning',
		ar: 'صباح الخير',
	},
	'good.afternoon': {
		en: 'Good Afternoon',
		ar: 'مساء الخير',
	},
	'good.evening': {
		en: 'Good Evening',
		ar: 'مساء الخير',
	},
	'billing.account.add.recipient': {
		en: 'Add recipient',
		ar: 'إضافة مستلم',
	},
	'billing.account.edit.recipient': {
		en: 'Edit recipient',
		ar: 'تعديل المستلم',
	},
	info: {
		en: 'Info',
		ar: 'المعلومات',
	},
	download: {
		en: 'Download',
		ar: 'تنزيل',
	},
	upload: {
		en: 'Upload',
		ar: 'تحميل',
	},
	'company.name': {
		en: 'Company Name',
		ar: 'اسم الشركة',
	},
	'register.authorizedPersonName': {
		en: 'Authorised Person Name',
		ar: 'اسم الشخص المصرح له',
	},
	'register.username': {
		en: 'Suggested user name',
		ar: 'اسم مستخدم مقترح',
	},
	'register.crNumber': {
		en: 'Commercial Registration Number',
		ar: 'رقم السجل التجاري',
	},
	'register.mobileNumber': {
		en: 'Mobile Number',
		ar: 'رقم الهاتف المحمول',
	},
	'register.email': {
		en: 'Official email address',
		ar: 'عنوان بريد إلكتروني رسمي',
	},
	'register.alreadyHaveAccount': {
		en: 'Already have an account?',
		ar: 'لديك حساب؟',
	},
	'register.login': {
		en: 'Login',
		ar: 'تسجيل الدخول',
	},
	copyright: {
		en: 'Oman Telecommunications Company © 2020',
		ar: '© الشركة العمانية للإتصالات 2020',
	},
	'register.pleasePrint': {
		en: 'Print and Fill out Authorization Letter(PDF) on the company’s letterhead',
		ar: 'ارجو طباعة الرسالة على أوراق الشركة الرسمية',
	},
	'register.downloadLetter': {
		en: 'Download authorization letter',
		ar: 'تحميل رسالة التفويض',
	},
	'register.files.authPersonIdFile': {
		en: 'Printed and filled out authorization letter',
		ar: 'يرجى طباعة و تعبئة رسالة التفويض',
	},
	'register.files.idCopy1File': {
		en: 'Copy of ID of the authorized person (front side)',
		ar: 'نسخة من البطاقة الشخصية للشخص المفوض (الجهة الأمامية)',
	},
	'register.files.idCopy2File': {
		en: 'Copy of ID of the authorized person (back side)',
		ar: 'نسخة من البطاقة الشخصية للشخص المفوض (الجهة الخلفية)',
	},
	'register.files.crLicFile': {
		en: 'Copy of Commercial Registration License',
		ar: 'نسخة من السجل التجاري',
	},
	'register.files.municipalityLicFile': {
		en: 'Copy of municipality license',
		ar: 'نسخة من تصريح البلدية',
	},
	'register.files.authPersonIdFileInfo': {
		en:
			'Is a document authorizing the company representative to receive telecommunication service applications and to carry out and effect the electronic transactions and online services offered by the Omantel.',
		ar:
			'هي وثيقة تفوض ممثل الشركة لإستخدام تطبيقات خدمة الاتصالات وتنفيذ المعاملات الإلكترونية والخدمات عبر الانترنت التي تقدمها عمانتل.',
	},
	'register.files.idCopy1FileInfo': {
		en: 'Scan or take a photo of your ID document from both sides. The photos should be bright and clear.',
		ar: 'مسح أو إلتقاط صورة للبطاقة الشخصية الخاصة من من الأمام و الخلف. يجب أن تكون صورة البطاقة واضحة.',
	},
	'register.files.idCopy2FileInfo': {
		en: 'Scan or take a photo of your ID document from both sides. The photos should be bright and clear.',
		ar: 'مسح أو إلتقاط صورة للبطاقة الشخصية الخاصة من من الأمام و الخلف. يجب أن تكون صورة البطاقة واضحة.',
	},
	'register.successfullySubmitted': {
		en: 'Your form has been successfully submitted',
		ar: 'تم إرسال الطلب بنجاح',
	},
	'register.confirmationLetterSent': {
		en: 'Your request is under process and you will be contacted at the earliest.',
		ar: 'طلبك قيد التنفيذ وسيتم الاتصال بك في أقرب وقت ممكن.',
	},
	'register.backTo': {
		en: 'Back to Omantel Website',
		ar: 'العودة لموقع عمانتل',
	},
	'register.pleaseUpload': {
		en: 'Upload required files below:',
		ar: 'يرجى تحميل الملفات المطلوبة:',
	},
	'something.went.wrong': {
		en: 'Something went wrong',
		ar: 'لقد حدث خطأ ما',
	},
	'services.add.postpaid.line.no.tariff.plan': {
		en: 'Cannot add new postpaid line to selected billing account',
		ar: 'لا يمكن إضافة خط آجل الدفع في حساب الفوترة المختار',
	},
	'dashboard.some.info.can.be.missed': {
		en: 'Some billing accounts can be missed because of your limited access.',
		ar: 'بعض حسابات الفوترة غير متوفرة بسبب صلاحيات الوصول الخاصة بك.',
	},
	'departments.no.numbers.or.users.assigned': {
		en: 'No numbers or users assigned',
		ar: 'لم يتم تخصيص الأرقام أو المستخدمين',
	},
	'organizations.2.is.the.max.number.of.admins': {
		en: '*2 is the limit of admins accounts you can create',
		ar: '*2 عدد المشرفين المسموح إضافتهم',
	},
	'organization.admins.only.two.admins': {
		en: 'You can have only 2 active admins accounts.',
		ar: 'يمكنك إضافة عدد 2 من المشرفين للحساب..',
	},
	'set.password.already.have.account': {
		en: 'I already have an account.',
		ar: 'لدي حساب مسبقاً.',
	},
	'set.password.your.password.changed': {
		en: 'Your password has been changed',
		ar: 'تم تغير كلمة المرور الخاصة بك',
	},
	'set.password.new.password': {
		en: 'New password',
		ar: 'كلمة مرور جديدة',
	},
	'set.password.link': {
		en: 'Login',
		ar: 'تسجيل الدخول',
	},
	'set.password.sorry': {
		en: 'Sorry, the link you followed has expired.',
		ar: 'عذراً، انتهت صلاحية الوصلة.',
	},
	'set.password.contact': {
		en: 'Contact your administrator and ask to resend the link. \nHe will find it in your profile details.',
		ar: 'توصل مع مدير الحساب في عمانتل لإعادة إرسال الوصلة.',
	},
	'new.services.billing.account.name': {
		en: 'Billing Account Name / Number',
		ar: 'اسم حساب الفوترة / الرقم',
	},
	'thank.you': {
		en: 'Thank You',
		ar: 'شكراً لك',
	},
	you: {
		en: 'You',
		ar: 'أنت',
	},
	'add.user.email.address': {
		en: 'Email address (optional)',
		ar: 'عنوان البريد الإلكتروني (إختياري)',
	},
	'add.user.newUserAdded': {
		en: 'New user has been added',
		ar: 'تم إضافة مستخدم جديد',
	},
	'add.user.userWillReceiveEmail': {
		en: 'User will receive an email with a link to set a password.',
		ar: 'سيتلقى المستخدم بريد إلكتروني لتعيين كلمة المرور.',
	},
	send: {
		en: 'Send',
		ar: 'إرسال',
	},
	'file.too.big': {
		en: 'Sorry, your file is too big (max size is %%)',
		ar: 'عذراً، حجم الملف كبير جداً (الحد الاقصى  %%)',
	},
	'field.required': {
		en: 'Field required',
		ar: 'حقل مطلوب',
	},
	'organizations.additional-info.title': {
		en: 'Edit Organization Address',
		ar: 'تعديل عنوان المؤسسة',
	},
	'organizations.additional-info.success': {
		en: 'Data changed successfully',
		ar: 'تم تعديل البيانات بنجاح',
	},
	'cookies.text': {
		en:
			'We use cookies to improve your online experience and the service we offer. By using Omantel Enterprise, you accept our ',
		ar:
			'نستخدم ملفات تعريف الارتباط (cookies) .لنقوم بتحسين تجربتك على الإنترنت والخدمات التي نقدمها. لقبول العملية قم بتصفح الإنترنت كالمعتاد. للحصول على مزيد من المعلومات قم بقراءة سياسة ملفات تعريف الارتباط (cookies).',
	},
	'cookies.use': {
		en: 'use of cookies.',
		ar: 'استخدام معرفات الارتباط',
	},
	note: {
		en: 'Note:',
		ar: 'ملاحظة؛ ',
	},
	'number.services.downgrade': {
		en:
			'Downgrades will only be applicable from next month.\nDowngrade and upgrade is not allowed within the same month',
		ar:
			'باقات التخفيض ستنطبق فقط من الشهر المقبل\n.يمكنك ترقية الباقات في اي وقت من الشهر, و لكن لا يمكنك تغير الباقة الى باقة ادنى ',
	},
	'number.services.mobile.internet.plans': {
		en: 'Mobile Internet Plans',
		ar: 'رقم خطة إنترنت',
	},
	'number.services.mobile.gsm.services': {
		en: 'Mobile Services',
		ar: 'خدمات الهاتف النقال',
	},
	'number.services.mobile.jawazak.roaming': {
		en: 'Jawazak',
		ar: 'جوازك للتجوال',
	},
	'number.services.international': {
		en: 'International',
		ar: 'دولي',
	},
	'number.services.international.tooltip': {
		en: 'Service allows for making international calls from Oman',
		ar: 'يمكن إجراء المكالمات الدولية الصادرة من السلطنة',
	},
	'number.services.international.roaming': {
		en: 'Roaming + International',
		ar: 'التجوال + دولي',
	},
	'number.services.roaming': {
		en: 'Roaming',
		ar: 'التجوال',
	},
	'footer.privacyPolicy': {
		en: 'Privacy Policy',
		ar: 'سياسة الخصوصية',
	},
	'footer.copyrights': {
		en: 'Copyrights',
		ar: 'الملكية الفكرية',
	},
	'footer.sca': {
		en: 'Standard Customer Agreement',
		ar: 'إتفاقية العملاء المحددة',
	},
	'footer.contactUs': {
		en: 'For more information please contact your account manager or call ',
		ar: 'لمزيد من المعلومات ، يرجى الاتصال بمدير حسابك أو الاتصال على ',
	},
	'billing.account.ebills.updated': {
		en: 'Emails updated successfully',
		ar: 'تم تحديث البريد الإلكتروني بنجاح',
	},
	'billing.account.ebill.deleted': {
		en: 'Email deleted successfully',
		ar: 'تم حذف البريد الإلكتروني بنجاح',
	},
	'number.loading.packages': {
		en: 'Loading, give us a minute',
		ar: 'يتم التحميل، يرجى الإنتظار',
	},
	no: {
		en: 'No',
		ar: 'لا',
	},
	yes: {
		en: 'Yes',
		ar: 'نعم',
	},
	okay: {
		en: 'Okay',
		ar: 'نعم',
	},
	'add.user.you.reach.max.admins': {
		en: 'You have reached the max amount of admin users for all accounts.',
		ar: 'تم إضافة العدد المسموح به للمشرفين في جميع الدوائر.',
	},
	'add.user.you.can.create.without.permissions': {
		en: 'You can still create one but without any permissions.',
		ar: 'يمكنك إضافة واحد أيضا بدون صلاحيات.',
	},
	'add.user.max.amount.reached': {
		en: '*The max amount of admin users has been reached',
		ar: 'تم إضافة العدد المسموح به للمشرفين في جميع الدوائر.',
	},
	free: {
		en: 'FREE',
		ar: 'مجاناً',
	},
	'numbers.services.no.services.available.for.number': {
		en: 'Sorry, there are no services available for this number',
		ar: 'لا توجد خدمات متوفرة لهذا الرقم',
	},
	'input.sim.numberConsistsOf': {
		en: 'Serial Number consists of %% digits',
		ar: 'يتكون الرقم المتسلسل من %% أرقام',
	},
	'input.sim.numberShouldConsistOf': {
		en: 'Serial Number should consist of %% digits',
		ar: 'يتكون الرقم المتسلسل من  %% أرقام',
	},
	'input.sim.great': {
		en: 'Great! You have entered %% digits Serial Number',
		ar: 'ممتاز! قمت بإدخال  %% أرقام للرقم المتسلسل',
	},
	select: {
		en: 'Select',
		ar: 'أختر',
	},
	selected: {
		en: 'Selected',
		ar: 'المختار',
	},
	'number.services.terms.conditions': {
		en: 'Terms & conditions',
		ar: 'الشروط و الاحكام',
	},
	'number.services.jawazak.terms': {
		en:
			'Enjoy data roaming plans that will help you enhance your travel experience and  enjoy browsing the Internet and reading your e-mails worry-free.',
		ar:
			'استمتع بباقات تجوال البيانات التي ستساعدك على تحسين تجربة سفرك والاستمتاع بتصفح الإنترنت وقراءة رسائل البريد الإلكتروني دون قلق.',
	},
	'number.services.gobiz.terms': {
		en:
			'Enjoy unified rates for data, receiving calls, making calls to Oman & GCC, local calls and SMS in over 145 countries. Requires roaming service.',
		ar:
			'استمتع بالأسعار الموحدة للبيانات واستقبال المكالمات وإجراء المكالمات إلى سلطنة عمان ودول مجلس التعاون الخليجي والمكالمات المحلية والرسائل النصية القصيرة في أكثر من 145 دولة. تتطلب خدمة التجوال.',
	},
	'number.services.mobile.internet.terms': {
		en: '* Data plans with data sharing.',
		ar: '* خطة بيانات مع مشاركة البيانات',
	},
	'number.services.nama.CPN': {
		en: 'Nama CPN',
		ar: 'الشبكة الخاصة للأعمال التجارية',
	},
	'number.services.shortcode': {
		en: 'CPN Short Code',
		ar: 'الرمز المختصر CPN',
	},
	'number.services.shortcode.selected': {
		en: 'CPN Short Code - %%',
		ar: 'الرمز المختصر %% CPN',
	},
	'number.services.nama.CPN.activated': {
		en: 'Nama CPN has been activated.',
		ar: 'تم تفعيل Nama CPN.',
	},
	'number.services.nama.CPN.deactivated': {
		en: 'Nama CPN has been deactivated.',
		ar: 'تم تعطيل Nama CPN',
	},
	'number.services.nama.CPN.add.short.code': {
		en: 'You can add short code now.',
		ar: 'يمكنك إضافة الرمز المختصرالان',
	},
	'number.services.CPN': {
		en: 'CPN',
		ar: 'CPN',
	},
	'number.services.voice': {
		en: 'Voice only',
		ar: 'المكالمات الهاتفية فقط',
	},
	'number.services.sms': {
		en: 'SMS only',
		ar: 'الرسائل القصيرة فقط',
	},
	'number.services.additional.services': {
		en: 'Additional Services',
		ar: 'خدمات إضافية',
	},
	'number.services.static.ip': {
		en: 'Static IP',
		ar: 'عنوان البروتوكول الثابت',
	},
	'number.services.static.ip.select': {
		en: 'Select Static IP mode:',
		ar: ':حدد وضع IP الثابت',
	},
	'number.services.static.ip.description': {
		en: 'For more information about static IP mode, please contact your account manager or call 1235',
		ar: 'لمزيد من المعلومات حول وضع IP الثابت ، يرجى الاتصال بمدير حسابك أو الاتصال على 1235',
	},
	'number.services.static.ip.success': {
		en: 'Your request have been submitted successfully. Your reference number is: %%',
		ar: 'الرقم المرجعي الخاص بك هو. رقمك المرجعي هو: ٪٪',
	},
	'number.services.static.ip.cancel.title': {
		en: 'Turn off Static Ip?',
		ar: 'قم بإيقاف تشغيل Static Ip?',
	},
	'number.services.static.ip.cancel.description': {
		en: 'To cancel the services, please contact your account manager or call 1235',
		ar: 'لإلغاء الخدمات ، يرجى الاتصال بمدير حسابك أو الاتصال على 1235',
	},
	'number.services.static.ip.in.progress': {
		en: 'In progress',
		ar: 'في تقدم',
	},
	'number.services.cpn.activation': {
		en: 'Nama CPN Activation',
		ar: 'تفعيل Nama CPN',
	},
	'number.services.select.package': {
		en: 'Select Nama CPN package.',
		ar: 'حدد حزمة Nama CPN',
	},
	'number.services.voice&sms': {
		en: 'Voice & SMS',
		ar: 'المكالمات الهاتفية و الرسائل القصيرة',
	},
	'number.services.gobiz': {
		en: 'GoBiz',
		ar: 'GoBiz',
	},

	'department.not.assigned': {
		en: 'Not Assigned',
		ar: 'لم يتم التخصيص',
	},
	'username.not.assigned': {
		en: 'Not Assigned',
		ar: 'لم يتم التخصيص',
	},
	'permission-expired.description1': {
		en: 'Sorry, your access has expired.',
		ar: 'عذراً، انتهت صلاحية الوصول الخاصة بك.',
	},
	'permission-expired.description2': {
		en: 'Please contact your administrator for more information.',
		ar: 'تواصل مع المشرف الخاص بك للمزيد من التفاصيل.',
	},
	'dashboard.values.refer.to.organization': {
		en: '* The values shown above refer to the selected organization / account.',
		ar: ' * البيانات الموضحة أعلاه تعود للشركة المختارة/ الحساب',
	},
	'payments.topup.tabs.NumbersValue': {
		en: 'Numbers & Value',
		ar: 'الأرقام و المبلغ',
	},
	'payments.topup.tabs.Donation': {
		en: 'Donation',
		ar: 'تبرع',
	},
	'payments.topup.tabs.Payment': {
		en: 'Payment',
		ar: 'دفع',
	},
	'payments.topup.card.header': {
		en: 'Select top up amount for chosen numbers',
		ar: 'حدد مبلغ التعبئة للأرقام المختارة',
	},
	'payments.topup.card.tip': {
		en:
			'Tip: If you would like to customize top up amount for particular numbers you can do so by editing it on the list below. You can select multiple numbers first to make changes to more then one number.',
		ar:
			'نصيحة: إذا كنت ترغب في تخصيص مبلغ إعادة التعبئة لأرقام معينة، يمكنك إضافة الأرقام في القائمة أدناه. يمكنك تحديد أرقام متعددة أولاً لإجراء تغييرات على أكثر من رقم واحد.',
	},
	'payments.topup.correctEmail': {
		en: 'Great! You have entered the correct email address.',
		ar: 'لقد قمت بإدخال بريد إلكتروني صحيح.',
	},
	'payments.topup.externalNumber': {
		en: 'External Number',
		ar: 'الرقم الخارجي',
	},
	'payments.topup.payment.error.youReachedLimit.credit': {
		ar: 'لقد تجاوزت الحد المسموح به لاعادة التعبئة. الحد الأقصى المسموح به 120 ريال لكل عملية.',
		en: 'You have reached the Top up limit.  For credit card transaction limit is 1200 OMR.',
	},
	'payments.topup.payment.error.reduce.credit': {
		en: 'Reduce the total amount to proceed.',
		ar: 'يرجى تقليل قمية المبلغ للمتابعة.',
	},
	'payments.topup.payment.error.youReachedLimit.debit': {
		en: 'You have reached the Top up limit.  For debit card transaction limit is 2000 OMR.',
		ar: 'لقد تجاوزت الحد المسموح به لاعادة التعبئة. الحد الأقصى المسموح به 2000 ريال لكل عملية.',
	},
	'payments.topup.payment.error.reduce.debit': {
		en: 'Reduce the total amount to proceed.',
		ar: 'يرجى تقليل قمية المبلغ للمتابعة.',
	},
	'services.new.postpaid': {
		en: 'New line has been added',
		ar: 'تم إضافة خط هاتف جديد',
	},
	'payments.history.rowType.TOP_UP_NO_LOGIN': {
		en: 'No login',
		ar: 'لا يوجد بيانات',
	},
	'payments.paymentCard': {
		en: 'Payment Card',
		ar: 'بطاقة الدفع',
	},
	'register.files.authorizationLetterInfo': {
		en:
			'Is a document authorizing the company representative to receive telecommunication service applications and to carry out and effect the electronic transactions and online services offered by the Omantel.',
		ar:
			'هي وثيقة تفوض ممثل الشركة لإستخدام تطبيقات خدمة الاتصالات وتنفيذ المعاملات الإلكترونية والخدمات عبر الانترنت التي تقدمها عمانتل.',
	},
	'register.files.crLicFileInfo': {
		en: 'It is an upfront legal authorization used to allow practicing a restricted business activity.',
		ar: 'إذن قانوني يستخدم لممارسة نشاط تجاري مقيد.',
	},
	'register.files.municipalityLicFileInfo': {
		en: "It's a commercial license which depending on your business location.",
		ar: 'ترخيص تجاري اعتمادا على موقع عملك.',
	},
	'number.services.mobile.internet.plan': {
		en: 'Mobile Internet Plan',
		ar: 'باقة انترنت متنقل',
	},
	'number.services.mobile.nama.cpn.terms': {
		en: 'Subject to fair usage policy of 400 On-Net SMS per SIM card per month',
		ar: 'تخضع لسياسة الاستخدام العادل 400 رسالة نصية قصيرة ضمن شبكة عمانتل لكل بطاقة SIM شهريًا',
	},
	'number.services.CPN.not.activated': {
		en: "You don't have CPN billing account necessary to turn on the service",
		ar: 'ليس لديك حساب فواتير CPN',
	},
	'number.services.CPN.shortcode.added': {
		en: 'New shortcode has been added',
		ar: 'تمت إضافة الرمز المختصر الجديد',
	},
	'number.services.CPN.shortcode.added.you.can.use.it': {
		en: 'You can start using it now.',
		ar: 'يمكنك البدء في استخدامه الآن.',
	},
	'number.services.CPN.shortcode.failure': {
		en: "New shortcode can't be added",
		ar: 'ا يمكن إضافة الرمز المختصر الجديد',
	},
	'number.services.CPN.shortcode.deactivated': {
		en: 'Short Code has been deactivated.',
		ar: 'تم إلغاء الرمز المختصر',
	},
	'number.services.CPN.turn.off': {
		en: 'Are you sure you want to turn off the Nama CPN service? Your shortcode will be deactivated too.',
		ar: 'هل أنت متأكد أنك تريد إيقاف تشغيل خدمة Nama CPN؟ سيتم إلغاء الرمز المختصر الخاص بك أيضًا.',
	},
	'number.services.CPN.shortcode.are.you.sure': {
		en: 'Are you sure you want to turn off the Short Code?',
		ar: 'هل أنت متأكد أنك تريد إيقاف  الرمز المختصر؟',
	},
	'number.services.CPN.description': {
		en: 'Save With Unlimited Free Calls within the company.',
		ar: 'وفر مع مكالمات مجانية غير محدودة داخل الشركة.',
	},
	'number.services.CPN.description.sms': {
		en: 'Active package: SMS only (1.000 OMR/month)',
		ar: 'الباقة النشطة: رسائل نصية فقط (1.000 ريال عماني / شهر)',
	},
	'number.services.CPN.description.voice': {
		en: 'Active package: Voice only (1.000 OMR/month)',
		ar: 'الباقة النشطة: المكالمات الصوتية فقط (1.000 ريال عماني / شهر)',
	},
	'number.services.CPN.description.voice&sms': {
		en: 'Active package: Voice & sms (1.000 OMR/month)',
		ar: 'الباقة النشطة: المكالمات الهاتفية و الرسائل القصيرة (1.000 ر.ع / شهر)',
	},
	'number.services.CPN.shortcode.description': {
		en: 'Connect Faster With Short Dial Feature.',
		ar: 'تواصل أسرع مع ميزة الرمز المختصر',
	},
	'number.services.cpn.tooltip': {
		en: 'It is a private numbering plan that links a minimum of 5 or more people within the company.',
		ar: 'إنها خطة ترقيم خاصة تربط ما لا يقل عن 5 أشخاص أو أكثر داخل الشركة.',
	},
	'number.services.CPN.usage': {
		en: 'Usage - Unlimited minutes + Unlimited SMS per SIM*',
		ar: 'الاستخدام - دقائق غير محدودة + رسائل غير محدودة لكل شريحة *',
	},
	'number.services.CPN.package': {
		en: 'Package',
		ar: 'باقة',
	},
	'number.services.CPN.monthly.charge': {
		en: 'Monthly Charge',
		ar: 'الرسوم الشهرية',
	},
	'clear-all': {
		en: 'Clear all',
		ar: 'مسح الكل',
	},
	'add.new.line.choose.credit.limit': {
		en: 'Choose Credit Limit for the line',
		ar: 'اختر حد الائتمان للخط',
	},
	'add.new.line.choose.extra.services': {
		en: 'You can choose also extra services (optional):',
		ar: 'يمكن اختيار خدمات إضافية أيضاً (اختياري)::',
	},
	'add.new.line.addon.service.title': {
		en: 'Addon services',
		ar: 'الخدمات الإضافية',
	},
	'add.new.line.installation.title': {
		en: 'One time installation fees',
		ar: 'رسوم التركيب لمرة واحدة',
	},
	'add.new.line.installation.cost': {
		en: 'Installation Cost',
		ar: 'تكلفة التركيب',
	},
	'add.new.line.monthlycost': {
		en: 'Monthly Cost',
		ar: 'تكلفة شهرية',
	},
	'add.new.line.price': {
		en: '%% OMR',
		ar: '%% ريال',
	},
	'add.new.line.confirmation.email': {
		en: 'You will receive a confirmation email.',
		ar: 'سيصلك بريد إلكتروني لتأكيد.',
	},
	'add.new.line.postpaid': {
		en: 'Mobile Postpaid',
		ar: 'هاتف آجل الدفع',
	},
	'add.new.line.fixed.sending': {
		en: 'Sending request',
		ar: 'طلب إرسال',
	},
	'add.new.line.fixed.failed': {
		en: 'Request submission unsuccessful',
		ar: 'لم ينجح تقديم الطلب',
	},
	'add.new.line.fixed.sent': {
		en: 'Request submitted successfully',
		ar: 'تم تقديم الطلب بنجاح',
	},
	'add.new.line.fixed.request': {
		en:
			'Your request has been submitted successfully, for more information, please contact your account manager or call 1235)',
		ar: 'تم تقديم طلبك بنجاح. للمزيد من المعلومات ، يرجى الاتصال بمدير حسابك أو الاتصال بالرقم 1235.\nرقم الطلب',
	},
	'add.new.line.fixed.requestFailed': {
		en: 'Your request was not successfull, for more information, please contact your account manager or call 1235',
		ar: 'تم تقديم طلبك بنجاح. للمزيد من المعلومات ، يرجى الاتصال بمدير حسابك أو الاتصال بالرقم 1235.\nرقم الطلب',
	},
	'add.new.line.fixed.requestId': {
		en: 'Request ID:%%',
		ar: 'رقم الطلب:%%',
	},
	'add.new.line.fixed.location': {
		en: 'Location',
		ar: 'موقعك',
	},
	'add.new.line.fixed.title': {
		en: 'Select your current location',
		ar: 'حدد موقعك الحالي',
	},
	'add.new.line.fixed.lines': {
		en: 'Lines',
		ar: 'خطوط',
	},
	'add.new.line.fixed.lines.title': {
		en: 'Enter a custom name and add lines as needed',
		ar: 'أدخل اسمًا مخصصًا وأضف خطوطًا حسب الحاجة',
	},
	'add.new.line.fixed.lines.subtitle': {
		en: '* maximum 4 lines',
		ar: 'يمكنك فقط طلب خطوط متعددة في نفس الموقع.',
	},
	'add.new.line.fixed.lines.addMoreLines': {
		en: 'Add more lines',
		ar: 'يمكنك فقط طلب خطوط متعددة في نفس الموقع.',
	},
	'add.new.line.fixed.lines.addMoreLinesInfo': {
		en: 'Contact your account manager or call 1235 if you need more than 4 lines.',
		ar: 'يمكنك فقط طلب خطوط متعددة في نفس الموقع.',
	},
	'add.new.line.fixed.requesterName': {
		en: 'Requester Name',
		ar: 'اسم مقدم الطلب',
	},
	'add.new.line.fixed.contactNumber': {
		en: 'Contact Number',
		ar: 'رقم الاتصال',
	},
	'add.new.line.fixed.addPlan': {
		en: 'Build your plan',
		ar: 'قم ببناء خطتك',
	},
	'add.new.line.fixed.removePlan': {
		en: 'Remove your plan',
		ar: 'قم ببناء خطتك',
	},
	'add.new.line.fixed.deleteLine': {
		en: 'Delete',
		ar: 'حذف',
	},
	'add.new.line.fixed.location.details': {
		en: 'Location Details',
		ar: 'تفاصيل الموقع',
	},
	'add.new.line.fixed.location.governorate': {
		en: 'Governorate',
		ar: 'المحافظة',
	},
	'add.new.line.fixed.location.willayat': {
		en: 'Region',
		ar: 'منطقة',
	},
	'add.new.line.fixed.location.town': {
		en: 'City / Village',
		ar: 'المدينة / القرية',
	},
	'add.new.line.fixed.location.buildingNumber': {
		en: 'House Number',
		ar: 'رقم المنزل',
	},
	'add.new.line.fixed.location.wayNumber': {
		en: 'Way Number',
		ar: 'رقم السكة',
	},
	'add.new.line.fbb.sending': {
		en: 'Sending request',
		ar: 'طلب إرسال',
	},
	'add.new.line.fbb.failed': {
		en: 'Failed',
		ar: 'فشل',
	},
	'add.new.line.fbb.sent': {
		en: 'Successfully sent',
		ar: 'أرسلت بنجاح',
	},
	'add.new.line.fbb.location': {
		en: 'Location',
		ar: 'موقعك',
	},
	'add.new.line.fbb.title': {
		en: 'Select your current location',
		ar: 'حدد موقعك الحالي',
	},
	'add.new.line.fbb.lines': {
		en: 'Lines',
		ar: 'خطوط',
	},
	'add.new.line.fbb.lines.title': {
		en: 'How many lines would you like to add?',
		ar: 'كم عدد الأرقام التي تريد إضافتها؟',
	},
	'add.new.line.fbb.lines.subtitle': {
		en: 'You may only request for multiple lines at the same location.',
		ar: 'يمكنك فقط طلب خطوط متعددة في نفس الموقع.',
	},
	'add.new.line.fbb.files': {
		en: 'Files',
		ar: 'الملفات',
	},
	'add.new.line.fbb.requesterName': {
		en: 'Requester Name',
		ar: 'اسم مقدم الطلب',
	},
	'add.new.line.fbb.contactNumber': {
		en: 'Contact Number',
		ar: 'رقم الاتصال',
	},
	'add.new.line.fbb.addPlan': {
		en: 'Add Plan',
		ar: 'أضف خطة',
	},
	'add.new.line.fbb.deleteLine': {
		en: 'Delete Line',
		ar: 'حذف الخط',
	},
	'add.new.line.fbb.location.details': {
		en: 'Location Details',
		ar: 'تفاصيل الموقع',
	},
	'add.new.line.fbb.location.governorate': {
		en: 'Governorate',
		ar: 'المحافظة',
	},
	'add.new.line.fbb.location.willayat': {
		en: 'Region',
		ar: 'منطقة',
	},
	'add.new.line.fbb.location.town': {
		en: 'City / Village',
		ar: 'المدينة / القرية',
	},
	'add.new.line.fbb.location.buildingNumber': {
		en: 'House Number',
		ar: 'رقم المنزل',
	},
	'add.new.line.fbb.location.wayNumber': {
		en: 'Way Number',
		ar: 'رقم السكة',
	},
	'add.new.line.bestTime': {
		en: 'Best Time To Contact',
		ar: 'افضل وقت للاتصال',
	},
	'add.new.line.alreadyHave': {
		en: 'I already have a working number at the requested location',
		ar: 'لدي رقم مفعل في الموقع المطلوب',
	},
	'add.new.line.workingNumber': {
		en: 'Working Number',
		ar: 'الرقم المفعل',
	},
	'add.new.line.workingNumber.description': {
		en: 'Please enter your fixed line number',
		ar: 'يرجى إدخال رقم الخط الثابت الخاص بك',
	},
	'add.new.line.pstn.planTitle': {
		en: 'Select best plan for you',
		ar: 'اختر الباقة المناسبة لك ',
	},
	'add.new.line.plansServices': {
		en: 'Plans & Services',
		ar: 'الخطط والخدمات',
	},
	'add.new.line.plansServices.title': {
		en: 'Build your plan and add services for each line',
		ar: 'قم ببناء خطتك وإضافة الخدمات لكل خط',
	},
	'add.new.line.plansServices.subtitle': {
		en: '* maximum 4 lines',
		ar: 'يمكنك فقط طلب خطوط متعددة في نفس الموقع.',
	},
	'add.new.line.validate.name': {
		en: 'Validate name',
		ar: 'تحقق من الاسم',
	},
	'add.new.line.fixed.dialog.title': {
		en: 'Edit your plan',
		ar: 'قم بتعديل خطتك',
	},
	'edit-plan.fixed.dialog.success': {
		en: 'Plan changed successfully',
		ar: 'تم تغيير الخطة بنجاح',
	},
	'add.new.line.fixed.locationTab.buildingNumber': {
		en: 'Building No',
		ar: 'رقم البناية',
	},
	'add.new.line.fixed.locationTab.poBox': {
		en: 'PO Box',
		ar: 'صندوق البريد',
	},
	'add.new.line.fixed.locationTab.postalCode': {
		en: 'Postal Code',
		ar: 'الرمز البريدي',
	},
	'add.new.line.fixed.locationTab.wayNumber': {
		en: 'Way No',
		ar: 'رقم السكة',
	},
	'add.new.line.fbb.files.title': {
		en: 'Files',
		ar: 'الملفات',
	},
	'add.new.line.fbb.dialog.title': {
		en: 'Edit your plan',
		ar: 'قم بتعديل خطتك',
	},
	'add.new.line.fbb.dialog.plan.title': {
		en: 'Select contract duration & plan',
		ar: 'اختر مدة العقد والخطة',
	},
	'add.new.line.fbb.username': {
		en: 'Business Broadband Username',
		ar: 'اسم الحساب',
	},
	'add.new.line.fbb.usernameWithNumber': {
		en: 'Business Broadband Username %%',
		ar: 'اسم المستخدم لخدمة الإنترنت فائق السرعة',
	},
	'add.new.line.fbb.dialog.required': {
		en: 'Select required services',
		ar: 'حدد الخدمات المطلوبة',
	},
	'add.new.line.fbb.dialog.local': {
		en: 'Local (Oman only without calls to GSM)',
		ar: 'محلي (عمان فقط بدون مكالمات إلى الهاتف المتنقل)',
	},
	'add.new.line.fbb.dialog.national': {
		en: 'National (Oman only with calls to GSM)',
		ar: 'المكالمات المحلية (عمان فقط مع مكالمات إلى الهاتف المتنقل)',
	},
	'add.new.line.fbb.dialog.international': {
		en: 'International (All)',
		ar: 'المكالمات الدولية (الكل)',
	},
	'add.new.line.fbb.dialog.extra': {
		en: 'Select extra services (optional)',
		ar: 'حدد الخدمات الإضافية (اختياري)',
	},
	'add.new.line.fbb.dialog.plan': {
		en: 'Plan',
		ar: 'خطة',
	},
	'add.new.line.fbb.dialog.additional': {
		en: 'Additional Services',
		ar: 'خدمات إضافية',
	},
	'add.new.line.fbb.dialog.additional.serviceType': {
		en: 'Service Type',
		ar: 'نوع الخدمة',
	},
	'add.new.line.fbb.dialog.additional.monthlyFee': {
		en: 'Monthly Fee',
		ar: 'رسوم شهرية',
	},
	'add.new.line.fbb.dialog.additional.installationFee': {
		en: 'Installation Fee',
		ar: 'رسوم التركيب',
	},
	'add.new.line.contract.duration.0': {
		en: 'Contract: No commitment',
		ar: 'العقد: لا يوجد التزام',
	},
	'add.new.line.contract.duration.12': {
		en: '1 year Contract',
		ar: 'العقد: 1 سنة',
	},
	'add.new.line.contract.duration.24': {
		en: '2 years Contract',
		ar: 'العقد: 2 سنة',
	},
	'add.new.line.contract.duration.36': {
		en: '3 years Contract',
		ar: 'عقد لمدة 3 سنوات',
	},
	'add.new.line.name.error': {
		en: 'Login already used %%', // need to change arabic
		ar: 'العقد: %% سنة',
	},
	'add.new.line.forbiddenword.error': {
		en: 'Please choose a different UserId',
		ar: 'الرجاء اختيار اسم مستخدم مختلف',
	},
	'add.new.line.special.error': {
		en: 'UserId can not have special characters except _',
		ar: 'اسم المستخدم يجب الا يبدأ بأحرف خاصة مثل (؟ , * - ; )',
	},

	'add.new.line.length.error': {
		en: 'UserId should be between 5 to 16 characters',
		ar: 'يجب ان يكون اسم المستخدم مكون من 5 الى 16 حروف او ارقام',
	},
	'add.new.line.start.error': {
		en: 'UserId can not start with numeric values',
		ar: 'اسم المستخدم يجب الا يبدأ برقم',
	},
	'add.new.line.only.english.error': {
		en: 'UserId should contain only English alphabets',
		ar: 'يجب ان يكون اسم المستخدم مكون من حروف باللغة الانجليزيه (small case only)',
	},

	'add.new.line.validity': {
		en: 'Valid till',
		ar: 'صالح لغاية',
	},
	'order.summary.contract.duration': {
		en: '%% years Contract',
		ar: 'العقد: %% سنة',
	},
	'add.new.line.fixed.summary.services.header.service': {
		en: 'Service Type',
		ar: 'نوع الخدمة',
	},
	'add.new.line.fixed.summary.services.header.oneTimeFee': {
		en: 'One Time Installation Charge',
		ar: 'رسوم التركيب لمرة واحدة',
	},
	'add.new.line.fixed.summary.services.header.monthlyFee': {
		en: 'Monthly Charge',
		ar: 'الرسوم الشهرية',
	},
	'add.new.line.fixed.summary.monthlyCost': {
		en: 'Monthly Cost',
		ar: 'تكلفة شهرية',
	},
	'add.new.line.fixed.order.title': {
		en: 'Order',
		ar: 'طلب',
	},
	'add.new.line.fixed.order.subtitle': {
		en: 'Order Summary',
		ar: 'ملخص الطلب',
	},
	'add.new.line.fixed.contact.requesterName': {
		en: 'Requester Name',
		ar: 'اسم مقدم الطلب',
	},
	'add.new.line.fixed.contact.contactNumber': {
		en: 'Contact Number',
		ar: 'رقم الاتصال',
	},
	'add.new.line.fixed.contact.bestTime': {
		en: 'Best Time To Contact',
		ar: 'افضل وقت للاتصال',
	},
	'add.new.line.fixed.contact.workingNumber': {
		en: 'Working Number',
		ar: 'الرقم المفعل',
	},
	'add.new.line.fixed.contact.details': {
		en: 'Contact Details',
		ar: 'بيانات المتصل',
	},
	'add.new.line.fixed.files.description': {
		en: 'Please upload required file below:',
		ar: 'يرجى تحميل الملف المطلوب أدناه:',
	},
	'add.new.line.fixed.files.location': {
		en: 'Location coordinates (Krooki)',
		ar: 'إحداثيات الموقع (الكروكي)',
	},
	'add.new.line.fixed.files.tooltip': {
		en: 'Krooki is a plan of your land, that is provided to you by Ministry of Housing.',
		ar: 'كروكي هو خطة لأرضك، تُقدم لك من قبل وزارة الإسكان.',
	},
	'add.new.line.fbb.summary.services.header.service': {
		en: 'Service Type',
		ar: 'نوع الخدمة',
	},
	'add.new.line.fbb.summary.services.header.oneTimeFee': {
		en: 'One Time Installation Charge',
		ar: 'رسوم التركيب لمرة واحدة',
	},
	'add.new.line.fbb.summary.services.header.monthlyFee': {
		en: 'Monthly Charge',
		ar: 'الرسوم الشهرية',
	},
	'add.new.line.fbb.summary.monthlyCost': {
		en: 'Monthly Cost',
		ar: 'تكلفة شهرية',
	},
	'add.new.line.fbb.order.title': {
		en: 'Order',
		ar: 'طلب',
	},
	'add.new.line.fbb.order.subtitle': {
		en: 'Order Summary',
		ar: 'ملخص الطلب',
	},
	'add.new.line.fbb.contact.requesterName': {
		en: 'Requester Name',
		ar: 'اسم مقدم الطلب',
	},
	'add.new.line.fbb.contact.contactNumber': {
		en: 'Contact Number',
		ar: 'رقم الاتصال',
	},
	'add.new.line.fbb.contact.bestTime': {
		en: 'Best Time To Contact',
		ar: 'افضل وقت للاتصال',
	},
	'add.new.line.fbb.contact.workingNumber': {
		en: 'Working Number',
		ar: 'الرقم المفعل',
	},
	'add.new.line.fbb.contact.details': {
		en: 'Contact Details',
		ar: 'بيانات المتصل',
	},
	'manager.resend.activation.email': {
		en: 'Resend activation email',
		ar: 'إعادة إرسال البريد الإلكتروني للتفعيل',
	},
	'user.details.email.sent.date': {
		en: 'Email sent %%',
		ar: '%% تم إرسال البريد الإلكتروني',
	},
	'user.details.activation.email.toast.title': {
		en: 'Activation Email:',
		ar: 'البريد الإلكتروني المفعل:',
	},
	'user.details.activation.email.toast.message': {
		en: 'Activation Email has been sent',
		ar: 'تم إرسال البريد الإلكتروني للتفعيل',
	},
	'user.details.set.department': {
		en: 'Assign to Department?',
		ar: 'تعيين للدائرة؟',
	},
	'user.details.set.department.areYouSure': {
		en: 'Are you sure you want to assign the user to the Department?',
		ar: 'هل ترغب في تعيين المستخدم لهذه الدائره؟',
	},
	'user.details.set.department.warning': {
		en: 'User numbers will be assigned to the selected Department.',
		ar: 'رقم المستخدم سيتم تعيينه للدائرة المختارة.',
	},
	'user.details.numbers.detached': {
		en: 'Numbers detached successfully.',
		ar: 'تم فصل الأرقام بنجاح.',
	},
	'organization.managers.more': {
		en: '+ %% more',
		ar: '+ %% المزيد',
	},
	'lock.screen.you.have.been.logged.out': {
		en: 'For security reason, you have been logged out.',
		ar: 'للخصوصية و الأمان، تم تسجيل خروجك.',
	},
	'add.new.line.internet.plan.not.selected': {
		en: 'You have to choose Mobile Internet Plan',
		ar: 'يجب اختيار خط هاتف انترنت متنقل',
	},
	'number.services.mobile.internet.plan.default': {
		en: 'None - Pay as you go',
		ar: 'لا يوجد - الدفع حسب الاستخدام',
	},
	'number.services.mobile.internet.plan.turn.off.confirmation': {
		en: 'Once this service is turned off, you will switch to Pay as you go plan, higher charges will apply',
		ar: 'بمجرد إيقاف تشغيل هذه الخدمة ، ستنتقل إلى خطة الدفع الفوري. سيتم تطبيق رسوم أعلى',
	},
	'number.services.default.turn.off.confirmation': {
		en: 'Are you sure you want to turn off %% service?',
		ar: 'هل أنت متأكد من رغبتك في إلغاء تفعيل خدمة %%؟',
	},
	'number.services.default.top.up.confirmation': {
		en: 'Are you sure you want to top up %% service?',
		ar: 'هل أنت متأكد أنك تريد اضافة خدمة ال %% ؟',
	},
	'number.services.default.turn.on.confirmation': {
		en: 'Are you sure you want to activate %% service?',
		ar: 'هل أنت متأكد من رغبتك في تفعيل خدمة %% ؟',
	},
	'number.services.mobile.internet.plan.turn.off.confirmation.title': {
		en: 'Are you sure you want to turn off this service?',
		ar: 'هل أنت متأكد أنك تريد إيقاف تشغيل هذه الخدمة',
	},
	'number.services.new.service.turned.off': {
		en: 'Service has been turned off',
		ar: 'تم إلغاء تنشيط الخدمة',
	},
	'number.services.new.service.request.received': {
		en: 'Your request is received and might take a while to process.',
		ar: 'تم تلقي طلبك وقد تستغرق معالجته بعض الوقت',
	},
	'number.services.new.service.turned.on': {
		en: 'New service has been turned on',
		ar: 'تم تنشيط الخدمة الجديدة',
	},
	'number.services.confirmation.email': {
		en: 'You will receive confirmation email.',
		ar: 'سوف تتلقى رسالة تأكيد بالبريد الإلكتروني.',
	},
	'number.services.confirmation.asynchronous.activation.part.one': {
		en: 'Please note that the activation can take a while.',
		ar: 'يرجىى الملاحظة: التفعيل قد يستغرق بعض الوقت.',
	},
	'number.services.confirmation.asynchronous.activation.part.two': {
		en: 'Once the plan is activated it will appear on the list.',
		ar: 'بمجرد التفعيل,   ستظهر  الباقة في القائمة',
	},
	'number.services.confirmation.asynchronous.deactivation.part.one': {
		en: 'Please note that deactivation can take a while.',
		ar: ' ملاحظة : تعطيل الخدمة قد يستغرق بعض الوقت.',
	},
	'number.services.confirmation.asynchronous.deactivation.part.two': {
		en: 'Once the plan is deactivated it will disappear from the list.',
		ar: 'ستختفي الباقة من القائمة بمجرد إلغاء تنشيطها',
	},
	'number.services.confirmation.loading': {
		en: 'Please wait, it can take a while.',
		ar: 'يُرجى الانتظار ، فقد يستغرق الأمر بعض الوقت.',
	},
	'number.services.error.multiactivate': {
		en: 'You are not allowed to activate this product multiple times.',
		ar: 'غير مسموح لك بتنشيط هذا المنتج عدة مرات.',
	},
	'dashboard.chart.label': {
		en: '%% [OMR]',
		ar: '%% [ريال]',
	},
	'services.add.postpaid.line.clone.plan': {
		en: 'Clone plan and tariff from',
		ar: 'نسخ الباقة و التعرفة من',
	},
	'services.add.postpaid.line.no.tariff.plan.for.number': {
		en: 'Cannot find tariff plan for the selected number',
		ar: 'لا يمكن العثور على الخطة التعريفة للرقم المحدد',
	},
	'services.add.postpaid.line.select.phone.number': {
		en: 'Choose plan and tariff',
		ar: 'اختر الخطة والتعرفة',
	},
	'services.add.postpaid.line.new.line.based.on.current.plan': {
		en:
			'Any new line you wish to add through our self-care has to be based on one of your current plans and tariffs. Simply select the line number that contains of the plan and tariff you require for the new line and we will set up new number with the same plan and tariff.',
		ar:
			'يجب أن يعتمد أي خط جديد ترغب في إضافته من خلال الخدمة الذاتية لدينا على إحدى خططك وتعريفاتك الحالية. ما عليك سوى تحديد رقم الخط الذي يحتوي على الخطة والتعرفة التي تطلبها للخط الجديد وسنقوم بإعداد رقم جديد بنفس الخطة والتعرفة.',
	},
	'services.add.postpaid.line.the.same.plan.details': {
		en: 'You can only select numbers from the billing account that you are currently working on.',
		ar: 'يمكنك فقط تحديد أرقام من حساب الفوترة الذي تعمل عليه حاليًا',
	},
	'number.details.monthly.subscription': {
		en: 'Monthly subscription:',
		ar: 'الاشتراك الشهري',
	},
	colon: {
		en: '%%:',
		ar: ':%%',
	},
	'active.services.add.billing.account': {
		en: 'Add Billing Account',
		ar: 'إضافة حساب الفواتير',
	},
	'active.services.billing.account.name': {
		en: 'Billing Account Name',
		ar: 'اسم الحساب للفواتير',
	},
	'active.services.billing.account.number': {
		en: 'Billing Account Number',
		ar: 'رقم الحساب للفواتير',
	},
	'active.services.add.billing.account.select.organization': {
		en: 'Select organization to add a new billing account.',
		ar: 'حدد مؤسسة لإضافة حساب فوترة جديد',
	},
	'active.services.add.billing.account.name.your.billing.account': {
		en: 'Name your billing account to make it easy to find it.',
		ar: 'قم بتسمية حساب الفواتير الخاص بك لتسهيل العثور عليه',
	},
	'active.services.add.billing.account.account.details': {
		en: 'Account Details',
		ar: 'تفاصيل الحساب',
	},
	'active.services.add.billing.account.verification': {
		en: 'Verification',
		ar: 'التحقق',
	},
	'active.services.delete.billing.account.no.contact.number': {
		en: 'You can’t delete a billing account for organization with no contact number assigned.',
		ar: 'لا يمكنك حذف حساب الفوترة للمؤسسة مع عدم تعيين رقم اتصال',
	},
	'active.services.delete.billing.account.subheader': {
		en: 'You are about to delete billing account %% (%%).',
		ar: 'أنت على وشك حذف حساب الفوترة %% (%%).',
	},
	'active.services.add.billing.account.you.will.receive.password': {
		en: 'You will shortly receive a 5-digits password on your mobile number:',
		ar: 'ستتلقى قريبًا كلمة مرور مكونة من 5 أرقام على رقم هاتفك:',
	},
	'active.services.add.billing.account.enter.password': {
		en: 'Enter it below to confirm your action.',
		ar: 'أدخله أدناه لتأكيد الإجراء الخاص بك',
	},
	'active.services.add.billing.account.your.password.valid.for': {
		en: 'Your OTP is valid for',
		ar: 'إن OTP الخاص بك صالح لمدة',
	},
	'active.services.add.billing.account.have.not.received.text': {
		en: 'Haven’t received the text?',
		ar: 'لم تتلق النص؟',
	},
	'active.services.add.billing.account.password.expired': {
		en: 'Your password expired.',
		ar: 'انتهت صلاحية كلمة المرور الخاصة بك',
	},
	'active.services.add.billing.account.request.sent': {
		en: 'Request to add a new billing account has been sent.',
		ar: 'تم إرسال طلب إضافة حساب فوترة جديد',
	},
	'active.services.add.billing.account.resend.token': {
		en: 'Resend password',
		ar: 'إعادة إرسال كلمة المرور',
	},
	'active.services.add.billing.account.request.sent.additional.info': {
		en:
			'This usually takes 5 - 10 minutes. By that time your account should be added and ready to work with. Once it’s done - you’ll receive confirmation email.',
		ar:
			'تستغرق هذه العملية عادةً من 5 إلى 10 دقائق ، وبعدها سيكون حسابك جاهزًا للعمل. بمجرد الانتهاء من العملية - ستتلقى رسالة تأكيد',
	},
	'active.services.add.billing.account.no.contact.number': {
		en: 'You can’t add new billing account to an organization with no contact number assigned.',
		ar: 'لا يمكنك إضافة حساب فوترة جديد لمؤسسة لم يتم تعيين رقم اتصال لها',
	},
	'active.services.add.billing.account.please.contact.omantel': {
		en: 'Please contact Omantel to update your contact number.',
		ar: 'يرجى الاتصال بعمانتل لتحديث رقم الاتصال الخاص بك',
	},
	'active.services.add.billing.account.no.contact.number.assigned': {
		en: 'You can’t add new billing account with no contact number assigned to your organization.',
		ar: 'لا يمكنك إضافة حساب فوترة جديد دون تحديد رقم اتصال لمؤسستك',
	},
	'active.services.add.billing.account.incorrect.password': {
		en: 'Not a valid OTP',
		ar: 'ليس OTP صالحًا',
	},
	'active.services.add.billing.account.technical.problems': {
		en: 'Sorry! We’re having some technical problems. Please try again later.',
		ar: 'المعذرة! نحن نواجه بعض المشاكل التقنية. الرجاء معاودة المحاولة في وقت لاحق',
	},
	'active.services.add.billing.account.no.numbers': {
		en: "This billing account doesn't have any numbers assigned.",
		ar: 'لم يتم تعيين أي أرقام لحساب الفوترة هذا',
	},
	'active.services.add.billing.account.incorrect.account.corporate': {
		en: 'Incorrect billing account number.',
		ar: 'رقم حساب الفوترة غير صحيح',
	},
	'active.services.add.billing.account.incorrect.account.enterprise': {
		en: 'Incorrect billing account number for selected organization.',
		ar: 'رقم حساب الفوترة غير صحيح للمؤسسة المحددة',
	},
	'active.services.add.billing.account.account.exists': {
		en: 'This account number already exists. Please try another one.',
		ar: 'رقم الحساب هذا مفعل. يرجى محاولة حساب آخر.',
	},
	'active.services.add.billing.account.verification.not.sent': {
		en: 'There was a problem sending verification password. Please try again.',
		ar: 'حدثت مشكلة في إرسال كلمة مرور التحقق. حاول مرة اخرى',
	},
	'number.services.change.credit.limit.you.can.only.change.credit.limit': {
		en:
			'You can only change your credit limit to the amount higher than your currently used credit. You may only reduce the limit at the start of every month.',
		ar:
			'يمكنك فقط تغيير حد الائتمان الخاص بك إلى مبلغ أعلى من رصيدك المستخدم حاليًا. يمكنك تخفيض الحد فقط في بداية كل شهر.',
	},
	'number.services.change.credit.limit.change.after.monthly.limit.resets': {
		en:
			'If the selected amount is lower than the credit used, set higher value or make the change after monthly limit resets.',
		ar:
			'إذا كان المبلغ المحدد أقل من الرصيد المستخدم ، فقم بتعيين قيمة أعلى أو قم بإجراء التغيير بعد إعادة تعيين الحد الشهري.',
	},
	'number.details.services.activate.shortcode': {
		en: 'Activate Shortcode',
		ar: 'تفعيل الرمز المختصر',
	},
	'number.details.services.edit.shortcode': {
		en: 'Edit Short Code',
		ar: 'اضافة الرمز المختصر ',
	},
	'number.details.services.activate.shortcode.description': {
		en:
			'Connect Faster With Short dial Feature, create your short code by choosing 3 to 5 digits for your GSM number and get started.',
		ar:
			'تواصل بشكل اسرع مع خاصية الرمز المختصر,قم بإنشاء رمز قصير عن طريق اختيار 3 إلى 5 أرقام لرقم الهاتف النقال الخاص بك وابدأ الان',
	},
	'number.details.services.shortcode': {
		en: 'Short code',
		ar: ' الرمز المختصر',
	},
	'number.details.services.shortcode.helper.text': {
		en: 'Should contain %%-%% digits.',
		ar: 'يجب أن يحتوي%%%%أرقام',
	},
	'orders.filtersHeader': {
		en: 'Orders list',
		ar: 'قائمة الطلبات',
	},
	'orders.column.requestName': {
		en: 'Request Name',
		ar: 'اسم الطلب',
	},
	'orders.column.requestID': {
		en: 'Request ID',
		ar: 'رقم الطلب',
	},
	'orders.column.requestType': {
		en: 'Request Type',
		ar: 'نوع الطلب',
	},
	'orders.column.userName': {
		en: 'User Name',
		ar: 'اسم المستخدم',
	},
	'orders.column.status': {
		en: 'Status',
		ar: 'الحالة',
	},
	'orders.tableComment': {
		en: 'If you need more information call our contact center 847 561 903.',
		ar: ' للمزيد من المعلومات ، اتصل بمركز الاتصال الخاص بنا',
	},
	'donations.background.title': {
		en: 'Hey!',
		ar: 'أهلاً!',
	},
	'donations.background.description': {
		en: 'Join Omantel in helping those in need. Gift a donation to a charity of your choosing.',
		ar: 'شارك عمانتل في عمل الخير. تبرع للجمعيات الخيرية.',
	},
	'donations.background.action-primary': {
		en: 'Donate',
		ar: 'تبرع',
	},
	'donations.background.action-secondary': {
		en: 'Edit donation',
		ar: 'تعديل التبرع',
	},
	'donations.dialog.header': {
		en: 'Donation for charity',
		ar: 'التبرع للأعمال الخيرية',
	},
	'donations.dialog.select.charity': {
		en: 'Select a charity you want to make a donation for:',
		ar: 'اختر مؤسسة خيرية ترغب في التبرع لها:',
	},
	'donations.dialog.select.how.much': {
		en: 'How much you’d like to donate?',
		ar: 'حدد مبلغ التبرع؟',
	},
	'donations.exposed.cta': {
		en: 'Support the good cause!',
		ar: 'شاركنا فعل الخير!',
	},
	'donations.thank.you': {
		en: 'Thank you!',
		ar: 'شكرا جزيلا!',
	},
	'donations.you.are.great': {
		en: 'You’re great!',
		ar: 'أنت رائع!',
	},
	'donations.thank.you.for.help': {
		en: 'Thank you for willing to help!',
		ar: 'شكرا على استعدادك للمساعدة!',
	},
	'donations.top.up.card': {
		en: '+ donation %% OMR',
		ar: '+ ٪٪ ريال عماني - التبرع',
	},
	'donations.dialog.error': {
		en: 'Donation should be greater than zero',
		ar: 'يجب أن تكون قيمة التبرع أكثر من صفر',
	},
	price: {
		en: '%% OMR',
		ar: '%% ريال',
	},
	'price.with.dot': {
		en: '%% OMR.',
		ar: '%% ريال.',
	},
	'sidebar.search.placeholder': {
		en: 'Search numbers or users',
		ar: 'البحث في الأرقام أو المستخدمين',
	},
	'add.new.service.nama-plans': {
		en: 'Mobile - Postpaid - New line',
		ar: 'الهاتف النقال - آجل الدفع - رقم جديد',
	},
	'add.new.service.business-data': {
		en: 'Mobile - Data - New line',
		ar: 'الهاتف النقال - بيانات - خط جديد',
	},
	'add.new.service.fiber-pro': {
		en: 'Fiber Pro',
		ar: 'باقات الفايبر الإحترافي',
	},
	'add.new.service.fixed': {
		en: 'Fixed Line',
		ar: 'خط ثابت',
	},
	'add.new.service.aamali-plus': {
		en: "Add A'amali+",
		ar: 'إضافة أعمالي+',
	},
	'current.plan': {
		en: 'Current plan',
		ar: 'الخطة الحالية',
	},
	'loading.it.can.take.a.while': {
		en: 'Please wait, it can take a while',
		ar: 'الرجاء الإنتظار، يمكن أن يأخذ وقتا ',
	},
	'contact.title': {
		en: 'Register a complaint Ticket',
		ar: 'تسجيل شكوى',
	},
	'contact.form.type': {
		en: 'Type',
		ar: 'اطبع هنا ',
	},
	'contact.form.subject': {
		en: 'Subject',
		ar: 'الموضوع',
	},
	'contact.form.message': {
		en: 'Your message',
		ar: 'رسالتك',
	},
	'contact.tickettracking.header': {
		en: 'Track your ticket',
		ar: 'تتبع بلاغك',
	},
	'contact.tickettracking.subheader': {
		en: 'Please enter the Ticket number associated with your complaint: (Ex. IM1234567)',
		ar: 'يرجى إدخال رقم البلاغ: (مثال: IM8736478455)',
	},
	'contact.tickettracking.error.subheader': {
		en: 'Sorry, incorrect entry. Please enter the ticket number associated with your complaint (Ex. IM8736478455)',
		ar: 'عذرا، الرقم المدخل غير صحيح. يرجى إدخال رقم البلاغ الصحيح (مثال: IM8736478455)',
	},
	'contact.tickettracking.inputTitle': {
		en: 'Enter ticket No. ...',
		ar: 'ادخل رقم البلاغ..',
	},
	'contact.tickettracking.buttonLabel': {
		en: 'Track',
		ar: 'تتبع',
	},
	'contact.tickettracking.success.header': {
		en: 'Ticket No.',
		ar: 'رقم البلاغ',
	},
	'contact.tickettracking.success.status': {
		en: 'Status',
		ar: 'الحالة',
	},
	'contact.tickettracking.success.statusText1': {
		en: 'Your complaint issued on ',
		ar: 'بلاغك المرفع في ',
	},
	'contact.tickettracking.moreInformationNeeded': {
		en: 'More information is needed on your ticket raised on ',
		ar: 'مطلوب مزيد من المعلومات حول بلاغك الذي تم رفعه في ',
	},
	'contact.tickettracking.success.statusText2.under.process': {
		en: ' is under process.',
		ar: ' قيد المعاينة.',
	},
	'contact.tickettracking.success.statusText2.accepted': {
		en: ' has been accepted.',
		ar: ' تم قبوله.',
	},
	'contact.tickettracking.success.statusText2.closed': {
		en: ' is closed.',
		ar: ' تم إغلاقه.',
	},
	'contact.tickettracking.success.statusText2.completed': {
		en: ' has been resolved.',
		ar: ' تم معالجته',
	},
	'contact.tickettracking.success.statusText2.withdrawn': {
		en: ' is withdrawn.',
		ar: ' تم سحبه.',
	},
	'contact.tickettracking.success.buttonLabel': {
		en: 'Track another',
		ar: 'تتبع بلاغ آخر',
	},
	'contact.tickettracking.error.header': {
		en: 'Wrong ticket No.!',
		ar: 'رقم البلاغ غير صحيح',
	},
	'contact.info.header': {
		en: 'Contact Customer Care',
		ar: 'تواصل مع خدمة العملاء',
	},
	'contact.info.subheader': {
		en: 'Available 24/7',
		ar: 'متاح 24/7',
	},
	'contact.info.description': {
		en:
			'Our Customer care is a 24 hour service which Omantel customers and other members of the public can call to make enquiries about our products and services.',
		ar:
			'مركز خدمة المشتركين الخاص بنا هو مركز يعمل على مدار الساعة ومن خلاله يمكن لمشتركي عمانتل وباقي الجمهور الإتصال للإستفسار عن المنتجات والعروض.',
	},
	'contact.info.simplyDial1': {
		en: 'Simply dial ',
		ar: 'ما عليك سوى الاتصال بالرقم ',
	},
	'contact.info.simplyDial2': {
		en:
			' to report faults or to make general enquiries about mobile services, fixed line and internet services. You can call from your mobile or fixed line from anywhere in Oman and our dedicated call centre representatives will be happy to answer your queries.',
		ar:
			' للإبلاغ عن الأعطال أو للاستفسارات حول خدمات الهاتف المحمول والخطوط الثابتة وخدمات الإنترنت. يمكنك الاتصال من هاتفك المحمول أو الخط الثابت من أي مكان في سلطنة عمان وسيسعد ممثلو مركز الاتصال بالإجابة على استفساراتك.',
	},
	'contact.info.ourCallCentre': {
		en:
			'Our highly trained and motivated call centre representatives offer reliable, efficient and flexible customer service.',
		ar: 'يقدم موظفو خدمة العملاء لدينا خدمات عملاء موثوقة وفعالة ومرنة',
	},
	'contact.info.calls': {
		en: 'Calls to our call center are FREE for Omantel subscribers.',
		ar: 'المكالمات إلى مركز الاتصال الخاص بنا مجانية لمشتركي عمانتل',
	},
	'contact.sending': {
		en: 'Sending',
		ar: 'ارسال',
	},
	'contact.newMessage': {
		en: 'New Message',
		ar: 'رسالة جديدة',
	},
	'contact.messageSent': {
		en: 'Message has been sent',
		ar: 'تم ارسال الرسالة',
	},
	'contact.ticketRegistered': {
		en: 'Your ticket has been registered in the system with the number: ',
		ar: 'تم تسجيل الشكوى  في النظام بالرقم: ',
	},
	'contact.followTicketStatus1': {
		en: 'You can follow the ticket status in the ',
		ar: 'يمكنك متابعة حالة الشكوى في ',
	},
	'contact.followTicketStatus2': {
		en: ' section under the Track your ticket section',
		ar: ' من قسم تتبع بلاغك ',
	},
	'contact.ticketResolved.moreInformation': {
		en: 'For more information, please contact your account manager or call ',
		ar: 'لمزيد من المعلومات ، يرجى الاتصال بمدير حسابك أو الاتصال على',
	},
	'contact.ticketResolved.you.will.be.contacted.earliest.possible': {
		en:
			'You will be contacted at the earliest possible, for more information, please contact your account manager or call ',
		er: 'سيتم الاتصال بك في أقرب وقت ممكن. لمزيد من المعلومات ، يرجى الاتصال بمدير حسابك أو الاتصال على',
	},
	'chat.how': {
		en: 'How can we help? Chat now...',
		ar: 'كيف يمكننا مساعدتك؟ دردش الان',
	},
	'chat.bar': {
		en: 'Omantel Chat',
		ar: 'عمانتل- دردشة',
	},
	'chat.form.category': {
		en: 'Select category:',
		ar: 'اختر الفئة:',
	},
	'chat.form.type': {
		en: 'Select enquiry type:',
		ar: 'حدد نوع الاستفسار',
	},
	'chat.button': {
		en: 'Connect with Omantel consultant',
		ar: 'تواصل مع  عمانتل',
	},
	'chat.info': {
		en: 'Chat available from 8:00 AM - 7:00 PM (Gulf Time Zone (UTC+04:00)) from Sunday to Thursday.',
		ar: 'لدردشة متاحة من 8:00 صباحًا إلى 7:00 مساءً (منطقة الخليج الزمنية (UTC + 04:00)) من الأحد إلى الخميس.',
	},
	'chat.category.FixedLine': {
		en: 'FixedLine',
		ar: 'الخط الثابت',
	},
	'chat.category.Mobile': {
		en: 'Mobile',
		ar: 'الهاتف النقال ',
	},
	'chat.category.Corporate': {
		en: 'Corporate',
		ar: 'الشركات',
	},
	'chat.type.billing': {
		en: 'Billing And Payments',
		ar: 'الفواتير والدفع',
	},
	'chat.type.network': {
		en: 'Network Coverage',
		ar: 'تغطية الشبكة',
	},
	'chat.type.makasib': {
		en: 'Makasib',
		ar: 'مكاسب',
	},
	'chat.type.internet': {
		en: 'Internet',
		ar: 'الإنترنت',
	},
	'chat.type.activation': {
		en: 'New activation',
		ar: 'تفعيل رقم  جديد',
	},
	'chat.type.others': {
		en: 'Others',
		ar: 'خدمات اخرى',
	},
	'bills.pay.any.bill': {
		en: 'Pay any bill',
		ar: 'ادفع أي فاتورة',
	},
	'bills.pay.selected': {
		en: 'Pay selected',
		ar: 'دفع المختارة',
	},
	'bills.selected.bills': {
		en: 'Selected bills',
		ar: 'فواتير مختارة',
	},
	'bills.selected': {
		en: 'Bills selected',
		ar: 'تم تحديد الفواتير',
	},
	'bills.toast.action': {
		en: 'Payment confirmed',
		ar: 'تم تأكيد الدفع',
	},
	bills: {
		en: 'Bills',
		ar: 'الفواتير',
	},
	'bills.look.for.bills': {
		en: 'Look for bills',
		ar: 'ابحث عن الفواتير',
	},
	'bills.any.radio.mobileNumber': {
		en: 'Mobile Number',
		ar: 'رقم الهاتف المحمول',
	},
	'bills.any.radio.billingAccountNo': {
		en: 'Billing Account No',
		ar: 'رقم حساب الفواتير',
	},
	'bills.any.radio.billNo': {
		en: 'Bill No',
		ar: 'رقم الفاتوره',
	},
	'bills.any.radio.mobileNumber.input': {
		en: 'Type Mobile Number',
		ar: ' اكتب رقم الهاتف',
	},
	'bills.any.radio.billingAccountNo.input': {
		en: 'Type Billing Account No',
		ar: 'رقم حساب الفواتير',
	},
	'bills.any.radio.billNo.input': {
		en: 'Type Bill No',
		ar: 'اكتب رقم الفاتورة',
	},
	'bills.payment': {
		en: 'Payment',
		ar: 'الدفع',
	},
	'bills.pay.in.seconds': {
		en: 'Pay any bill in seconds.',
		ar: 'ادفع أي فاتورة في ثوان.',
	},
	'bills.type.phone.number': {
		en: 'Search bills by mobile number, billing account number or bill number.',
		ar: 'البحث في الفواتير عن طريق رقم الهاتف المحمول أو رقم حساب الفواتير',
	},
	'bills.see.bills': {
		en: 'See bills',
		ar: 'الفواتير',
	},
	'bills.type.phone.number.label': {
		en: 'Type mobile number',
		ar: ' اكتب رقم الهاتف',
	},
	'bills.helper.text': {
		en: 'Please input Omantel number',
		ar: 'الرجاء إدخال رقم عمانتل',
	},
	'bills.error.text': {
		en: "Sorry, it's not an Omantel number.",
		ar: 'عذرا ، الرقم الذي أدخلته ليس في قائمة ارقام عمانتل',
	},
	'bills.no.bills': {
		en: 'No bills to display',
		ar: 'ا توجد فواتير للعرض',
	},
	'bills.payment.enter.card.details': {
		en: 'Enter credit card details',
		ar: 'أدخل تفاصيل بطاقة الائتمان',
	},
	'bills.payment.confirmed': {
		en: 'You have paid selected bills',
		ar: 'لقد دفعت الفواتير المحددة',
	},
	'top.up.successful': {
		en: 'Top-up successful',
		ar: 'تم إضافة الرصيد بنجاح',
	},
	'top.up.successful.description': {
		en: 'Congratulations! Your top-up is successful. Stay connected and enjoy your uninterrupted communication!',
		ar: 'مبروك! لقد تمت عملية تعبئة رصيدك بنجاح. ابق على اتصال واستمتع باتصالاتك دون انقطاع!',
	},
	'add.on.successful': {
		en: 'Add-ons successful',
		ar: 'الإضافات ناجحة',
	},
	'numbers.assign.user.dialog.mobile-postpaid': {
		en: 'Mobile - Postpaid',
		ar: 'رقم آجل الدفع',
	},
	'numbers.assign.user.dialog.internet-postpaid': {
		en: 'FBB - Postpaid',
		ar: 'باقات الإنترنت فائق السرعة - الدفع الآجل',
	},
	'numbers.assign.user.dialog.fix-postpaid': {
		en: 'Fixed Line - Postpaid',
		ar: 'الخط الثابت - الدفع الآجل',
	},
	'numbers.assign.user.dialog.mobile-prepaid': {
		en: 'Mobile - Prepaid',
		ar: 'رقم مسبق الدفع',
	},
	'services.table.pstn.LOC_MIN_COST': {
		en: 'Calls to mobile & other operators',
		ar: 'المكالمات إلى الهواتف المحمولة والمشغلين الآخرين',
	},
	'services.table.pstn.INCLUDED_MINUTES': {
		en: 'Included free minutes',
		ar: 'الدقائق المجانية المشمولة',
	},
	'services.table.pstn.FIXED_CALLS': {
		en: 'Calls to Fixed Lines',
		ar: 'المكالمات إلى الخطوط الثابتة',
	},
	'services.table.pstn.PEAK': {
		en: 'PEAK',
		ar: 'الذروة',
	},
	'services.table.pstn.OFF_PEAK': {
		en: 'OFF-PEAK',
		ar: 'غير الذروة',
	},
	'services.table.per.month': {
		en: 'per month',
		ar: 'للشهر ',
	},
	'services.table.vat-price': {
		en: 'Total price with VAT: %% %%',
		ar: 'إجمالي المبلغ شامل ضريبة القيمة المضافة: %% %%',
	},
	'services.table.data.allowance.global': {
		en: 'Data Allowance Global',
		ar: 'بدل البيانات العالمية',
	},
	'services.table.unified.roaming.rates': {
		en: 'Unified Roaming Rates for Out of Bundle',
		ar: 'أسعار التجوال الموحدة خارج الباقة',
	},
	'services.table.at.gobiz.destination.light': {
		en: 'At gobiz destination - GoBiz light',
		ar: 'ي وجهات GoBiz light ',
	},
	'services.table.at.gobiz.destination': {
		en: 'At gobiz destination',
		ar: 'ي وجهات GoBiz  ',
	},
	'services.table.receive.calls': {
		en: 'Receive Calls, Call Oman & Call Local',
		ar: 'استقبال المكالمات,اتصال إلى عمان, اتصال محلي',
	},
	'services.table.fbb.HBB_DOWN_SPEED': {
		en: 'Download speed',
		ar: 'سرعة التنزيل',
	},
	'services.table.fbb.HBB_UP_SPEED': {
		en: 'Upload speed',
		ar: 'سرعة الرفع',
	},
	'services.table.fbb.HBB_MAIL_INC': {
		en: 'Email accounts',
		ar: 'حسابات البريد الإلكتروني',
	},
	'services.table.fbb.subtitle': {
		en: 'Fixed Broadband',
		ar: 'النطاق العريض الثابت',
	},
	'services.table.fbbPro.subtitle': {
		en: 'Fiber Pro',
		ar: 'باقات الفايبر الإحترافي',
	},
	'services.table.booster.subtitle': {
		en: 'Booster',
		ar: 'باقات الفايبر الإحترافي',
	},
	'services.table.fbbPro.new': {
		en: '(New)',
		ar: '(النطاق)',
	},
	'services.table.fbb.discount': {
		en: '%%% discount',
		ar: '%%% خصم',
	},
	'services.table.fbb.discount.subtitle': {
		en: 'International Calls',
		ar: 'مكالمات دولية',
	},
	'services.table.fbb.INCLUDED_MINUTES': {
		en: 'Calls to mobile',
		ar: 'المكالمات إلى الهاتف المحمول',
	},
	'add.new.line.fbb.plan.discount': {
		en: 'Discount',
		ar: 'خصم',
	},
	'add.new.line.fbb.plan.price': {
		en: 'Price',
		ar: 'السعر',
	},
	'services.table.fbb.noCommitment': {
		en: 'No commitment',
		ar: 'لا يوجد التزام',
	},
	'services.table.fbb.1year': {
		en: '1 year contract',
		ar: 'عقد سنة',
	},
	'services.table.fbb.2years': {
		en: '2 years contract',
		ar: 'عقد سنتين',
	},
	'services.table.fbb.3years': {
		en: '3 years contract',
		ar: 'عقد 3 سنوات',
	},
	'services.table.SMS': {
		en: 'SMS',
		ar: 'رسائل',
	},
	'services.table.data.allowance': {
		en: 'Data Allowance',
		ar: 'البيانات المضافة',
	},
	'services.table.data.allowance.oman': {
		en: 'Data Allowance in Oman',
		ar: 'البيانات المضافة داخل السلطنة',
	},
	'number.services.gobiz.description': {
		en:
			'GoBiz offers unified rates for data, receiving calls, making calls to Oman & GCC, local calls and SMS in over 145 countries.',
		ar:
			'تقدم GoBiz أسعارًا موحدة للبيانات واستقبال المكالمات وإجراء المكالمات إلى عمان ودول مجلس التعاون الخليجي والمكالمات المحلية والرسائل النصية القصيرة في أكثر من 145 دولة.',
	},
	'number.services.gobiz.activation': {
		en: 'GoBiz Activation',
		ar: 'تفعيل GoBiz',
	},
	'number.services.gobiz.top.up': {
		en: 'GoBiz Top Up',
		ar: 'إعادة تعبئة GoBiz',
	},
	'number.services.gobiz.change.plan': {
		en: 'Change GoBiz plan',
		ar: 'GoBiz تغير خطة',
	},
	'number.services.gobiz.select.plan': {
		en: 'Select GoBiz plan',
		ar: 'اختر حزمة GoBiz',
	},
	'number.services.gobiz.turn.off.confirmation.title': {
		en: 'Turn off GoBiz?',
		ar: 'هل تريد إيقاف  حزمة GoBiz؟',
	},
	'number.services.gobiz.turn.off.confirmation': {
		en: 'Are you sure you want to deactivate %%?',
		ar: 'هل تريد إلغاء الخدمة%%؟',
	},
	'number.services.price': {
		en: '(%% %% per month)',
		ar: 'للشهر %%',
	},
	'jawazak.table.gcc': {
		en: 'Jawazak GCC',
		ar: 'جوازك دول الخليج',
	},
	'jawazak.table.world': {
		en: 'Jawazak World',
		ar: 'جوازك حول العالم',
	},
	'jawazak.table.roaming.data.allowance': {
		en: 'Roaming Data Allowance',
		ar: 'بدل بيانات التجوال',
	},
	'jawazak.table.day': {
		en: '%% DAY',
		ar: ' %%يوم ',
	},
	'jawazak.table.days': {
		en: '%% DAYS',
		ar: '%% ايام ',
	},
	'jawazak.table.validity': {
		en: 'Validity',
		ar: 'الصلاحية',
	},
	'number.services.jawazak.gcc': {
		en: 'Jawazak GCC',
		ar: 'جوازك دول الخليج',
	},
	'number.services.jawazak.description': {
		en:
			'Enjoy data roaming plans that will help you enhance your travel experience and  enjoy browsing the Internet and reading your e-mails worry-free. Requires roaming service.',
		ar:
			'استمتع بخطط تجوال البيانات التي ستساعدك على تحسين تجربة سفرك والاستمتاع بتصفح الإنترنت وقراءة رسائل البريد الإلكتروني الخاصة بك دون قلق. هّذه الخدمة تتطلب تفعيل خدمة التجوال.',
	},
	'number.services.mobile.internet.plans.description': {
		en:
			'Do you use the internet a lot?\n' +
			'Then you would definitely benefit from subscribing to one of our packages of Mobile Internet',
		ar:
			'هل تستخدم الانترنت كثيرا؟\n' +
			'في هذه الحالة ستستفيد من الاشتراك في أحد حزمنا من الإنترنت عبر الهاتف النقال',
	},
	'number.services.jawazak.activation': {
		en: 'Jawazak  Activation',
		ar: 'تفعيل جوازك',
	},
	'number.services.jawazak.edit': {
		en: 'Edit Jawazak',
		ar: 'اضافة خدمة جوازك',
	},
	'number.services.jawazak.select.package': {
		en: 'Select Jawazak plan and package',
		ar: 'اختر باقةجوازك',
	},
	'number.services.jawazak.one.plan': {
		en: 'You can subscribe to one plan.',
		ar: 'يمكنك الاشتراك في خطة واحدة.',
	},
	'number.services.jawazak.subscribe.again': {
		en: 'You can subscribe again after consuming the included data within your existing plan.',
		ar: 'يمكنك الاشتراك مرة أخرى بعد استهلاك البيانات المضمنة في باقتك الحالية.',
	},
	'number.services.jawazak.turn.off.header': {
		en: 'Turn off Jawazak?',
		ar: 'إيقاف تشغيل خدمة الجوازك؟',
	},
	'number.services.jawazak.turn.off.body.gcc': {
		en: 'Are you sure you want to deactivate Jawazak? Jawazak GCC will deactivate.',
		ar: 'هل أنت متأكد أنك تريد إلغاء تفعيل جوازك؟ سيتم تعطيل جوازك دول مجلس التعاون الخليجي.',
	},
	'number.services.jawazak.turn.off.body.world': {
		en: 'Are you sure you want to deactivate Jawazak? Jawazak World will deactivate.',
		ar: 'هل أنت متأكد أنك تريد إلغاء تفعيل جوازك؟ سيتم إلغاء تنشيط جوازك حول العالم',
	},
	'number.services.accept.terms.and.conditions': {
		en: 'I accept Terms & Conditions',
		ar: 'أوافق على الشروط والأحكام',
	},
	'number.services.accept.terms.and.conditions.error': {
		en: 'In order to continue, please accept our Terms and Conditions.',
		ar: 'للمتابعة ، يرجى قبول الشروط والأحكام الخاصة بنا.',
	},
	'services.monthly.fee': {
		en: 'Monthly Fee: %%',
		ar: 'رسوم شهرية: %%',
	},
	'number.services.international.activation': {
		en: 'International Minutes Activation',
		ar: 'تفعيل International Minutes',
	},
	'number.services.international.top.up': {
		en: 'International Minutes Top Up',
		ar: 'إعادة تعبئة International Minutes',
	},
	'number.services.international.change.plan': {
		en: 'Change International Minutes plan',
		ar: 'International Minutes تغير خطة',
	},
	'services.installation.fee': {
		en: 'Installation Fee: %%',
		ar: 'رسوم التركيب: %%',
	},
	'number.services.cpn.shortcode.forbidden': {
		en: 'Sorry, this code is forbidden',
		ar: 'عذرا ، هذا الرمز ممنوع',
	},
	'services.fix.description.fee': {
		en: 'Installation Fee: %% OMR, Monthly Fee: %% OMR',
		ar: 'رسوم التركيب: %% ريال, رسوم شهرية: %% ريال',
	},
	'number.services.roaming.required': {
		en: 'Roaming required',
		ar: 'الرجاء تفعيل خدمة التجوال',
	},
	'number.services.international.required': {
		en: 'International required',
		ar: 'الرجاء تفعيل الخدمات الدولية',
	},
	'number.services.JAWAZAK.roaming.required.description': {
		en: 'In order to activate Jawazak package, you need to turn on roaming services.',
		ar: 'لتفعيل باقة جوازك تحتاج إلى تشغيل خدمات التجوال.',
	},
	'number.services.GOBIZ.roaming.required.description': {
		en:
			'In order to activate Gobiz service, you have to turn on the Roaming first. Do you want to turn it on now? ',
		ar: 'لتفعيل خدمة Gobiz ، عليك تشغيل التجوال أولاً. هل تريد تشغيله الآن؟',
	},
	'number.services.roaming.required.description.pending': {
		en:
			'The request for roaming service is still processing, once the order is completed, you may proceed with your next request.',
		ar: 'لا يزال طلب خدمة التجوال قيد المعالجة ، وبمجرد اكتمال الطلب ، يمكنك متابعة طلبك التالي.',
	},
	'number.services.international.minutes.international.required.description': {
		en: 'In order to activate international minutes package, you need to turn on international services.',
		ar: 'لتفعيل باقة الدقائق الدولية تحتاج إلى تشغيل الخدمات الدولية.',
	},
	'number.services.international.minutes.international.required.description.pending': {
		en:
			'The request for international service is still processing, once the order is completed, you may proceed with your next request.',
		ar: 'لا يزال طلب الخدمة الدولية قيد المعالجة ، وبمجرد اكتمال الطلب ، يمكنك متابعة طلبك التالي.',
	},
	'number.services.international.minutes.description': {
		en: 'Requires international service.',
		ar: 'الرجاء تفعيل الخدمة الدولية',
	},
	'number.services.international.minutes.activation': {
		en: 'International Minutes Activation',
		ar: 'تفعيل الدقائق الدولية',
	},
	'number.services.international.select.package': {
		en: 'Select International Minutes package.',
		ar: 'اختر باقة الدقائق الدولية.',
	},
	'number.services.international.with.auto.renewal': {
		en: 'With Auto Renewal',
		ar: 'مع التجديد التلقائي',
	},
	'number.services.international.without.auto.renewal': {
		en: 'Without Auto Renewal',
		ar: 'بدون تجديد تلقائي',
	},
	'bills.pay.any.bill.works.inside.organization': {
		en: 'Works only inside your organization.',
		ar: 'يعمل فقط داخل مؤسستك.',
	},
	'bills.pay.any.bill.billing.account.doesnt.belong.to.organization': {
		en: "This number doesn't belong to your organization.",
		ar: 'هذا الرقم غير مدرج باسم الشركة.',
	},
	'services.international.minutes.destinations': {
		en: 'International minutes destinations',
		ar: 'وجهات الدقائق الدولي',
	},
	'services.international.minutes.dialog.codes': {
		en: 'Dialing Codes (USA, Australia, Canada)',
		ar: 'رموز الاتصال (الولايات المتحدة الأمريكية ، أستراليا ، كندا)',
	},
	'services.international.minutes.country.on.the.list': {
		en: 'Please check if the country you are interested in is on the list.',
		ar: 'يرجى التحقق مما إذا كانت الدولة التي تهتم بها مدرجة في القائمة.',
	},
	'services.roaming.activation': {
		en: 'In terms of service activation, Roaming service will be activated.',
		ar: 'فيما يتعلق بتفعيل الخدمة ، سيتم تفعيل خدمة التجوال.',
	},
	'services.international.activation': {
		en: 'In terms of service activation, Mobile International service will be activated',
		ar: 'فيما يتعلق بتفعيل الخدمة ، سيتم تفعيل الاتصال الدولي.',
	},
	'services.international.conditions.first.part': {
		en: '1. International minutes package rental is not eligible for international call discount of the bundle.',
		ar: '1. تأجير باقة الدقائق الدولية غير مؤهل للحصول على خصم المكالمات الدولية للباقة.',
	},
	'services.international.conditions.second.part': {
		en:
			'2. Minutes over the package allowance and to destinations not included in the list, will be charged standard international calling rates, and will get international call discount of the bundle, if any.',
		ar:
			'2. سيتم احتساب الدقائق التي تزيد عن رصيد الباقة وإلى وجهات غير مدرجة في القائمة ، بأسعار المكالمات الدولية القياسية ، وستحصل على خصم المكالمات الدولية من الباقة ، إن وجدت.',
	},
	'shortcuts.admin.on.the.go': {
		en: 'Admin on the go',
		ar: 'Admin on the go',
	},
	'shortcuts.admin.on.the.go.description': {
		en: 'Select the number you want to manage, and use Admin On The Go functions',
		ar: 'حدد الرقم الذي تريد إدارته، واستخدم وظائف Admin On The Go',
	},
	'shortcuts.go.to.full.version': {
		en: 'Go to full version SelfCare >',
		ar: 'انتقل إلى النسخة الكاملة من الخدمة الذاتية >',
	},
	'shortcuts.TryAndBuy': {
		en: 'Try and Buy',
		ar: 'جرب واشترك',
	},
	'shortcuts.Topup': {
		en: 'Top up',
		ar: 'تعبئة الرصيد',
	},
	'shortcuts.view.pay.bills': {
		en: 'View/Pay bills',
		ar: 'عرض / دفع الفواتير',
	},
	'shortcuts.add.new.services': {
		en: 'Add new services',
		ar: 'إضافة خدمة جديدة',
	},
	turnOn: {
		en: 'Turn On',
		ar: 'تفعيل',
	},
	'number.services.top.up': {
		en: 'Top Up',
		ar: 'إعادة التعبئة',
	},
	'number.services.manage': {
		en: 'Manage',
		ar: 'يدير',
	},
	'number.services.enable': {
		en: 'Enable',
		ar: 'يمكن',
	},
	'number.services.jawazak.gcc.package.name': {
		en: 'Jawazak GCC - %% %%, 1 day',
		ar: 'جوازك دول مجلس التعاون الخليجي - %% %% 1 يوم',
	},
	'number.services.jawazak.world.package.name': {
		en: 'Jawazak World - %% %%, 1 day',
		ar: 'جوازك حول العالم - %% %% 1 يوم',
	},
	'number.services.jawazak.gcc.package.name.days': {
		en: 'Jawazak GCC - %% %%, %% days',
		ar: 'جوازك دول مجلس التعاون الخليجي - %% %%  يوم',
	},
	'number.services.jawazak.world.package.name.days': {
		en: 'Jawazak World - %% %%, %% days',
		ar: 'جوازك حول العالم - %% %%يوم',
	},
	'number.services.jawazak.gcc.active.package.name': {
		en: 'Jawazak GCC - %%, 1 day',
		ar: 'جوازك دول مجلس التعاون الخليجي - %% 1 يوم',
	},
	'number.services.jawazak.world.active.package.name': {
		en: 'Jawazak World - %%, 1 day',
		ar: 'جوازك حول العالم - %% 1 يوم',
	},
	'number.services.jawazak.gcc.active.package.name.days': {
		en: 'Jawazak GCC - %%, %% days',
		ar: 'جوازك دول مجلس التعاون الخليجي - %%  يوم',
	},
	'number.services.jawazak.world.active.package.name.days': {
		en: 'Jawazak World - %%, %% days',
		ar: 'جوازك حول العالم - %% يوم',
	},
	'number.services.jawazak.package.description': {
		en: '1 package, total package size: %% %%, valid till: %%',
		ar: 'حزمة واحدة ، إجمالي حجم الحزمة %% %% ، صالح حتى: %%',
	},
	'number.services.gobiz.packages.description': {
		en: '%% valid till: %%',
		ar: '%% صالح حتى: %%',
	},
	'number.services.international.packages.description': {
		en: '%% valid till: %%',
		ar: '%% صالح حتى: %%',
	},
	'number.services.jawazak.packages.description': {
		en: '%% packages, total package size: %% %%, valid till: %%',
		ar: '%% حزم ، إجمالي حجم الحزمة: %% %% ، صالح حتى: %%',
	},
	'number.services.international.minutes.package.one.time.description': {
		en: '1 package - one time, total package size: %% minutes, valid till: %%',
		ar: 'حزمة واحدة - مرة واحدة ، إجمالي حجم الحزمة: %% دقيقة ، صالحة حتى: %%',
	},
	'number.services.international.minutes.packages.one.time.description': {
		en: '%% packages - one time, total package size: %% minutes, valid till: %%',
		ar: 'حزم %% - مرة واحدة ، إجمالي حجم الحزمة: %% دقيقة ، صالحة حتى: %%',
	},
	'number.services.international.minutes.package.monthly.renewable.description': {
		en: '1 package - monthly renewable, total package size: %% minutes, valid till: %%',
		ar: 'حزمة واحدة - قابلة للتجديد شهريًا ، إجمالي حجم الحزمة: %% دقيقة ، صالحة حتى: %%',
	},
	'usage.valid.till': {
		en: 'Valid till: %%',
		ar: 'صالح لغاية: %%',
	},
	'usage.monthly.renewable': {
		en: 'Monthly renewable',
		ar: 'قابلة للتجديد شهريا',
	},
	'usage.one.time': {
		en: 'One time',
		ar: 'مره واحده',
	},
	'wallet.no.cards.added': {
		en: 'No cards added yet.',
		ar: 'لم تتم إضافة بطاقات حتى الآن',
	},
	'wallet.you.can.add.card': {
		en: 'You can add a new card during the payment process.',
		ar: 'يمكنك إضافة بطاقة جديدة أثناء عملية الدفع.',
	},
	'wallet.delete.card': {
		en: 'Delete Card',
		ar: 'حذف البطاقة',
	},
	'wallet.card.deleted': {
		en: 'Card has been deleted.',
		ar: 'تم حذف البطاقة.',
	},
	'wallet.bm.deleted': {
		en: 'Alias Id has been deleted.',
		ar: 'تم حذف معرف الدفع المستعار',
	},
	'wallet.confirmation.delete.card': {
		en: 'Delete card?',
		ar: 'حذف البطاقة؟',
	},
	'wallet.confirmation.are.you.sure': {
		en: 'Are you sure you want to delete this card?',
		ar: 'هل أنت متأكد أنك تريد حذف هذه البطاقة؟',
	},
	'wallet.delete': {
		en: 'Delete',
		ar: 'حذف',
	},
	'number.settings.change.adsl.password': {
		en: 'Change ADSL Password',
		ar: 'تغيير كلمة مرور ADSL',
	},
	'number.settings.reset.adsl.password': {
		en: 'Reset ADSL Password',
		ar: 'إعادة تعيين كلمة مرور ADSL',
	},
	'number.settings.old.password': {
		en: 'Old Password',
		ar: 'كلمة المرور القديمة',
	},
	'number.settings.confirm.new.password': {
		en: 'Confirm New Password',
		ar: 'تأكيد كلمة المرور الجديدة',
	},
	'number.settings.new.password': {
		en: 'New Password',
		ar: 'كلمة سر جديدة',
	},
	'number.settings.password.sent': {
		en: 'We have sent you an OTP on your phone number',
		ar: 'لقد أرسلنا لك رمز التحقق على رقم هاتفك.',
	},
	'number.settings.one.time.password': {
		en: 'One Time Password',
		ar: 'كلمة السر لمرة واحدة',
	},
	reset: {
		en: 'Reset',
		ar: 'إعادة تعيين',
	},
	'number.settings.verification': {
		en: 'Verification',
		ar: 'التحقق',
	},
	'number.settings.have.not.received.text': {
		en: 'Haven’t received the text?',
		ar: 'لم تتلق النص؟',
	},
	'number.settings.resend.token': {
		en: 'Resend password',
		ar: 'إعادة إرسال كلمة المرور',
	},
	'number.settings.resend.otp': {
		en: 'Resend otp',
		ar: 'إعادة إرسال كلمة المرور',
	},
	disconnect: {
		en: 'Disconnect',
		ar: 'افصل رقم الهاتف',
	},
	disable: {
		en: 'Disable',
		ar: 'تعطيل',
	},
	'sim.management.are.you.sure.you.want.disconnect': {
		en: 'Are you sure you want to disconnect SIM card?',
		ar: 'هل أنت متأكد أنك تريد قطع رقم الهاتف؟',
	},
	'sim.management.disconnect.sim.card': {
		en: 'Disconnect SIM card?',
		ar: 'قطع رقم الهاتف؟',
	},
	'number.disconnected': {
		en: 'Temporary disconnected',
		ar: 'موقوف بصفة مؤقتة',
	},
	'number.disconnection.active': {
		en: 'SIM card temporary disconnection is active',
		ar: 'تم تفعيل الفصل المؤقت لرقم الهاتف',
	},
	'sim.management.disable.disconnection': {
		en: 'Disable SIM card disconnection?',
		ar: 'تعطيل فصل رقم الهاتف',
	},
	'sim.management.disable.disconnection.are.you.sure': {
		en: 'Are you sure you want to disable temporary SIM card disconnection?',
		ar: 'هل أنت متأكد أنك تريد تعطيل خدمة فصل رقم الهاتف المؤقتة؟',
	},
	'services.email.hosting': {
		en: 'Email hosting*',
		ar: 'استضافة البريد الإلكتروني',
	},
	'services.email.hosting.email': {
		en: 'Email',
		ar: 'البريد الإلكتروني',
	},
	'services.email.hosting.add.email': {
		en: 'Add Email',
		ar: 'أضف بريد إلكتروني',
	},
	'services.email.hosting.new.email': {
		en: 'New Email',
		ar: 'بريد إلكتروني جديد',
	},
	'services.email.hosting.email.activation': {
		en: 'Email activation',
		ar: 'تفعيل البريد الإلكتروني',
	},
	'services.email.hosting.email.description': {
		en:
			'You can enjoy the benefits of business class email in a model that allows you to scale up as needed, with no risk. E-mail hosting solution from Omantel frees valuable capital, IT staff and other costly resources for more effective, strategic use within your company.\n  *You can add upp to 5 mails.',
		ar:
			'يمكنك الاستمتاع بمزايا البريد الإلكتروني الخاص بدرجة رجال الأعمال في نموذج يتيح لك التوسع حسب الحاجة ، دون أي مخاطر.يوفر حل استضافة البريد الإلكتروني من عمانتل رأس المال الثمين وموظفي تكنولوجيا المعلومات والموارد الأخرى المكلفة لاستخدام أكثر فعالية واستراتيجية داخل شركتك. * يمكنك إضافة upp إلى 5 رسائل.',
	},
	'services.email.hosting.enter.email.and.password': {
		en: 'Enter your new email address and password',
		ar: 'أدخل عنوان بريدك الإلكتروني الجديد وكلمة المرور',
	},
	'services.email.hosting.email.incorrect': {
		en: 'Email address is incorrect.',
		ar: 'عنوان البريد الإلكتروني غير صحيح.',
	},
	'services.email.hosting.email.correct': {
		en: 'Email address is correct.',
		ar: 'عنوان البريد الإلكتروني صحيح.',
	},
	'services.email.hosting.change.email.password': {
		en: 'Change email password',
		ar: 'تغيير كلمة مرور البريد الإلكتروني',
	},
	'services.email.hosting.change.email.password.description': {
		en:
			'Omantel is providing the best e-mail hosting solution to allow you to stay on the lead in today’s competitive business environment. By filling this form you can change your email password.',
		ar:
			'تقدم عمانتل أفضل حل لاستضافة البريد الإلكتروني للسماح لك بالبقاء في الصدارة في بيئة الأعمال التنافسية اليوم. عن طريق ملء هذا النموذج يمكنك تغيير كلمة مرور البريد الإلكتروني الخاص بك.',
	},
	'services.email.hosting.change.password': {
		en: 'Change password',
		ar: 'غير كلمة السر',
	},
	'organization.details.no.account.managers': {
		en: 'No account manager. Please contact 1235.',
		ar: 'لا يوجد مدير حساب. يرجى الاتصال بـ 1235.',
	},
	'services.number.gobiz.change.plan': {
		en: 'Change plan',
		ar: 'تغير خطة',
	},
	'tryandbuy.tryNowButton': {
		en: 'Try Now',
		ar: 'جرب الآن',
	},
	'tryandbuy.fbb.serviceName': {
		en: 'Fixed Business Broadband',
		ar: 'انترنت فائق السرعة',
	},
	'tryandbuy.fbb.servicePeriod': {
		en: 'Try no-commitment upgrade for 1 month for free',
		ar: 'جرب الترقية بدون عقد لمدة شهر واحد',
	},
	'tryandbuy.fbb.serviceNote': {
		en: 'Note:',
		ar: 'ملاحظة:',
	},
	'tryandbuy.tryNow': {
		en: 'Try Now',
		ar: 'جرب الآن',
	},
	'tryandbuy.fbb.serviceDescription': {
		en:
			'Try and Buy is an opportunity to try new or upgraded products for a limited time. Get the service as a free trial with no commitment and decide if you want to purchase it later.',
		ar:
			'توفر خدمة "جرب واشترك" فرصة لتجربة منتجات جديدة أو باقات اعلى لفترة محدودة. احصل على الخدمة كتجربة مجانية بدون عقد لتحديد ما يناسب احتياجات عملك.',
	},
	'tryandbuy.fbb.dialog.desriptionTitle': {
		en: 'Description',
		ar: 'الوصف',
	},
	'tryandbuy.fbb.dialog.description1': {
		en:
			'Experience FREE higher output and business efficiency. Upgrade your existing FBB speed free for 1 month, no commitment required. After the free trial, your internet speed will return to your original subscription automatically, hassle-free.',
		ar:
			'قم بترقية باقة الإنترنت الخاصة بك مجانًا لمدة شهر دون الحاجة إلى تجديد العقد. بعد انتهاء الفترة التجريبية المجانية ، ستعود سرعة الإنترنت إلى اشتراكك الأصلي تلقائيًا.',
	},
	'tryandbuy.fbb.dialog.description2': {
		en:
			'This offer is only available for lines on the current FBB packages. Click <a target="_blank" href="%%">here</a> to see our latest FBB packages. Subscribers on Fiber network can try higher speeds.',
		ar:
			'هذا العرض متاح للمشتركين في أحدث باقات الإنترنت الثابت للأعمال التجارية. <a target="_blank" href="%%">اضغط هنا</a> للاطلاع على أحدث الباقات. يمكن للمشتركين على شبكة الألياف البصرية تجربة سرعات أعلى.',
	},
	'tryandbuy.fbb.dialog.termsAndConfitions': {
		en: 'Terms & Conditions',
		ar: 'الشروط و الأحكام',
	},
	'tryandbuy.fbb.dialog.policy.2': {
		en: '• The FBB Try and Buy service is a free next-speed upgrade for a limited period of 1 month.',
		ar: '• خدمة جرب و اشترك هي ترقية مجانية لباقات الإنترنت الثابت للأعمال التجارية للسرعة التالية لفترة شهر',
	},
	'tryandbuy.fbb.dialog.policy.3': {
		en: '• Subscribers may utilize the Try and Buy service one time per line at each bandwidth.',
		ar: '• يمكن لكل مشترك الاستفادة من خدمة "جرب و أشترك" مرة واحدة لكل خط أنترنت',
	},
	'tryandbuy.fbb.dialog.policy.4': {
		en: '• At the end of the trial, subscribers will automatically be reverted to their original speed.',
		ar: '• بعد إنتهاء الخدمة سيتم إعادة الخدمة إلى السرعة الأصلية',
	},
	'tryandbuy.fbb.dialog.policy.5': {
		en:
			'• The existing FBB commitment period continues as usual if the subscriber does not change their plan after the Try and Buy period.',
		ar:
			'• يستمر العقد الأصلي لباقة الإنترنت الثابت للأعمال التجارية إذا لم يقم المشترك بتغيير عقده بعد الفترة التجريبية.',
	},
	'tryandbuy.fbb.dialog.policy.6': {
		en: '• The Try and Buy service is subject to network availability.',
		ar: '• تخضع الخدمة لتوافر الشبكة',
	},
	'tryandbuy.fbb.dialog.subscribe': {
		en: 'Subscribe',
		ar: 'اشترك',
	},
	'tryandbuy.fbb.dialog.fbbPlan': {
		en: 'Fixed Business Broadband plan',
		ar: 'باقة الإنترنت الثابت للأعمال التجارية',
	},
	'tryandbuy.fbb.dialog.fbbPlan.currentPlan': {
		en: 'Current plan',
		ar: 'الباقة الحالية',
	},
	'tryandbuy.fbb.dialog.fbbPlan.newPlan': {
		en: 'New plan',
		ar: 'الباقة الجديدة',
	},
	'tryandbuy.fbb.dialog.fbbPlan.offer.end': {
		en: 'Your "Try and Buy" offer will end on: ',
		ar: 'سينتهي عرض "جرب واشترك" في: ',
	},
	'tryandbuy.fbb.dialog.fbbPlan.conditions': {
		en: 'Terms & Conditions',
		ar: 'الشروط و الأحكام',
	},
	'tryandbuy.fbb.dialog.fbbPlan.accept': {
		en: 'I accept',
		ar: 'اوافق',
	},
	'tryandbuy.fbb.dialog.fbbPlan.choose.number': {
		en: 'Type your FBB number here',
		ar: 'سجل رقم الانترنت هنا',
	},
	'tryandbuy.fbb.dialog.fbbPlan.choose.number.helperText': {
		en: 'Try and Buy is active for this line',
		ar: 'خدمة "جرب واشترك" مفعلة لهذا الخط',
	},
	'tryandbuy.fbb.dialog.fbbPlan.choose.number.helperText.highestPlanActive': {
		en: 'Sorry, you have the highest plan activated. Please check again when higher speeds are available.',
		ar: 'عذرا ، لديك أعلى باقة مفعلة. يرجى العودة مرة أخرى عندما تتوفر سرعات أعلى.',
	},
	'tryandbuy.fbb.dialog.fbbPlan.choose.number.helperText.invalidAccountCategory': {
		en: 'This account is not eligible for "Try and Buy"',
		ar: 'هذا الحساب غير مؤهل لخدمة "جرب واشترك"',
	},
	'tryandbuy.fbb.dialog.fbbPlan.numberNotEligible': {
		en: 'This number is not eligible',
		ar: 'هذا الرقم غير مؤهل',
	},
	'tryandbuy.fbb.dialog.fbbPlan.callToSupport': {
		en: 'Call to support',
		ar: 'اتصل للحصول على الدعم',
	},
	'tryandbuy.fbb.dialog.fbbPlan.success.1': {
		en: 'Request sent successfully',
		ar: 'تم إرسال الطلب',
	},
	'tryandbuy.fbb.dialog.fbbPlan.success.2': {
		en: 'The new plan will be available soon',
		ar: 'الباقة الجديدة ستكون جاهزة للاستخدام قريبا',
	},
	'bills.pay.balance': {
		en: 'Pay balance',
		ar: 'دفع الرصيد',
	},
	'bills.pay.balance.pay.now': {
		en: 'Pay Now',
		ar: 'ادفع الآن',
	},
	'bills.pay.balance.current.balance': {
		en: 'Your current balance',
		ar: 'الرصيد الحالي',
	},
	'bills.pay.balance.how.much.to.pay': {
		en: 'How much do you want to pay now?',
		ar: 'كم تريد أن تدفع الآن؟',
	},
	'bills.pay.balance.payment.amount': {
		en: 'Payment Amount',
		ar: 'مبلغ الدفع',
	},
	'bills.pay.balance.payment': {
		en: 'Payment',
		ar: 'دفع',
	},
	'bills.list.total.due.tooltip': {
		en: 'The amount reduced by the value of made payments. (Already paid: %% OMR)',
		ar: 'المبلغ المخفض بقيمة المدفوعات التي تم إجراؤها. (تم دفع : ٪٪ ريال عماني)',
	},
	'vat-clause.description.wrapped': {
		en: 'All prices mentioned are exclusive of VAT.\nFrom 16 April 2021, 5% VAT will be added to the price.',
		ar:
			'جميع الأسعار المبينة لا تشمل ضريبة القيمة المضافة.\n اعتباراً من 16 ابريل 2021، سيتم إضافة 5% ضريبة القيمة المضافة على الأسعار.',
	},
	'static.ip.description.wrapped': {
		en: 'Static IP monthly cost is %% OMR.',
		ar: 'Static IP monthly cost is %% OMR.', // need arabic for
	},
	'vat-clause.description.one-line': {
		en: 'All prices mentioned are exclusive of VAT. From 16 April 2021, 5% VAT will be added to the price.',
		ar:
			'جميع الأسعار المبينة لا تشمل ضريبة القيمة المضافة. اعتباراً من 16 ابريل 2021، سيتم إضافة 5% ضريبة القيمة المضافة على الأسعار.',
	},
	'welcome-modal.title': {
		en: 'Welcome to our newly revamped portal.',
		ar: 'مرحباً بكم في موقعنا الجديد.',
	},
	'welcome-modal.body': {
		en:
			'Many features have been added to give you an enriching experience. To serve you better, we have kept the old portal temporarily and you can find it on the left side list.',
		ar:
			'أضفنا ميزات عديدة لإثراء تجربتكم، ولخدمتكم بشكل أفضل فإن الموقع القديم لا يزال متاحاً بصفة مؤقتة، ويمكنكم تصفحه عبر اختياره من القائمة.',
	},
	'number.services.mobile.tariff.plan.with.built.in.international.roaming': {
		en:
			'The plan chosen has built-in international/roaming services. If you wish to deactivate the international/roaming feature, please go to the services page once the line is active and disable it as required',
		ar:
			'تتضمن الخطة المختارة دقائق دولية و خدمة التجوال. إذا كنت ترغب في إلغاء هذه الميزة ، فيرجى الانتقال إلى صفحة الخدمات بعد تفعيل الخط وتعطيل الخدمة.',
	},
	'number.services.unavailable': {
		en:
			'We apologize for the inconvenience, the services you are attempting to subscribe to are currently unavailable. These services can be subscribed to through our selfcare portal after adding a new line. We appreciate your understanding and patience.',
		ar:
			'نعتذر عن الإزعاج، الخدمات التي تحاول الاشتراك فيها غير متوفرة حاليًا. يمكن الاشتراك في هذه الخدمات من خلال بوابة الخدمة الذاتية الخاصة بنا بعد إضافة خط جديد.',
	},
	'contact.us.queries.and.complaints': {
		en: 'Queries and complaints',
		ar: 'الاستفسارات والشكاوى',
	},
	'contact.us.queries.and.complaints.register.ticket': {
		en: 'Register a ticket',
		ar: 'تسجيل شكوى',
	},
	'contact.us.queries.and.complaints.track.ticket': {
		en: 'Track your ticket',
		ar: 'تتبع بلاغك',
	},
	'contact.us.register.ticket.input.label': {
		en: 'Enter Omantel Number',
		ar: 'أدخل رقم عمانتل',
	},
	'contact.us.register.ticket.enter.number': {
		en: 'Enter the number associated with the complaint.',
		ar: 'أدخل الرقم المرتبط بالشكوى.',
	},
	'contact.us.register.ticket.account.number': {
		en: 'Billing Account number',
		ar: 'رقم حساب الفواتير',
	},
	'contact.us.register.ticket.line.type': {
		en: 'Line type',
		ar: 'نوع الخط',
	},
	'contact.us.register.ticket.contact.number': {
		en: 'Contact number',
		ar: 'رقم الاتصال',
	},
	'contact.us.register.ticket.complaint.number': {
		en: 'Compliant For Number',
		ar: 'رقم المشتكي',
	},
	'contact.us.register.ticket.input.alternative.number.label': {
		en: 'Alternative Contact Number',
		ar: 'الرقم الإضافي',
	},
	'contact.us.register.ticket.input.email': {
		en: 'Email address',
		ar: 'عنوان البريد الالكترونى',
	},
	'contact.us.register.ticket.input.email.error': {
		en: 'Invalid email address ',
		ar: 'بريد إلكتروني غير صحيح',
	},
	'contact.us.register.ticket.input.alternative.number.error': {
		en: 'The alternative contact number should be different from the contact number provided above',
		ar: 'يجب أن يكون رقم الاتصال البديل مختلفًا عن رقم الاتصال الموضح أعلاه',
	},
	'contact.us.queries.complaint.description': {
		en:
			'For any queries or complaints, simply register a ticket with all the details. Feel free to raise any technical or billing complaints and we will make sure you are served in the best way possible. You can also track all your open tickets and stay updated with their status.',
		ar:
			'أي استفسارات أو بلاغات، ما عليك سوى تسجيل الشكوى مع كل التفاصيل. لا تتردد في تسجيل أي بلاغات فنية أو فوترة وسنتأكد من خدمتك بأفضل طريقة ممكنة.يمكنك أيضا تتبع جميع بلاغاتك والبقاء على اطلاع دائم بحالتها.',
	},
	'contact.us.register.ticket.failure.message': {
		en: 'Sorry, your request is not processed successfully, please try again later.',
		ar: 'طلبك لم ينجح ، يرجى المحاولة مرة أخرى في وقت لاحق.',
	},
	'contact.us.register.ticket.billing.account.number': {
		en: 'Billing Account Number',
		ar: 'رقم الحساب للفواتير',
	},
	'number.not.active': {
		en: 'Not Active',
		ar: 'موقوف',
	},
	'number.not.active.tooltip': {
		en:
			'This number is not active due to unpaid bills. For more information, please contact your account manager or call 1235',
		ar:
			'هذا الرقم موقوف بسبب الفواتير غير المسددة. لمزيد من المعلومات ، يرجى الاتصال بمدير حسابك أو الاتصال على 1235',
	},
	'number.disconnected.tooltip': {
		en:
			'This number is temporarily disconnected. For more information, please contact your account manager or call 1235',
		ar: 'هذا الرقم موقوف بصفة مؤقتًة. لمزيد من المعلومات ، يرجى الاتصال بمدير حسابك أو الاتصال على 1235',
	},
	'refresh.statuses.text': {
		en: 'Your service status might not be up to date. Click on refresh to get the latest update.',
		ar: 'قد لا تكون حالة الخدمة محدثة. اضغط على تحديث للحصول على آخر المستجدات.',
	},
	'refresh.statuses.button': {
		en: 'Refresh status',
		ar: 'تحديث الحالة',
	},
	'refresh.statuses.info': {
		en: 'Status on your order has been refreshed',
		ar: 'تم تحديث حالة طلبك',
	},
	'dashboard.try.and.buy': {
		en: 'Try and Buy',
		ar: 'جرب واشترك',
	},
	'dashboard.try.and.buy.description': {
		en: 'Boost Fixed Business Broadband for free and enjoy higher speed',
		ar: 'قم بترقية باقة الانترنت مجانًا واستمتع بسرعة أعلى',
	},
	'dashboard.try.and.buy.button': {
		en: 'Try no-commitment',
		ar: 'جرب بدون عقد التزام',
	},
	'custom.pop.up.success.header': {
		en: 'Request sent successfully.',
		ar: 'تم إرسال الطلب بنجاح',
	},
	'custom.pop.up.success.header2': {
		en: 'Your upgraded speed will be activated soon.',
		ar: 'سيتم تفعيل الباقة الجديدة قريبا',
	},
	'custom.pop.up.failure.header2': {
		en: 'Please contact your account manager or call 1235 for support.',
		ar: 'للمزيد من المعلومات ، يرجى الاتصال بمدير حسابك أو الاتصال على 1235.',
	},
	'custom.pop.up.failure.header': {
		en: 'This number is not eligible for "Try and Buy" offer',
		ar: 'هذا الرقم غير مؤهل لعرض "جرب واشترك"',
	},
	'custom.pop.up.failure.body': {
		en: 'For any inquiries call to support',
		ar: 'لأي استفسارات اتصل على ',
	},
	'custom.pop.up.success.body': {
		en: 'Upgrade FBB to %%',
		ar: '%% ترقية باقة انترنت فائق السرعة إلى ',
	},
	'number.details.tariff.plan.card.try.and.buy.description1': {
		en: 'The "Try and Buy" offer is activated. ',
		ar: 'تم تفعيل عرض "جرب واشترك". ',
	},
	'number.details.tariff.plan.card.try.and.buy.description2': {
		en: 'The current subscription of %% is upgraded for 1 month for free.',
		ar: 'تمت ترقية اشتراكك في %% لمدة شهر مجانًا.',
	},
	'dashboard.try.and.buy.new.tag': {
		en: 'NEW',
		ar: 'جديد',
	},
	'number.details.tariff.plan.card.subscribe.now': {
		en: 'Subscribe now',
		ar: 'إشترك الآن',
	},
	'number.details.tariff.plan.card.upgrade.plan': {
		en: 'Click "Change Plan" to upgrade your plan and enjoy premium benefits.',
		ar: 'اضغط على "تغيير الخطة" لترقية باقتك واستمتع بمزيد من المزايا.',
	},
	'custom.repeat.period.week': {
		en: 'Number of weeks:',
		ar: 'عدد الاسابيع:',
	},
	'custom.repeat.period.month': {
		en: 'Number of months:',
		ar: 'عدد الأشهر:',
	},
	'custom.repeat.every': {
		en: 'Add subscription every',
		ar: 'اضافة اشتراك كل',
	},
	every: {
		en: 'every ',
		ar: ' كل',
	},
	'custom.repeat.every.month': {
		en: 'month',
		ar: 'شهر',
	},
	'custom.repeat.every.week': {
		en: 'week',
		ar: 'أسبوع',
	},
	'custom.repeat.every.day': {
		en: 'day',
		ar: 'يوم',
	},
	'custom.repeat.every.year': {
		en: 'year',
		ar: 'عام',
	},
	'custom.repeat.every.months': {
		en: 'months',
		ar: 'الشهور',
	},
	'custom.repeat.every.weeks': {
		en: 'weeks',
		ar: 'أسابيع',
	},
	'custom.repeat.every.days': {
		en: 'days',
		ar: 'أيام',
	},
	'custom.repeat.every.years': {
		en: 'years',
		ar: 'سنوات',
	},
	'custom.repeat.every.startDate': {
		en: 'Start:',
		ar: 'بداية',
	},
	'custom.repeat.every.endDate': {
		en: 'End by:',
		ar: 'ينتهي بـ:',
	},
	'custom.repeat.every.chooseDate': {
		en: 'Choose Date',
		ar: 'اختر موعدا',
	},
	'custom.repeat.every.note': {
		en: 'Orders are limited to a maximum of %% months',
		ar: 'الطلبات محدودة بحد أقصى ٪٪ شهر',
	},
	'custom.repeat.every.summary.order': {
		en: 'You are planning a total of 1 order.',
		ar: 'أنت تخطط لإجمالي طلب واحد.',
	},
	'custom.repeat.every.summary.orders': {
		en: 'You are planning a total of %% orders,',
		ar: 'أنت تخطط لإجمالي ٪٪ من الطلبات،',
	},
	'custom.repeat.every.summary.period': {
		en: 'which will occur every %% %%,',
		ar: 'والذي سيحدث كل ٪٪ ٪٪،',
	},
	'custom.repeat.every.summary.from': {
		en: 'from',
		ar: 'من',
	},
	'custom.repeat.every.summary.to': {
		en: 'to',
		ar: 'الى',
	},
	'custom.repeat.every.summary.on': {
		en: 'on',
		ar: 'على',
	},
	'path.prepaid.loyalty': {
		en: 'Gift Program',
		ar: 'برنامج الاهداء',
	},
	'prepaid.loyalty': {
		en: 'Loyalty Program',
		ar: 'برنامج الولاء',
	},
	'prepaid.loyalty.success': {
		en: 'Success!',
		ar: 'نجاح',
	},
	'prepaid.loyalty.add.numbers': {
		en: 'Add numbers',
		ar: 'أضف الأرقام',
	},
	'prepaid.loyalty.add.new.numbers': {
		en: 'Add new numbers',
		ar: 'أضف أرقامًا جديدة',
	},
	'prepaid.loyalty.add.numbers.duplicates.found': {
		en: 'Duplicated numbers',
		ar: 'أرقام مكررة',
	},
	'prepaid.loyalty.add.numbers.duplicates.found.explainer': {
		en: 'Some of the numbers were previously added. We removed duplicates for you.',
		ar: '.تمت إضافة بعض الأرقام مسبقًا. أزلنا التكرارات لك',
	},
	'prepaid.loyalty.upload': {
		en: 'Upload from file',
		ar: 'تحميل من ملف',
	},
	'prepaid.loyalty.import': {
		en: 'Import numbers from file',
		ar: 'استيراد الأرقام من الملف',
	},
	'prepaid.loyalty.import.error': {
		en: 'One or more numbers not found',
		ar: 'لم يتم العثور على رقم واحد أو أكثر',
	},
	'prepaid.loyalty.import.error.explainer': {
		en: 'One or more numbers were not found or do not meet the criteria. We removed them for you.',
		ar: '.لم يتم العثور على رقم واحد أو أكثر أو لا يستوفي المعايير. أزلناهم من أجلك',
	},
	'prepaid.loyalty.create.loyalty': {
		en: 'Create new Gift Program groups',
		ar: 'إنشاء مجموعات جديدة لبرنامج الهدايا',
	},
	'prepaid.loyalty.create.loyalty.description': {
		en:
			'The gift program facilitates sending add-ons to your clients, contractors, etc providing a hassle-free scheduling feature. It simplifies the process of scheduling and delivering add-ons, ensuring a seamless experience for both the sender and the recipients.',
		ar:
			'يسهل برنامج الهدايا إرسال الخدمات الإضافية كالبيانات إلى عملائك، كما يمكنك جدولة الخدمات المختارة لارسالها مما يوفر تجربة سلسة لكل من المرسل والمستلمين.',
	},
	'prepaid.loyalty.create.loyalty.description.no.permission': {
		en: "You don't have permission to add loyalty group.",
		ar: 'ليس لديك إذن لإضافة مجموعة ولاء.',
	},
	'prepaid.loyalty.create.loyalty.description.no.permission2': {
		en: 'Only super admin can add and manage groups',
		ar: 'يمكن للمسؤول فقط إضافة المجموعات وإدارتها',
	},
	'prepaid.loyalty.name.loyalty': {
		en: 'Group name',
		ar: 'أسم المجموعة',
	},
	'prepaid.loyalty.email.address': {
		en: 'Email address',
		ar: 'عنوان البريد الالكترونى',
	},
	'prepaid.loyalty.add.numbers.description': {
		en: 'You can add only numbers from outside the organization/company.',
		ar: 'يمكنك فقط إضافة أرقام من خارج المنظمة / الشركة.',
	},
	'prepaid.loyalty.add.any.number': {
		en: 'Any Mobile Number',
		ar: 'أي رقم هاتف',
	},
	'prepaid.loyalty.add.lines': {
		en: 'Add Mobile lines',
		ar: 'أضف أرقام الهواتف المحمولة',
	},
	'prepaid.loyalty.add.any.number.can.not.add': {
		en: 'Sorry, this number is not registered under omantel.',
		ar: 'عذرا ، هذا الرقم غير مسجل في عمانتل.',
	},
	'prepaid.loyalty.add.any.number.exists': {
		en: 'Attention this number is already added',
		ar: 'هذا الرقم مضاف',
	},
	'prepaid.loyalty.payment.type.card.upfront': {
		en: 'This service is already paid for and will expire on %%. The amount paid will not be reimbursed.',
		ar: 'هذه الخدمة مدفوعة مسبقا وستنتهي في في تاريخ %%. لن يتم تعويض المبلغ المدفوع.',
	},
	'prepaid.loyalty.add.any.number.not.mobile': {
		en: 'Sorry, this number is not mobile',
		ar: 'نآسف، هذا  ليس رقم هاتف محمول',
	},
	'prepaid.loyalty.add.any.number.number.in.organization': {
		en: 'Sorry, only numbers from outside the organization/company are allowed',
		ar: 'عذرًا ، لا يُسمح إلا بالأرقام من خارج المؤسسة / الشركة',
	},
	'prepaid.loyalty.type.loyalty.name': {
		en: 'Insert Group Name',
		ar: 'أدخل اسم المجموعة',
	},
	'prepaid.loyalty.run.once': {
		en: 'One Time',
		ar: 'مره واحده',
	},
	'prepaid.loyalty.recurrent': {
		en: 'Recurrent',
		ar: 'متكرر',
	},
	'prepaid.loyalty.add.services': {
		en: 'Add Services',
		ar: 'أضف خدمات',
	},
	'prepaid.loyalty.add.top.up': {
		en: 'Add Top up',
		ar: 'أضف رصيد',
	},
	'prepaid.loyalty.loyalty.name': {
		en: 'Group name',
		ar: 'أسم المجموعة',
	},
	'prepaid.loyalty.active.subscriptions': {
		en: '%% Active Subscriptions',
		ar: '%% اشتراكات نشطة',
	},
	'prepaid.loyalty.active.subscription': {
		en: '1 Active Subscription',
		ar: '1  اشتراك نشط ',
	},
	'prepaid.loyalty.active.subscription.title': {
		en: 'Active Subscription',
		ar: ' اشتراك نشط',
	},
	'prepaid.loyalty.finished.subscription.title': {
		en: 'Finished Subscription',
		ar: 'الانتهاء من الاشتراك',
	},
	'prepaid.loyalty.add.group': {
		en: 'Add new group',
		ar: 'أضف مجموعة جديدة',
	},
	'prepaid.loyalty.manage.groups.description.1': {
		en: 'You can create and manage the group',
		ar: 'يمكنك إنشاء وإدارة المجموعة',
	},
	'prepaid.loyalty.manage.groups.description.2': {
		en: 'You can top-up and add new services.',
		ar: 'يمكنك تعبئة رصيد وإضافة خدمات جديدة.',
	},
	'prepaid.loyalty.manage.groups.short.description': {
		en: 'You can create and manage the group',
		ar: 'يمكنك إنشاء وإدارة المجموعة',
	},
	'prepaid.loyalty.manage.groups.note': {
		en: 'You cannot change the set of Numbers within the group, if there are any active subscription added.',
		ar: 'لا يمكنك تغيير الأرقام داخل المجموعة إذا تمت إضافة أي اشتراكات نشطة.',
	},
	'prepaid.loyalty.register.loyalty.name': {
		en: 'Add group name',
		ar: 'أضف اسم المجموعة',
	},
	'prepaid.loyalty.register.loyalty.success.description1': {
		en: 'You have created new group: ',
		ar: ':لقد قمت بإنشاء مجموعة جديدة',
	},
	'prepaid.loyalty.register.loyalty.topup.success.description': {
		en: 'You have top-uped successfully ',
		ar: 'لقد قمت بإعادة التعبئة بنجاح',
	},
	'prepaid.loyalty.register.loyalty.addon.success.description': {
		en: 'You have added services successfully ',
		ar: 'لقد أضفت الخدمات بنجاح',
	},
	'prepaid.loyalty.register.loyalty.addon.success.totalNumbers': {
		en: 'Total Numbers Count: ',
		ar: 'عدد الأرقام الإجمالية: ',
	},
	'prepaid.loyalty.register.loyalty.success.on.the': {
		en: ' on the ',
		ar: ' على ال ',
	},
	'prepaid.loyalty.register.loyalty.erro.try.again': {
		en: 'Try again later',
		ar: 'حاول  في وقت لاحق',
	},
	'prepaid.loyalty.manage.groups.details.select': {
		en: 'Group details...',
		ar: 'تفاصيل المجموعة …',
	},
	'prepaid.loyalty.manage.service.details.select': {
		en: 'Services details...',
		ar: 'تفاصيل الخدمات …',
	},
	'prepaid.loyalty.manage.groups.details': {
		en: 'Group details',
		ar: 'تفاصيل المجموعة',
	},
	'prepaid.loyalty.manage.service.details': {
		en: 'Services details',
		ar: 'تفاصيل الخدمات',
	},
	'prepaid.loyalty.manage.service.details.table.subscriptions.name': {
		en: 'Subscription',
		ar: 'الاشتراك',
	},
	'prepaid.loyalty.manage.service.details.table.subscriptions.amount': {
		en: 'Total amount',
		ar: 'المبلغ الإجمالي',
	},
	'prepaid.loyalty.manage.service.details.table.subscriptions.numbers': {
		en: 'Set of numbers',
		ar: 'مجموعة من الأرقام',
	},
	'prepaid.loyalty.manage.service.details.table.subscriptions.recurrence': {
		en: 'Recurrence',
		ar: 'تكرار',
	},
	'prepaid.loyalty.manage.service.details.table.subscriptions.end.date': {
		en: 'End date',
		ar: 'تاريخ الانتهاء',
	},
	'prepaid.loyalty.manage.service.details.table.subscriptions.payment': {
		en: 'Payment',
		ar: 'دفع',
	},
	'prepaid.loyalty.manage.service.details.table.phone.number': {
		en: 'Mobile number',
		ar: 'رقم الهاتف المحمول',
	},
	'prepaid.loyalty.manage.service.unsubscribe.dialog.description.topup': {
		en: 'Are you sure you want unsubscribe?',
		ar: 'هل أنت متأكد أنك تريد إلغاء الاشتراك؟',
	},
	'prepaid.loyalty.manage.service.unsubscribe.dialog.description.services': {
		en: 'Are you sure you want unsubscribe %% OMR?',
		ar: 'هل أنت متأكد أنك تريد إلغاء الاشتراك ٪٪ ريال ؟',
	},
	'prepaid.loyalty.manage.service.unsubscribe.dialog.success': {
		en: 'Unsubscription successful',
		ar: 'تم إلغاء الاشتراك بنجاح',
	},
	'prepaid.loyalty.manage.service.unsubscribe.dialog.error': {
		en: 'Something went wrong',
		ar: 'حدث خطأ ما',
	},
	'prepaid.loyalty.manage.service.unsubscribe.dialog.error.call': {
		en: 'For technical support, please call 1235',
		ar: 'للدعم الفني، يرجى الاتصال بـ 1235',
	},
	'prepaid.loyalty.manage.service.unsubscribe.dialog.error.description': {
		en: 'The service cannot be unsubscribed',
		ar: 'لا يمكن إلغاء الاشتراك في الخدمة',
	},
	'prepaid.loyalty.manage.groups.ongoing.subscription.note': {
		en: "Editing numbers doesn't affect ongoing subscriptions",
		ar: 'تعديل الأرقام لا يؤثر على الاشتراكات الجارية',
	},
	'prepaid.loyalty.manage.groups.change.name': {
		en: 'Change group name',
		ar: 'تغيير اسم المجموعة',
	},
	'prepaid.loyalty.manage.groups.details.table.phone.number': {
		en: 'Mobile number',
		ar: 'رقم الهاتف المحمول',
	},
	'prepaid.loyalty.manage.groups.details.edit.success': {
		en: 'Group editing was successful',
		ar: 'تم تحرير المجموعة بنجاح',
	},
	'prepaid.loyalty.manage.groups.details.edit.error': {
		en: 'Group editing was wrong',
		ar: 'كان تحرير المجموعة خاطئًا',
	},
	'prepaid.loyalty.manage.groups.details.delete.numbers.description': {
		en: 'Are you sure you want to delete selected numbers?',
		ar: 'هل أنت متأكد أنك تريد حذف الأرقام المختارة؟',
	},
	'prepaid.loyalty.manage.groups.details.discard.changes': {
		en: 'Are you sure you want to discard changes?',
		ar: 'هل أنت متأكد أنك تريد تجاهل التغييرات؟',
	},
	'prepaid.loyalty.manage.groups.details.delete.numbers.title': {
		en: 'Delete numbers',
		ar: 'احذف الأرقام',
	},
	'prepaid.loyalty.manage.groups.details.delete.numbers.success': {
		en: '%% numbers were successfully deleted',
		ar: 'تم حذف ٪٪  الأرقام بنجاح',
	},
	'prepaid.loyalty.manage.groups.details.delete.numbers.error': {
		en: 'Something go wrong',
		ar: 'حدث خطأ ما',
	},
	'prepaid.loyalty.manage.groups.details.add.numbers.success': {
		en: '%% numbers were added successfully',
		ar: 'تم إضافة ٪٪ أرقام بنجاح',
	},
	'prepaid.loyalty.manage.groups.details.add.numbers.error': {
		en: 'Something go wrong',
		ar: 'حدث خطأ ما',
	},
	'prepaid.loyalty.delete.groups.pop.up.success.oneSelect.header': {
		en: '%% group deleted',
		ar: '%% تم حذف المجموعة',
	},
	'prepaid.loyalty.delete.groups.pop.up.success.fewSelect.header': {
		en: '%% groups deleted',
		ar: '%% تم حذف المجموعات',
	},
	'prepaid.loyalty.delete.groups.pop.up.failure.header': {
		en: 'The services cannot be deleted',
		ar: 'ا يمكن حذف هذه الخدمات',
	},
	'prepaid.loyalty.delete.groups.pop.up.success.body': {
		en: 'Succesfull',
		ar: 'ناجح',
	},
	'prepaid.loyalty.delete.groups.wantDeleteText': {
		en: 'You want delete ',
		// TODO: this doesn't work. We merge two translations "You want to delete X groups"
		ar: 'هل تريد حذف المجموعات؟',
	},
	'prepaid.loyalty.delete.groups.noDeleteText': {
		en: 'You can not delete selected groups, because one of the groups has ongoing services',
		ar: 'ا يمكنك حذف المجموعات المحددة ، لأن إحدى المجموعات بها خدمات جارية',
	},
	'prepaid.loyalty.delete.groups': {
		en: ' groups',
		ar: 'مجموعات ',
	},
	'prepaid.loyalty.delete.groups.ongoing.services.stop': {
		en: ' and stop ongoing services?',
		ar: 'ووقف الخدمات الجارية؟ ',
	},
	'prepaid.loyalty.delete.groups.creditCard.text': {
		en: 'You have paid by credit card, so all ongoing subscriptions',
		ar: 'لقد دفعت عن طريق بطاقة الائتمان ، لذلك جميع الاشتراكات الجارية',
	},
	'prepaid.loyalty.delete.groups.creditCard.oneSelect.until': {
		en: ' (until %%)',
		ar: ' (حتى %%) ',
	},
	'prepaid.loyalty.delete.groups.creditCard.oneSelect.amount': {
		en: ' by amount %% OMR',
		ar: 'بالمبلغ %% ريال عماني ',
	},
	'prepaid.loyalty.delete.groups.creditCard.fewSelect.terminated': {
		en: ' will be terminated at the end of the date.',
		ar: '.سيتم إنهاؤها في نهاية التاريخ ',
	},
	'prepaid.loyalty.delete.groups.creditCard.oneSelect.terminated': {
		en: ' will be terminated.',
		ar: 'سيتم قطع الأرقام ',
	},
	'prepaid.loyalty.mobile.number': {
		en: 'Mobile Number',
		ar: 'رقم الهاتف المحمول',
	},
	'prepaid.loyalty.mobile.postpaid.number': {
		en: 'Mobile Postpaid Number',
		ar: 'رقم الهاتف المتنقل',
	},
	'prepaid.loyalty.selected.numbers': {
		en: '%% of %%',
		ar: '%% من %%',
	},
	'prepaid.loyalty.common.per.line': {
		en: '/ Per Line',
		ar: '/ لكل خط',
	},
	'prepaid.loyalty.common.nameOfTheGroup': {
		en: 'Name Of the Group:',
		ar: ':اسم المجموعة',
	},
	'prepaid.loyalty.add.new.services.numbers.tab': {
		en: 'Numbers',
		ar: 'الأرقام',
	},
	'prepaid.loyalty.add.new.services.payment.method.tab': {
		en: 'Payment method',
		ar: 'طريقة الدفع او السداد',
	},
	'prepaid.loyalty.add.new.services.services.tab': {
		en: 'Services',
		ar: 'الخدمات',
	},
	'prepaid.loyalty.add.new.services.services.select.one.option': {
		en: 'Select plan',
		ar: 'اختر خطة',
	},
	'prepaid.loyalty.add.new.services.date.tab': {
		en: 'Scheduling',
		ar: 'الجدولة',
	},
	'prepaid.loyalty.add.new.services.summary.tab': {
		en: 'Summary',
		ar: 'ملخص',
	},
	'prepaid.loyalty.add.new.services': {
		en: 'Add new services',
		ar: 'إضافة خدمة جديدة',
	},
	'prepaid.loyalty.add.new.services.payment.method.title': {
		en: 'Set payment method',
		ar: 'حدد طريقة الدفع',
	},
	'prepaid.loyalty.add.new.services.payment.method.master.number': {
		en: 'Monthly bill',
		ar: 'الفاتورة الشهرية',
	},
	'prepaid.loyalty.add.new.services.payment.method.bill': {
		en: 'Bill',
		ar: 'الفاتورة',
	},
	'prepaid.loyalty.add.new.services.payment.method.master.number.caption': {
		en:
			'Choose one mobile number from below to be assigned to your billing account number for the monthly charges. ',
		ar: 'اختر رقم هاتف متنقل واحد لربطه برقم حساب الفواتير للرسوم الشهرية.',
	},
	'prepaid.loyalty.add.new.services.payment.method.master.number.input.label': {
		en: 'Select Master Postpaid Number',
		ar: 'حدد رقم الدفع الآجل الرئيسي',
	},
	'prepaid.loyalty.add.new.services.payment.method.master.number.input.helper.text': {
		en: 'Please, type 3 numbers to search',
		ar: 'من فضلك اكتب 3 أرقام للبحث',
	},
	'prepaid.loyalty.add.new.services.payment.method.credit.card': {
		en: 'By Credit Card',
		ar: 'عن طريق بطاقة الإئتمان',
	},
	'prepaid.loyalty.add.new.services.services.amount': {
		en: 'x %%',
		ar: '[AR] x %%',
	},
	'prepaid.loyalty.add.new.services.roaming.bundles': {
		en: 'Roaming bundles',
		ar: 'باقات التجوال',
	},
	'prepaid.loyalty.add.new.services.terms': {
		en: '* Data plans with data sharing. ',
		ar: '* خطط البيانات مع مشاركة البيانات.',
	},
	'prepaid.loyalty.add.new.services.terms.conditions': {
		en: 'Terms & conditions',
		ar: 'الشروط و الأحكام',
	},
	'prepaid.loyalty.add.new.services.payment.method.credit.card.account.managers.no': {
		en:
			'The Option is not active. To enable this program, please contact your Account Managet or Contact Center 1235',
		ar: 'الخيار غير متوفر. لتفعيل البرنامج يرجى التواصل مع مدير اعمالك او مركز الاتصال 1235.',
	},
	'prepaid.loyalty.add.new.services.payment.method.credit.card.account.managers.yes': {
		en:
			'The Option is not active. To enable this program, please contact your Account Managet or Contact Center 1235',
		ar: 'الخيار غير متوفر. لتفعيل البرنامج يرجى التواصل مع مدير اعمالك او مركز الاتصال 1235.',
	},
	'prepaid.loyalty.add.new.services.payment.method.credit.card.account.managers.subject.message': {
		en: 'Prepaid Loyalty Contact',
		ar: 'جهة اتصال برنامج الولاء المدفوعة مسبقًا',
	},
	'prepaid.loyalty.add.new.services.payment.method.credit.card.account.managers.send': {
		en: 'Send message',
		ar: 'أرسل رسالة',
	},
	'prepaid.loyalty.numbers': {
		en: 'Number of lines:',
		ar: 'أرقام الدفع الآجل ',
	},
	'prepaid.loyalty.add.new.services.confirm.payment': {
		en: 'Confirm payment',
		ar: 'تأكيد الدفع',
	},
	'prepaid.loyalty.add.new.services.totalAmount': {
		en: 'Total amount',
		ar: 'المبلغ الإجمالي',
	},
	'prepaid.loyalty.add.new.services.date.question': {
		en: 'When do you want to start the Subscription?',
		ar: 'متى تريد بدء الاشتراك؟',
	},
	'prepaid.loyalty.add.new.services.date.repeat': {
		en: 'Repeat',
		ar: 'تكرار',
	},
	'prepaid.loyalty.add.new.services.selectedNumbers': {
		en: 'Selected numbers',
		ar: 'أرقام مختارة',
	},
	'prepaid.loyalty.add.new.services.payment.date': {
		en: 'Payment date',
		ar: 'موعد الدفع',
	},
	'prepaid.loyalty.add.new.services.payment.donationAmount': {
		en: 'Donation amount',
		ar: 'مبلغ التبرع',
	},
	'prepaid.loyalty.add.new.services.start.date': {
		en: 'Start date',
		ar: 'تاريخ البدء',
	},
	'prepaid.loyalty.add.new.services.end.date': {
		en: 'End date',
		ar: 'تاريخ الانتهاء',
	},
	'prepaid.loyalty.add.new.services.recurrence': {
		en: 'Recurrence',
		ar: 'تكرار',
	},
	'prepaid.loyalty.add.new.services.recurrence.value': {
		en: 'every %% %%',
		ar: 'كل %% %%',
	},
	'prepaid.loyalty.add.new.services.credit.card': {
		en: 'Credit card',
		ar: 'بطاقة الائتمان',
	},
	'prepaid.loyalty.add.new.services.credit.card.mask': {
		en: '**** **** **** %%',
		ar: '**** **** **** %%',
	},
	'prepaid.loyalty.add.new.services.master.postpaid.number': {
		en: 'Master Postpaid Number',
		ar: 'رقم الدفع الآجل',
	},
	'prepaid.loyalty.add.new.topUp.title': {
		en: 'Add new Top-up',
		ar: 'إضافة رصيد جديد',
	},
	'prepaid.loyalty.add.new.topUp.numbers.tab': {
		en: 'Numbers / Top-up',
		ar: 'أرقام / تعبئة رصيد',
	},
	'prepaid.loyalty.pay.cc.attention.1': {
		en: 'You can not pay by credit card, because you selected',
		ar: 'لا يمكنك الدفع بواسطة بطاقة الائتمان ، لأنك اخترت',
	},
	'prepaid.loyalty.pay.cc.attention.2': {
		en: 'more than %% numbers',
		ar: 'أكثر من %% من الأرقام',
	},
	'prepaid.loyalty.pay.cc.limit': {
		en: 'You can select only %% numbers in credit card payment',
		ar: 'يمكنك تحديد %% فقط من الأرقام في الدفع ببطاقة الائتمان',
	},
	'top.up.add.ons.choose.services': {
		en: 'Choose Services',
		ar: 'اختر الخدمات',
	},
	'top.up.add.ons.top.up': {
		en: 'Top-up',
		ar: 'إعادة التعبئة',
	},
	'top.up.add.ons.top.up.subtitle': {
		en: 'You can top up multiple numbers with predefined or custom value',
		ar: 'يمكنك تعبئة أرقام متعددة بقيمة محددة مسبقًا أو مخصصة',
	},
	'top.up.add.ons.new.top.up': {
		en: 'New Top-up',
		ar: 'إعادة التعبئة',
	},
	'top.up.add.ons.order.add.ons': {
		en: 'Order Add-ons',
		ar: 'طلب إضافات',
	},
	'top.up.add.ons.add.ons': {
		en: 'Add-ons',
		ar: 'إضافات',
	},
	'top.up.add.ons.add.ons.subtitle': {
		en: 'You can choose services from several packages: Mobile data Roaming, Social media, Others',
		ar: 'يمكنك اختيار الخدمات من عدة باقات: تجوال بيانات الجوال ، وسائل التواصل الاجتماعي ، أخرى',
	},
	'top.up.add.ons.choose.services.description': {
		en: 'You can Top-up or order Add-ons for multiple postpaid lines. ',
		ar: 'يمكنك زيادة رصيدك أو طلب إضافات لخطوط الدفع الآجل المتعددة',
	},
	'top.up.add.ons.limit.exceeded.text1': {
		en: 'You are exceeding the available limit on your Master Postpaid Number account.',
		ar: '.لقد تجاوزت الحد المتاح على حساب الرقم الرئيسي للفوترة  الخاص بك',
	},
	'top.up.add.ons.limit.exceeded.text2': {
		en: 'To proceed, change one of the following:',
		ar: ':للمتابعة ، قم بتغيير أحد الخيارات التالية',
	},
	'prepaid.loyalty.add.new.services.CORP_LOYALTY_PREPAID_MARHABA': {
		en: 'Marhaba World',
		ar: 'عالم مرحبا',
	},
	'prepaid.loyalty.add.new.services.CORP_LOYALTY_PREPAID_DPS': {
		en: 'Mobile Internet Plans',
		ar: 'باقات الإنترنت عبر الهاتف المتنقل',
	},
	'prepaid.loyalty.add.new.services.CORP_LOYALTY_PREPAID_SOCIAL': {
		en: 'Social',
		ar: 'اجتماعي',
	},
	'prepaid.loyalty.add.new.services.other': {
		en: 'Other',
		ar: 'أخرى',
	},
	'prepaid.loyalty.add.new.services.CORP_LOYALTY_PREPAID_NAT_MIN': {
		en: 'National minutes',
		ar: 'الدقائق المحلية',
	},
	'prepaid.loyalty.add.new.services.CORP_LOYALTY_PREPAID_INTER_MIN': {
		en: 'International minutes',
		ar: 'الدقائق الدولية',
	},
	'prepaid.loyalty.add.new.services.national.minutes': {
		en: 'National minutes',
		ar: 'الدقائق المحلية',
	},
	'prepaid.loyalty.add.new.services.international.minutes': {
		en: 'International minutes',
		ar: 'الدقائق الدولية',
	},
	'prepaid.loyalty.add.new.services.mobile.internet': {
		en: 'Mobile internet',
		ar: 'رقم خطة إنترنت',
	},
	'prepaid.loyalty.add.new.services.proposed.packages': {
		en: 'Proposed packages',
		ar: 'الحزم المقترحة',
	},
	'prepaid.loyalty.add.new.services.OTHER': {
		en: 'Other',
		ar: 'أخرى',
	},
	'prepaid.loyalty.add.new.services.CORP_LOYALTY_PREPAID_OTHER': {
		en: 'Other',
		ar: 'أخرى',
	},
	'prepaid.loyalty.add.new.services.CORP_LOYALTY_PREPAID_ROAMING': {
		en: 'Roaming',
		ar: 'التجوال',
	},
	'prepaid.loyalty.add.new.services.JAWAZAK GCC': {
		en: 'Jawazak GCC',
		ar: 'جوازك دول الخليج',
	},
	'prepaid.loyalty.add.new.services.JAWAZAK WORLD': {
		en: 'Jawazak World',
		ar: 'جوازك حول العالم',
	},
	'prepaid.loyalty.terms': {
		en: '* Data plans with data sharing.',
		ar: '* باقات البيانات التي تتضمن مشاركة البيانات.',
	},
	'prepaid.loyalty.terms.conditions': {
		en: 'T&Cs of the related service applies',
		ar: 'تطبق الشروط والأحكام',
	},
	'top.up.add.ons.credit.limit': {
		en: 'credit limit',
		ar: 'سقف الأئتمان',
	},
	'top.up.add.ons.paymentTab.credit.limit': {
		en: 'In total, the selected number has a monthly limit of ',
		ar: 'إجمالاً ، الرقم المحدد له حد ائتماني شهري قدره ',
	},
	'top.up.add.ons.paymentTab.account.manager': {
		en: 'To increase the limit please get in touch with your dedicated Account Manager.',
		ar: 'لزيادة الحد ، يرجى التواصل مع مدير الحساب المخصص لك.',
	},
	'top.up.add.ons.order.top.up': {
		en: 'Order Top-up',
		ar: 'اطلب تعبئة رصيد',
	},
	'top.up.add.ons.expiry.date': {
		en: 'Expiry date',
		ar: 'تاريخ انتهاء الصلاحية',
	},
	'top.up.add.ons.recurrency': {
		en: 'Recurrency',
		ar: 'تكرار',
	},
	'prepaid.loyalty.add.new.services.master.number': {
		en: 'Master number',
		ar: 'رقم الدفع الآجل',
	},
	'user.information.contact.number': {
		en: 'Contact number: ',
		ar: 'رقم التواصل: ',
	},
	'user.information.email': {
		en: 'Email: ',
		ar: 'البريد الإلكتروني: ',
	},
	'prepaid.loyalty.set.of.numbers.subscription.ending': {
		en: 'Subscription ending on ',
		ar: ' الاشتراك ينتهي في',
	},
	'change.password.form.body': {
		en: 'Enter your old password and new one',
		ar: 'أدخل كلمة المرور القديمة وكلمة المرور الجديدة',
	},
	'change.password.unsuccessfulReset': {
		en: 'You entered an incorrect password or new password does not match. Please, try again.',
		ar: 'لقد أدخلت كلمة مرور غير صحيحة أو أن كلمة المرور الجديدة غير متطابقة. حاول مرة اخرى.',
	},
	'change.password.back': {
		en: 'Back to dashboard',
		ar: 'العودة إلى لوحة القيادة',
	},
	'billing.payment.track.success.body': {
		en: 'The request is submitted successfully: Request number: %% was created',
		ar: '%%: تم إرسال الطلب بنجاح: رقم الطلب',
	},
	'billing.payment.track.error.body': {
		en: 'Please try again later or call support #123',
		ar: 'يرجى المحاولة مرة أخرى لاحقًا أو الاتصال بالدعم رقم 123',
	},
	'billing.payment.track.status.list.heading': {
		en: 'Status list',
		ar: 'قائمة الحالة',
	},
	'billing.payment.track.status.list.description': {
		en: 'You can check your request status or send a new request to prove your invoice',
		ar: 'يمكنك التحقق من حالة طلبك أو إرسال طلب جديد لإثبات فاتورتك',
	},
	'billing.payment.track.status.new.request.button': {
		en: 'Create a new request',
		ar: 'قم بإنشاء طلب جديد',
	},
	'billing.payment.track.status.ticket.id': {
		en: 'Ticket Id',
		ar: 'رقم البلاغ',
	},
	'billing.payment.track.status.tracking.number': {
		en: 'Tracking Number',
		ar: 'رقم التتبع',
	},
	'billing.payment.track.status.dates': {
		en: 'Approval date',
		ar: 'تاريخ الموافقة',
	},
	'billing.payment.track.status.bank.name': {
		en: 'Bank Name',
		ar: 'اسم البنك',
	},
	'billing.payment.track.status.paid.amount': {
		en: 'Paid Amount',
		ar: 'المبلغ المدفوع',
	},
	'billing.payment.track.status.files': {
		en: 'Files',
		ar: 'الملفات',
	},
	'billing.payment.track.status.status': {
		en: 'Status',
		ar: 'الحالة',
	},
	'billing.payment.track.payment.type.form': {
		en: 'Payment type',
		ar: 'نوع الدفع',
	},
	'billing.payment.track.payment.type.BANK_TRANSFER': {
		en: 'Bank Transfer',
		ar: 'التحويل المصرفي',
	},
	'billing.payment.track.payment.type.form.title': {
		en: 'Select type of payment',
		ar: 'حدد نوع الدفع',
	},
	'billing.payment.track.payment.type.form.invoice.type': {
		en: 'Choose type of payment:',
		ar: 'اختر نوع الدفع:',
	},
	'billing.payment.track.payment.type.form.invoice.type.account': {
		en: 'Account number',
		ar: 'الحساب',
	},
	'billing.payment.track.payment.type.form.invoice.type.invoice': {
		en: 'Invoice number',
		ar: 'الفاتورة',
	},
	'billing.payment.track.payment.details.form': {
		en: 'Payment details',
		ar: 'بيانات الدفع',
	},
	'billing.payment.track.payment.details.form.title.description': {
		en: 'Completes the form correctly so that the UTT can properly verify your prove',
		ar: 'أكمل النموذج بشكل صحيح حتى يتمكن UTT من التحقق بشكل صحيح من إثباتك',
	},
	'billing.payment.track.payment.details.form.bank.name.label': {
		en: 'Select bank',
		ar: 'حدد البنك',
	},
	'billing.payment.track.payment.details.form.bank.account.number.label': {
		en: 'Bank Account Number',
		ar: 'رقم الحساب المصرفي',
	},
	'billing.payment.track.payment.details.form.bank.transaction.id.label': {
		en: 'Bank Transaction ID',
		ar: 'رقم المعاملة المصرفية',
	},
	'billing.payment.track.payment.details.form.cheque.number.label': {
		en: 'Cheque Number',
		ar: 'رقم الشيك',
	},
	'billing.payment.track.payment.details.form.date.payment.label': {
		en: 'Choose the date payment',
		ar: 'اختر تاريخ الدفع',
	},
	'billing.payment.track.upload.excel.file': {
		en: 'Upload excel file',
		ar: 'تحميل ملف اكسل',
	},
	'billing.payment.upload.excel.files.reason': {
		en: 'Our team will verify your files, please submit an excel',
		ar: 'سيقوم فريقنا بالتحقق من ملفاتك ، يرجى إرسال ملف Excel',
	},
	'billing.payment.track.upload.excel.max.one': {
		en: 'Select max one excel file to upload',
		ar: 'حدد ملف excel واحد كحد أقصى للتحميل',
	},
	'billing.payment.track.upload.excel.allowed.formats': {
		en: 'Allowed file formats: xls, xlsx.',
		ar: 'تنسيقات الملفات المسموح بها: xls، xlsx.',
	},
	'billing.payment.track.download.sample': {
		en: 'Download excel template',
		ar: 'قم بتنزيل نموذج Excel',
	},
	'billing.payment.track.uploading.file': {
		en: 'Uploading file...',
		ar: 'جاري تحميل الملف ...',
	},
	'billing.payment.upload.proof.files': {
		en: 'Upload proof files',
		ar: 'تحميل ملفات إثبات',
	},
	'billing.payment.track.empty.screen.description': {
		en: 'User can prove their payment for bills by cheque or bank transfer',
		ar: 'يمكن للمستخدم إثبات دفع الفواتير عن طريق الشيك أو التحويل المصرفي',
	},
	'billing.payment.track.empty.screen.start': {
		en: 'Start',
		ar: 'بداية',
	},
	'billing.payment.upload.proof.files.reason': {
		en: 'Our team will verify your files, please submit proof payment documents',
		ar: 'سيتحقق فريقنا من ملفاتك ، يرجى تقديم مستندات إثبات الدفع',
	},
	'billing.payment.track.upload.select.max.five': {
		en: 'Select max 5 files to upload',
		ar: 'حدد 5 ملفات كحد أقصى للتحميل',
	},
	'billing.payment.track.upload.drag.or.drop': {
		en: 'or drag and drop it here',
		ar: 'أو اسحبه وأفلته هنا',
	},
	'billing.payment.track.upload.allowed.formats': {
		en:
			'Allowed file formats: pdf, doc, docx,xls, xlsx, csv, txt, rtf, html, zip, jpg, jpeg, png, gif. Each file size should not exceed 10MB. All attachments should not exceed 50MB.',
		ar:
			'تنسيقات الملفات المسموح بها: pdf، doc، docx، xls، xlsx، csv، txt، rtf، html، zip، jpg، jpeg، png، gif. يجب ألا يتجاوز حجم كل ملف 10 ميغا بايت. يجب ألا يتجاوز حجم جميع المرفقات 50 ميغا بايت.',
	},
	'billing.payment.track.upload.error.max_size_exceeded': {
		en: '%% size exceeds maximum limit. Maximum allowed file size is 10MB.',
		ar: 'حجم %% يتجاوز الحد الأقصى. الحد الأقصى لحجم الملف المسموح به هو 10 ميغا بايت.',
	},
	'billing.payment.track.upload.error.wrong_extension': {
		en: '%% incorect file format.',
		ar: '%% دمج تنسيق الملف.',
	},
	'billing.payment.track.upload.error.empty_file': {
		en: '%% is empty.',
		ar: '%% فارغ.',
	},
	'billing.payment.track.upload.error.too_many_files': {
		en: '%% not uploaded. You can upload maximum %% files',
		ar: '%% لم يتم تحميلها. يمكنك تحميل ملفات %% كحد أقصى',
	},
	'billing.payment.track.upload.error.too_many_files.one.file': {
		en: '%% not uploaded. You can upload maximum one file',
		ar: '%% لم يتم تحميلها. يمكنك تحميل ملف واحد كحد أقصى',
	},
	'billing.payment.track.upload.error.bad_sheet': {
		en: '%% is not a correctly formatted excel file. See an example file',
		ar: '%% ليس ملف Excel بتنسيق صحيح. انظر ملف مثال',
	},
	'billing.payment.track.upload.error.invalid_account_number': {
		en: '%% has account numbers that are not inside your organisation',
		ar: '٪٪ لديه أرقام حسابات ليست داخل مؤسستك',
	},
	'billing.payment.track.preview.excel.heading': {
		en: 'Preview Excel Files',
		ar: 'معاينة ملفات Excel',
	},
	'billing.payment.track.preview.excel.reason': {
		en: 'You can check that your uploaded excel file is correct',
		ar: 'يمكنك التحقق من صحة ملف Excel الذي تم تحميله',
	},
	'billing.payment.track.preview.excel.account.number': {
		en: 'Account Number',
		ar: 'رقم حساب',
	},
	'billing.payment.track.preview.excel.invoice.number': {
		en: 'Invoice Number',
		ar: 'رقم الفاتورة',
	},
	'billing.payment.track.preview.excel.bill.month': {
		en: 'Bill Month',
		ar: 'شهر الفاتورة',
	},
	'billing.payment.track.preview.excel.payment.date': {
		en: 'Payment Date',
		ar: 'تاريخ الدفع',
	},
	'billing.payment.track.uploaded.files.heading': {
		en: 'Uploaded files',
		ar: 'الملفات التي يتم تحميلها',
	},
	'billing.payment.track.uploaded.files.excel': {
		en: 'Excel file',
		ar: 'ملف اكسل',
	},
	'billing.payment.track.uploaded.files.proof': {
		en: 'Proof files',
		ar: 'ملفات إثبات',
	},
	'billing.payment.track.uploaded.files.file': {
		en: 'file',
		ar: 'ملف',
	},
	'billing.payment.track.uploaded.files.files': {
		en: 'files',
		ar: 'ملفات',
	},
	'billing.payment.track.details.request.dialog.title': {
		en: 'Details request',
		ar: 'طلب التفاصيل',
	},
	'billing.payment.track.details.request.dialog.approval.date': {
		en: 'Approval date:',
		ar: 'تاريخ الموافقة:',
	},
	'billing.payment.track.details.request.dialog.invoice.type': {
		en: 'Type of Invoice:',
		ar: 'نوع الفاتورة:',
	},
	'billing.payment.track.details.request.dialog.invoice.type.INVOICE': {
		en: 'Invoice',
		ar: 'فاتورة',
	},
	'billing.payment.track.details.request.dialog.invoice.type.ACCOUNT': {
		en: 'Account',
		ar: 'حساب',
	},
	'billing.payment.track.details.request.dialog.payment.type': {
		en: 'Payment type:',
		ar: 'نوع الدفع:',
	},
	'billing.payment.track.details.request.dialog.bank.name': {
		en: 'Name of Bank:',
		ar: 'اسم البنك:',
	},
	'billing.payment.track.details.request.dialog.bank.account.number': {
		en: 'Bank Account Number:',
		ar: 'رقم الحساب المصرفي:',
	},
	'billing.payment.track.details.request.dialog.bank.cheque.number': {
		en: 'Cheque Number:',
		ar: 'رقم الشيك:',
	},
	'billing.payment.track.details.request.dialog.bank.total.amount.paid': {
		en: 'Total amount paid:',
		ar: 'إجمالي المبلغ المدفوع:',
	},
	'billing.payment.track.details.request.dialog.comment': {
		en: 'Comment:',
		ar: ':تعليق',
	},
	'billing.payment.track.details.request.dialog.bank.payment.date': {
		en: 'Date of Payment:',
		ar: ':تاريخ السداد',
	},
	'billing.payment.track.status.IN_PROGRESS': {
		en: 'In progress',
		ar: 'قيد الطلب',
	},
	'billing.payment.track.status.NEW': {
		en: 'New',
		ar: 'جديد',
	},
	'billing.payment.track.status.ACCEPTED': {
		en: 'Accepted',
		ar: 'الطلب مقبول',
	},
	'billing.payment.track.status.REJECTED': {
		en: 'Rejected',
		ar: 'الطلب مرفوض',
	},
	'billing.payment.track.status.DONE': {
		en: 'Done',
		ar: 'تم',
	},
	'billing.payment.track.status.ERROR': {
		en: 'Error',
		ar: 'خطأ',
	},
	'department.none.selected': {
		en: 'No department selected, user will not be able to login',
		ar: 'لم يتم تحديد أي قسم ، لن يتمكن المستخدم من تسجيل الدخول',
	},
	'number.details.termination.fees': {
		en: 'Termination fees',
		ar: 'رسوم انهاء الخدمة',
	},
	close: {
		en: 'Close',
		ar: 'يغلق',
	},
	'start.date': {
		en: 'Start date',
		ar: 'تاريخ البدء',
	},
	'end.date': {
		en: 'End date',
		ar: 'تاريخ الانتهاء',
	},
	'total.amount': {
		en: 'Total amount',
		ar: 'المبلغ الإجمالي',
	},
	'active.commitments.name': {
		en: 'Name',
		ar: 'الاسم',
	},
	'active.commitments.total.months': {
		en: 'Total months',
		ar: 'مجموع الشهور',
	},
	'active.commitments.remaining.months': {
		en: 'Remaining months',
		ar: 'الأشهر المتبقية',
	},
	'active.commitments.total.amount': {
		en: 'Total Amount',
		ar: 'المبلغ الإجمالي',
	},
	'active.commitments.remaining.amount': {
		en: 'Remaining amount',
		ar: 'المبلغ المتبقي',
	},
	'active.commitments.rate': {
		en: 'Rate',
		ar: 'المعدل',
	},
	'active.commitments.penalty': {
		en: 'Penalty',
		ar: 'الرسوم',
	},
	'active.commitments.start.date': {
		en: 'Start date',
		ar: 'تاريخ البدء',
	},
	'active.commitments.end.date': {
		en: 'End date',
		ar: 'تاريخ الانتهاء',
	},
	'change.number.change.number': {
		en: 'Change Number',
		ar: 'تغيير رقم',
	},
	'change.number.new.number': {
		en: 'New number',
		ar: 'رقم جديد',
	},
	'change.number.form.body': {
		en: 'Enter your new number',
		ar: 'أدخل رقمك الجديد',
	},
	'activities.details.technicalInformation': {
		en: 'Technical Information',
		ar: 'معلومات تقنية',
	},
	'activities.details.accountInformation': {
		en: 'Account Information',
		ar: 'معلومات رقم الحساب',
	},
	'activities.details.accountType': {
		en: 'Account Type',
		ar: 'نوع رقم الحساب',
	},
	'activities.details.billingType': {
		en: 'Billing Type',
		ar: 'نوع الفاتورة',
	},
	'activities.details.number': {
		en: 'Number',
		ar: 'الرقم',
	},
	'activities.details.product': {
		en: 'Product',
		ar: 'منتج',
	},
	'activities.details.newLimit': {
		en: 'New limit',
		ar: 'حد ائتماني جديد',
	},
	'activities.details.oldLimit': {
		en: 'Old limit',
		ar: 'حد الائتمان القديم',
	},
	'activities.details.browser': {
		en: 'Browser',
		ar: 'المستعرض',
	},
	'activities.details.chooseStartDate': {
		en: 'Choose start date',
		ar: 'اختر تاريخ البدء',
	},
	'activities.details.activityDetails': {
		en: 'Details',
		ar: 'تفاصيل',
	},
	'activities.details.activity.details': {
		en: 'Requests details',
		ar: 'تفاصيل الخدمات المفعلة',
	},
	'activities.details.event.details': {
		en: 'Request details',
		ar: 'تفاصيل الطلب',
	},
	'activities.details.accountId': {
		en: 'Account number',
		ar: 'رقم الحساب',
	},
	'number.services.mobile.internet.select.plan': {
		en: 'Select Mobile Internet plan',
		ar: 'حدد بيانات الهاتف المتنقل',
	},
	'number.services.mobile.internet.select.top.up': {
		en: 'Select Mobile Internet Top Up',
		ar: 'حدد خطة زيادة رصيد  بيانات الهاتف المتنقل',
	},
	'users.list.change.user.type.email.not.set': {
		en: 'The user type has not changed. There is no email address set for this account.',
		ar: 'نوع المستخدم لم يتغير. لا يوجد عنوان بريد إلكتروني معين لهذا الحساب.',
	},
	'users.list.change.user.type.email.exist.as.other.account': {
		en: 'The user type has not changed. Enduser email exist in system as other account.',
		ar: 'نوع المستخدم لم يتغير. البريد الإلكتروني للمستخدم النهائي موجود في النظام كحساب آخر.',
	},
	'purchase.bulk.devices.tab.payment': {
		en: 'Payment',
		ar: 'دفع',
	},
	'purchase.bulk.devices.tab.payment.success.title': {
		en: 'Congrats!',
		ar: 'مبروك',
	},
	'purchase.bulk.devices.tab.payment.failed.title': {
		en: 'Payment failed!',
		ar: '!عملية الدفع فشلت',
	},
	'purchase.bulk.devices.tab.payment.success.decription1': {
		en: 'You have ordered ',
		ar: 'لقد طلبت ',
	},
	'purchase.bulk.devices.tab.payment.success.decription2': {
		en: '%% devices for %% business lines within your organization.',
		ar: 'أجهزة %% لـ %% خطوط أعمال داخل مؤسستك.',
	},
	'purchase.bulk.devices.tab.payment.success.subtitle': {
		en: 'Your request number %%',
		ar: '%% رقم طلبك',
	},
	'purchase.bulk.devices.tab.summary': {
		en: 'Summary',
		ar: 'ملخص',
	},
	'purchase.bulk.devices.empty.cart.heading': {
		en: 'Your cart is empty',
		ar: 'عربة التسوق فارغة',
	},
	'purchase.bulk.devices.empty.cart.subheading': {
		en: 'Add first number to your order',
		ar: 'أضف الرقم الأول إلى طلبك',
	},
	'purchase.bulk.devices.empty.cart.number.input.label': {
		en: 'Start typing Omantel Number...',
		ar: 'ابدأ بكتابة رقم عمانتل',
	},
	'purchase.bulk.devices.voucher.loader.title': {
		en: 'Checking data',
		ar: 'التحقق من البيانات',
	},
	'purchase.bulk.devices.voucher.warning.invalid.account.category': {
		en: 'Invalid account category',
		ar: 'فئة الحساب غير صحيحة',
	},
	'purchase.bulk.devices.voucher.warning.closed.balance': {
		en: 'Closed balance',
		ar: 'رصيد مغلق',
	},
	'purchase.bulk.devices.voucher.warning.not.configured': {
		en: 'Number not configured for smart voucher',
		ar: 'لم يتم تكوين الرقم للقسيمة الذكية',
	},
	'purchase.bulk.devices.voucher.warning.device.commitments.exists': {
		en: 'Device commitment exist, not eligible for another device',
		ar: 'الالتزام بالجهاز موجود ، هذا الرقم غير مؤهل لجهاز آخر',
	},
	'purchase.bulk.devices.voucher.warning.not.active': {
		en: 'Phone number is not active',
		ar: 'رقم الهاتف غير نشط',
	},
	'purchase.bulk.devices.voucher.warning': {
		en: 'No voucher found, please pay upfront',
		ar: 'لم يتم العثور على قسيمة ، يرجى الدفع مقدمًا',
	},
	'purchase.bulk.devices.voucher.warning.invalid.discount': {
		en: 'Phone number does not have a valid discount. Please contact your Account Manager.',
		ar: 'رقم الهاتف لا يحتوي على خصم صالح. يرجى الاتصال بمدير حسابك',
	},
	'purchase.bulk.devices.warning.wrong.device': {
		en: 'Sorry, your plan is not compatible with selected product.',
		ar: 'نعتذر، باقتك لا تتناسبك مع المنتج المختار',
	},
	'purchase.bulk.devices.add.device.dialog.title': {
		en: 'Order device for %%',
		ar: '%% طلب الجهاز لرقم الجوال',
	},
	'purchase.bulk.devices.add.device.dialog.description': {
		en: 'Select and configure the device to add it to order',
		ar: 'حدد الجهاز  لإضافته إلى الطلب',
	},
	'purchase.bulk.devices.add.device.dialog.commitment.description': {
		en: 'Smart Voucher Commitment',
		ar: 'التزام القسيمة الذكية',
	},
	'purchase.bulk.devices.add.device.dialog.commitment.description.text': {
		en: 'Your commitment: ',
		ar: ' :التزامكم ',
	},
	'purchase.bulk.devices.add.device.dialog.commitment.period': {
		en: '%% months',
		ar: '%% اشهر',
	},
	'purchase.bulk.devices.add.device.dialog.input.title': {
		en: 'Device',
		ar: 'جهاز',
	},
	'purchase.bulk.devices.numbers.list.columns.number': {
		en: 'Mobile Number',
		ar: 'رقم الهاتف المحمول',
	},
	'purchase.bulk.devices.numbers.list.columns.tariff': {
		en: 'Tariff Plan',
		ar: 'خطة التعرفة',
	},
	'purchase.bulk.devices.numbers.list.columns.allowance': {
		en: 'Device allowance',
		ar: 'بدل الجهاز',
	},
	'purchase.bulk.devices.numbers.list.columns.loading': {
		en: 'Loading...',
		ar: 'تحميل...',
	},
	'purchase.bulk.devices.numbers.list.columns.commitment': {
		en: 'Commitment',
		ar: 'التزام',
	},
	'purchase.bulk.devices.numbers.list.columns.device': {
		en: 'Device',
		ar: 'جهاز',
	},
	'purchase.bulk.devices.numbers.list.columns.current.price': {
		en: 'Current Price',
		ar: 'السعر الحالي',
	},
	'purchase.bulk.devices.numbers.list.columns.prediscount.price': {
		en: 'Pre-discount',
		ar: 'الخصم المسبق',
	},
	'purchase.bulk.devices.numbers.list.add.next': {
		en: 'Add next Omantel Number',
		ar: 'أضف رقم عمانتل التالي',
	},
	'purchase.bulk.devices.numbers.list.add.device': {
		en: 'Add Device',
		ar: 'اضف جهاز',
	},
	'purchase.bulk.devices.numbers.list.delete.cart.item': {
		en: 'Do you want delete selected cart items?',
		ar: 'هل تريد حذف عناصر سلة التسوق المختارة؟',
	},
	'purchase.bulk.devices.go.to.cart': {
		en: 'Go to Cart',
		ar: 'اذهب إلى عربة التسوق',
	},
	'purchase.bulk.devices.add.to.cart': {
		en: 'Add to Cart',
		ar: 'أضف إلى السلة',
	},
	'purchase.bulk.devices.storage': {
		en: 'Storage: %%',
		ar: '%% :تخزين',
	},
	'purchase.bulk.devices.color': {
		en: 'Color: %%',
		ar: '%% :لون',
	},
	'purchase.bulk.devices.price.vat': {
		en: 'With %%% VAT: ',
		ar: ':مع %%% ضريبة القيمة المضافة',
	},
	'purchase.bulk.devices.next.number.popup.description': {
		en: 'Add another number to shopping cart',
		ar: 'أضف رقمًا آخر إلى عربة التسوق',
	},

	'purchase.bulk.devices.order.title': {
		en: 'Purchase Devices',
		ar: 'شراء الأجهزة الذكية',
	},
	'purchase.bulk.devices.order.description': {
		en:
			'Create an order for Single/Multiple numbers. Select the available Smartphones from the eshop you are interested in.',
		ar: 'قم بإنشاء الطلب لرقم او مجموعة ارقام . أضف الأجهزة الذكية المتوفرة في المتجر والتي تود شراءها',
	},
	'purchase.bulk.devices.order.description.cancel': {
		en: 'There are already added devices in the cart that cannot be processed in Bulk Orders and must be removed',
		ar: 'توجد بالفعل أجهزة مضافة في سلة التسوق لا يمكن معالجتها في الطلبات المجمعة ويجب إزالتها',
	},
	'purchase.bulk.devices.order.create': {
		en: 'Create order',
		ar: 'قم بإنشاء طلب',
	},
	'purchase.bulk.devices.title.select.number': {
		en: 'Select number',
		ar: 'اختر الرقم ',
	},
	'purchase.bulk.devices.subheader.select.number': {
		en: 'Please select the numbers, for which you want to order devices.',
		ar: 'الرجاء تحديد الأرقام التي تريد طلب الأجهزة لها.',
	},
	'purchase.bulk.devices.title.add.device': {
		en: 'Add device',
		ar: 'اختر جهازا',
	},
	'purchase.bulk.devices.subheader.add.device': {
		en: 'Please add devices for each number',
		ar: 'الرجاء إضافة أجهزة لكل رقم',
	},
	'purchase.bulk.devices.title.payment': {
		en: 'Payment',
		ar: 'الدفع',
	},
	'purchase.bulk.devices.title.summary': {
		en: 'Summary',
		ar: 'ملخص',
	},
	'purchase.bulk.devices.selected.numbers': {
		en: '%% of %%',
		ar: '%% من %%',
	},
	'change.number.unsuccessfulNumberChange': {
		en: 'Number could not be changed',
		ar: 'لا يمكن تغيير الرقم',
	},
	'change.number.successfulChange': {
		en: 'Number changed successfuly',
		ar: 'تم تغيير الرقم بنجاح',
	},
	'my.users.edit.permissions': {
		en: 'Permissions added',
		ar: 'تمت إضافة الأذونات',
	},
	'offline.payment.no.data': {
		en: 'No Data available',
		ar: 'لا توجد بيانات',
	},
	'complaints.number': {
		en: 'Number',
		ar: 'الرقم',
	},
	number: {
		en: 'Number',
		ar: 'الرقم',
	},
	'complaints.createdAt': {
		en: 'Created at',
		ar: 'أنشئت في',
	},
	'complaints.updatedAt': {
		en: 'Updated at',
		ar: 'تم التحديث في',
	},
	status: {
		en: 'Status',
		ar: 'الحالة',
	},
	'complaints.status': {
		en: 'Status',
		ar: 'الحالة',
	},
	'complaints.category': {
		en: 'Category',
		ar: 'الفئة',
	},
	'complaints.subcategory': {
		en: 'Subcategory',
		ar: 'تصنيف فرعي',
	},
	'complaints.complaint.details': {
		en: 'Complaint details',
		ar: 'تفاصيل الشكوى',
	},
	'complaints.type': {
		en: 'Type',
		ar: 'النوع',
	},
	'contact.us.track.ticket.click': {
		en: 'To see ticket history list click here',
		ar: 'لمشاهدة قائمة تاريخ الشكاوى ، انقر فوق',
	},
	'contact.us.track.ticket.here': {
		en: 'here',
		ar: 'هنا',
	},
	'new.postpaid.line.table.commitment.null': {
		en: 'No commitment',
		ar: 'لا يوجد التزام',
	},
	'new.postpaid.line.table.commitment.12': {
		en: '1 year commitment',
		ar: 'التزام لمدة سنة',
	},
	'new.postpaid.line.table.commitment.24': {
		en: '2 years commitment',
		ar: 'التزام لمدة سنتين',
	},
	'new.postpaid.line.table.commitment.36': {
		en: '3 years commitment',
		ar: 'التزام لمدة ثلاث سنوات',
	},
	'new.postpaid.line.tariffPlans': {
		en: 'Tariff Plans',
		ar: 'خطط التعرفة',
	},
	'new.postpaid.line.selectTariff': {
		en: 'Select Tariff Plan',
		ar: 'حدد خطة التعرفة',
	},
	'new.postpaid.line.no.billing.id': {
		en: 'No billing id',
		ar: 'لا يوجد معرف فوترة',
	},
	'custom.search.more.options': {
		en: 'To get more options please use search',
		ar: 'للحصول على المزيد من الخيارات الرجاء استخدام البحث',
	},
	'services.table.postpaid.line.CPN Minutes': {
		en: 'CPN Minutes',
		ar: 'دقائق CPN',
	},
	'services.table.postpaid.line.National Minutes': {
		en: 'National Minutes',
		ar: 'دقائق وطنية',
	},
	'services.table.postpaid.line.SMS': {
		en: 'SMS',
		ar: 'SMS',
	},
	'services.table.postpaid.line.Local and GCC Data': {
		en: 'Local and GCC Data',
		ar: 'البيانات المحلية ودول مجلس التعاون الخليجي',
	},
	'services.table.postpaid.line.GoBiz Data': {
		en: 'GoBiz Data',
		ar: 'بيانات GoBiz',
	},
	'services.table.postpaid.line.GoBiz Minutes': {
		en: 'GoBiz Minutes',
		ar: 'دقائق GoBiz',
	},
	'services.table.postpaid.line.Data - Global': {
		en: 'Data - Global',
		ar: 'البيانات - عالمية',
	},
	'services.table.postpaid.line.Nama Professional': {
		en: 'Nama Professional',
		ar: 'نما الرواد',
	},
	'services.table.postpaid.line.Nama 2022': {
		en: 'Nama 2022',
		ar: 'نما 2022',
	},
	'services.table.postpaid.line.bonus': {
		en: 'Bonus',
		ar: 'علاوة',
	},
	'services.table.postpaid.line.International Call': {
		en: 'International Calls',
		ar: 'مكالمات دولية',
	},
	'simtab.choose.sim.type': {
		en: 'Choose type of the SIM',
		ar: 'اختر نوع بطاقة SIM',
	},
	'new.postpaid.line.select.plan': {
		en: 'Select commitment period & plan',
		ar: 'حدد فترة الالتزام والخطة',
	},
	commitment: {
		en: 'Commitment',
		ar: 'التزام',
	},
	_CSTMERR_ORDERITEM_SERVICE_UNAVAILABLE: {
		en: 'Provided number is not authorized to order this device',
		ar: 'الرقم المقدم غير مصرح له بطلب هذا الجهاز',
	},
	_CSTMERR_ORDERITEM_MAX_ONE_COMMITMENT_PER_NUMBER: {
		en: 'Device commitment exist, not eligible for another device',
		ar: 'الالتزام بالجهاز موجود ، هذا الرقم غير مؤهل لجهاز آخر',
	},
	_ERR_INVALID_COOKIE: {
		en: 'Something went wrong.',
		ar: 'لقد حدث خطأ ما',
	},
	_ERR_BAD_REQUEST: {
		en: 'Something went wrong. Please contact your administrator for more information.',
		ar: '.لقد حدث خطأ ما.تواصل مع المشرف الخاص بك للمزيد من التفاصيل.',
	},
	'history.of.complaints.complaint.details.description': {
		en: 'Description',
		ar: 'الوصف',
	},
	'change.number.verification': {
		en: 'Verification',
		ar: 'تَحَقّق',
	},
	'change.email.change.email': {
		en: 'Change Email',
		ar: 'تغيير الايميل',
	},
	'change.email.new.email': {
		en: 'New Email',
		ar: 'بريد إلكتروني جديد',
	},
	'change.email.successfulChange': {
		en: 'Email changed successfully',
		ar: 'تم تغيير البريد الإلكتروني بنجاح',
	},
	'change.email.unsuccessfulEmailChange': {
		en: 'Email could not be changed',
		ar: 'لا يمكن تغيير البريد الإلكتروني',
	},
	'change.email.form.body': {
		en: 'Enter your new email',
		ar: 'أدخل بريدك الإلكتروني الجديد',
	},
	'otp.token.sent': {
		en: 'OTP token has been sent',
		ar: 'OTP token has been sent',
	},
	'users.details.changeUserTypeWarning.changeFromEnduser': {
		en: 'You are changing user type from Enduser, please provide an email',
		ar: 'يرجى إضافة البريد الإلكتروني قبل أن تقوم بتغير اسم المستخدم',
	},
	'users.details.changeUserType.addEmail': {
		en: 'Add Email',
		ar: 'أضف بريد إلكتروني',
	},
	'users.details.changeUserType.email': {
		en: 'Email',
		ar: 'البريد الإلكتروني',
	},
	'users.list.change.user.type.error.on.email.add': {
		en: 'There was an error while adding email',
		ar: 'حدث خطأ أثناء إضافة البريد الإلكتروني',
	},
	'user.details.permissions.delete': {
		en: 'Delete',
		ar: 'حذف',
	},
	'table.user.requestor': {
		en: 'Requestor',
		ar: 'المُطلب',
	},
	'table.user': {
		en: 'User',
		ar: 'المستخدم',
	},
	'table.type': {
		en: 'Type',
		ar: 'اطبع هنا ',
	},
	'table.status': {
		en: 'Status',
		ar: 'الحالة',
	},
	'service.requests.requestInfo': {
		en: 'Request Information',
		ar: 'معلومات الطلب',
	},
	'service.requests.request': {
		en: 'Request',
		ar: 'طلب',
	},
	'service.requests.sim.activate': {
		en: 'Activate SIM',
		ar: 'SIM تفعيل',
	},
	'service.requests.esim.activate': {
		en: 'Activate ESIM',
		ar: 'ESIM تفعيل',
	},
	'service.requests.sim.accept.msisdn': {
		en: 'Mobile Number',
		ar: 'رقم الهاتف المحمول',
	},
	'service.requests.sim.context': {
		en: 'SIM card type',
		ar: 'نوع الشريحة',
	},
	'service.requests.tariff.change.request': {
		en: 'Upgrade Plan to %%',
		ar: 'ترقية الخطة إلى %%',
	},
	'service.requests.tariff.change.ACCEPTED': {
		en: 'Approved',
		ar: 'تمت الموافقة',
	},
	'service.requests.tariff.change.REJECTED': {
		en: 'Rejected',
		ar: 'مرفوض',
	},
	'service.requests.tariff.change.PENDING': {
		en: 'Requested',
		ar: 'تم الطلب',
	},
	'service.requests.tariff.change.NEW': {
		en: 'Requested',
		ar: 'مطلوب',
	},
	'service.requests.reject': {
		en: 'Reject',
		ar: 'رفض',
	},
	'service.requests.reject.header': {
		en: 'Do you want to reject?',
		ar: 'هل ترغب في الرفض؟',
	},
	'service.requests.accept': {
		en: 'Accept',
		ar: 'قبول',
	},
	'service.requests.accept.header': {
		en: 'Do you want to accept request?',
		ar: 'هل ترغب في قبول الطلب؟',
	},
	'service.requests.accept.subject': {
		en: 'Number %% will upgrade plan to %%, %% commitment cost %% OMR',
		ar: 'سيتم ترقية الخطة للرقم %% إلى %%, %% بتكلفة التزام %% ريال عماني',
	},
	'service.requests.accept.sim.body': {
		en: 'Number %% will have new sim card activated',
		ar: 'سيتم تنشيط بطاقة SIM الجديدة للرقم %%',
	},
	'service.requests.accept.success.under.process': {
		en: 'Your request is under process, you will receive confirmation by mail.',
		ar: 'طلبك قيد المعالجة، ستتلقى تأكيداً عبر البريد',
	},
	'service.requests.accept.failure.header': {
		en: 'We cannot process your request now.',
		ar: 'لا يمكننا معالجة طلبك في الوقت الحالي',
	},
	'service.requests.accept.failure.try.again': {
		en: 'Please try again later',
		ar: 'يرجى المحاولة مرة أخرى لاحقًا',
	},
	'table.createdAt': {
		en: 'Created at',
		ar: 'أنشئت في',
	},
	'requests.details': {
		en: 'Request Details',
		ar: 'تفاصيل الطلب',
	},
	'service.requests.planToAdd': {
		en: 'Requested plan',
		ar: 'الخطة المطلوبة',
	},
	'service.requests.planToDelete': {
		en: 'Old plan',
		ar: 'الخطة القديمة',
	},
	'service.requests.commitment.period': {
		en: 'Commitment period',
		ar: 'فترة الالتزام',
	},
	'service.request.update.user.request.error': {
		en: 'There was an error while updating user request',
		ar: 'حدث خطأ أثناء تحديث طلب المستخدم',
	},
	'service.request.fetch.requests.error': {
		en: 'There was an error while trying to fetch user requests, try again later',
		ar: 'حدث خطأ أثناء محاولة الوصول إلى طلبات المستخدم، يرجى المحاولة مرة أخرى لاحقًا',
	},
	'change.number.error': {
		en: 'There was an error while changing number',
		ar: 'حدث خطأ عند تغييرالرقم ',
	},
	more: {
		en: '+ %% more',
		ar: '+ %% المزيد',
	},
	'change.email.duplicate.address': {
		en: 'This email address is already taken',
		ar: 'عنوان البريد الإلكتروني تم إستخدامه مسبقاً',
	},
	'prepaid.loyalty.add.new.services.vat.excluded': {
		en: '(VAT not included) *',
		ar: '(غير شامل الضريبة) *',
	},
	'prepaid.loyalty.add.new.services.vat.excluded.description': {
		en: '* All prices mentioned are exclusive of VAT. 5% VAT will be added to the price upon purchase.',
		ar:
			'* جميع الأسعار المبينة لا تشمل ضريبة القيمة المضافة. سيتم إضافة 5% ضريبة القيمة المضافة على السعر عند الدفع.',
	},
	'prepaid.loyalty.add.new.services.vat.included': {
		en: '(5% VAT included)',
		ar: '(يشمل ٥% ضريبة القيمة المضافة)',
	},
	'activities.no.business.id': {
		en: 'No business id',
		ar: 'لا يوجد معرف تجاري',
	},
	'activities.no.account.id': {
		en: 'No account id',
		ar: 'الحساب غير موجود',
	},
	'numbers.settings.replace.data.sim.card': {
		en: 'New Data SIM Card',
		ar: 'شريحة بيانات جديدة ',
	},
	'numbers.settings.replace.data.esim.card': {
		en: 'New Data ESIM Card',
		ar: 'شريحة بيانات إلكترونية جديدة',
	},
	'numbers.settings.replace.sawa.sim.card': {
		en: 'New Sawa SIM Card',
		ar: 'شريحة Sawa جديدة',
	},
	'numbers.settings.replace.sawa.esim.card': {
		en: 'New Sawa ESIM Card',
		ar: 'شريحة Sawa إلكترونية جديدة',
	},
	'numbers.settings.sim.details.add.new.sim': {
		en: 'Add new SIM',
		ar: 'إضافة شريحة جديدة',
	},
	'numbers.settings.esim.details.add.new.esim': {
		en: 'Add new ESIM',
		ar: 'إضافة شريحة إلكترونية جديدة',
	},
	'users.details.changeUserTypeWarning.addAuthorities': {
		en: 'After this action you will need to add authorities to this user',
		ar: 'بعد هذا الإجراء، ستحتاج إلى إضافة صلاحيات لهذا المستخدم',
	},
	'prepaid.newLoyalty.monthlyBillIsBlocked': {
		en:
			'Monthly bill payment method is blocked. You have no Prepaid Loyalty premissions. To enable your Enterprise Loyalty Account, please contact your Account Manager or Contact Center 1235',
		ar:
			'طريقة دفع الفاتورة الشهرية محظورة. ليس لديك أذونات الولاء المدفوعة مسبقًا. لتمكين حساب الولاء المؤسسي الخاص بك، يرجى الاتصال بمدير حسابك أو مركز الاتصال 1235',
	},
	'activities.details.numbersAffected': {
		en: 'Numbers affected',
		ar: 'الأرقام المتضررة',
	},
	'prepaid.loyalty.manage.service.details.table.phone.unsubscribed': {
		en: 'Number %% was unsubscribed',
		ar: 'تم إلغاء الاشتراك بالرقم %%',
	},
	'activities.details.paymentMethod': {
		en: 'Payment method',
		ar: 'طريقة الدفع',
	},
	'purchase.history.device.quantity': {
		en: 'Quantity',
		ar: 'العدد',
	},
	'purchase.history.device.price': {
		en: 'Price',
		ar: 'السعر',
	},
	'purchase.history.device.status': {
		en: 'Status',
		ar: 'الحالة',
	},
	'purchase.history.device.ordered.date': {
		en: 'Ordered Date',
		ar: 'تاريخ الطلب',
	},
	'purchase.history.device.last.updated': {
		en: 'Last update at',
		ar: 'اخر تحديث في',
	},
	'path.users.purchase.device.history': {
		en: 'Purchase Device History',
		ar: 'سجل شراء جهاز',
	},
	'purchase.history.device.details': {
		en: 'Order details',
		ar: 'تفاصيل الطلب',
	},
	'purchase.history.device.order.status.PENDING': {
		en: 'Pending',
		ar: 'قيد الانتظار',
	},
	'purchase.history.device.order.status.COMPLETED': {
		en: 'Completed',
		ar: 'مكتمل',
	},
	'purchase.history.device.order.status.CANCELLED': {
		en: 'Cancelled',
		ar: 'ألغاء',
	},
	'purchase.history.device.order.status.PAYMENT_COMPLETED': {
		en: 'Payment Completed',
		ar: 'تم الدفع بنجاح',
	},
	'tracking.title.ORDER_RECEIVED': {
		ar: 'تم تلقي الطلب ',
		en: 'Order received',
	},
	'tracking.description.ORDER_RECEIVED': {
		ar: 'لقد تلقينا طلبك.',
		en: 'We have received your order.',
	},
	'tracking.title.REQUEST_FROM_SUPPLIER': {
		ar: 'تم الطلب من المورد',
		en: 'Requested from supplier',
	},
	'tracking.description.REQUEST_FROM_SUPPLIER': {
		ar: 'لقد قمنا بطلب طلبك من المورد',
		en: 'We have requested your order from supplier.',
	},
	'tracking.title.PREPARED': {
		ar: 'تجهيز الطلب',
		en: 'Preparing',
	},
	'tracking.track.shipping': {
		ar: 'تتبع الطلب',
		en: 'Track shipping',
	},
	'tracking.track.shipping.id': {
		ar: ' %% :معرّف الشحن الخاص بك',
		en: 'Your shipping ID: %%',
	},
	'tracking.track.delivery': {
		ar: 'تتبع الشحن',
		en: 'Track delivery',
	},
	'tracking.doneTitle.PREPARED': {
		ar: 'تم تجهيز الطلب',
		en: 'Prepared',
	},
	'tracking.description.PREPARED': {
		ar: 'نقوم الآن بتجهيز طلبك.',
		en: 'We are preparing your order.',
	},
	'tracking.doneDescription.PREPARED': {
		ar: 'لقد قمنا بتجهيز طلبك.',
		en: 'We have prepared your order.',
	},
	'tracking.title.SHIPPED': {
		ar: 'شحن الطلب',
		en: 'Shipping',
	},
	'tracking.doneTitle.SHIPPED': {
		ar: 'تم شحن الطلب',
		en: 'Shipped',
	},
	'tracking.description.SHIPPED': {
		ar: 'الطلب في الطريق',
		en: 'Your order is on the way.',
	},
	'tracking.title.DELIVERED': {
		ar: 'توصيل',
		en: 'Delivery',
	},
	'tracking.doneTitle.DELIVERED': {
		ar: 'تم تسليم الطلب',
		en: 'Delivered',
	},
	'tracking.doneDescription.DELIVERED': {
		ar: 'طلبك الآن بين يديك!',
		en: 'Hooray, your order is in your hands!',
	},
	'tracking.inProgress': {
		ar: 'الطلب قيد التقدم',
		en: 'In progress',
	},
	'tracking.title.READY_TO_PICKUP': {
		ar: 'جاهز للاستلام',
		en: 'Ready to pickup',
	},
	'tracking.description.READY_TO_PICKUP': {
		ar: 'طلبك جاهز للاستلام',
		en: 'Your order is ready to be picked up',
	},
	month: {
		en: 'Month',
		ar: 'الشهر',
	},
	'payments.bills.ordered.zips': {
		en: 'Ready to download',
		ar: 'جاهز للتحميل',
	},
	'path.purchase.device.history': {
		en: 'Purchase Device History',
		ar: 'سجل شراء جهاز',
	},
	'path.faq': {
		en: 'FAQ',
		ar: 'الأسئلة الشائعة ',
	},
	'faq.product.in.stock.question': {
		en: 'Are the products in stock and readily available?',
		ar: 'هل المنتجات متوفرة حاليًا وجاهزة للشراء؟',
	},
	'faq.product.in.stock.answer': {
		en:
			'The majority of the products displayed on our website are currently in stock. In the event that an item is temporarily out of stock, it will be clearly labeled, and you will have the option to receive a notification once it becomes available.',
		ar:
			'معظم المنتجات المعروضة على موقعنا متاحة في المخزون حاليًا. في حالة نفاد مؤقت لأحد المنتجات، سيتم وضع علامة واضحة على ذلك، وستتاح لك الفرصة لتلقي إشعار حال توفرها مجددًا.',
	},
	'faq.payment.methods.question': {
		en: 'What payment methods can I use?',
		ar: 'ما هي وسائل الدفع المتاحة',
	},
	'faq.payment.methods.answer': {
		en: 'We accept payments through Visa and MasterCard.',
		ar: 'نحن نقبل دفعاتكم عبر بطاقات فيزا وماستركارد',
	},
	'faq.voucher.question': {
		en: 'Can I use my voucher to purchase devices?',
		ar: 'هل يمكن استخدام القسائم لشراء الأجهزة؟',
	},
	'faq.voucher.answer': {
		en: 'Yes, you can indeed redeem your voucher when making a purchase',
		ar: 'نعم، يمكنكم استخدام القسائم بكل ثقة عند القيام بعملية الشراء.',
	},
	'faq.delivery.question': {
		en: 'Can I select cash-on-delivery as a payment method?',
		ar: 'هل يمكن اختيار الدفع نقدًا عند الاستلام؟',
	},
	'faq.delivery.answer': {
		en:
			'No, we exclusively accept payments via Visa and MasterCard to ensure a smooth and secure transaction process.',
		ar: 'للأسف، نحن نقبل  الدفع من خلال بطاقات فيزا وماستركارد فقط، وذلك لضمان تسهيل عملية الدفع وتأمينها.',
	},
	'faq.vat.question': {
		en: 'Is VAT applied to the order total?',
		ar: 'هل تُفرض ضريبة القيمة المضافة (VAT) على السعر الإجمالي؟',
	},
	'faq.vat.answer': {
		en:
			'Yes, please be aware that VAT is included in the total price of your order in compliance with tax regulations.',
		ar:
			'نعم، نرجو منكم ملاحظة أن ضريبة القيمة المضافة مُضافة إلى السعر الإجمالي للطلب وذلك امتثالا للتشريعات الضريبية.',
	},
	'faq.delivery.charges.question': {
		en: 'What are the associated delivery fees?',
		ar: 'ما هي تكلفة الشحن المرتبطة بالطلب؟',
	},
	'faq.delivery.charges.answer': {
		en: 'Delivery charges are 2 OMR for orders within Muscat and 3 OMR for orders in other regions.',
		ar: 'تبلغ رسوم التوصيل 2 ريال عماني للطلبات داخل مسقط و 3 ريال عماني للطلبات في مناطق أخرى.',
	},
	'faq.order.time.question': {
		en: 'How long can I expect to wait for my order to arrive?',
		ar: 'كم يستغرق لاستلام الطلب؟',
	},
	'faq.order.time.answer': {
		en: 'Your order will be delivered to your doorstep within 48 hours.',
		ar: 'سيتم توصيل طلبكم إلى باب منزلكم في غضون 48 ساعة.',
	},
	'payments.bills.select.month': {
		en: 'Select month to generate bill',
		ar: 'حدد الشهر لإنشاء الفاتورة',
	},
	submit: {
		en: 'Submit',
		ar: 'إرسال',
	},
	'purchase.hisotry.device.orderId': {
		en: 'Order ID',
		ar: 'رقم الطلب',
	},
	'table.confirmedBy': {
		en: 'Confirmed By',
		ar: 'تم بواسطة',
	},
	'dashboard.mb.heading': {
		en: "A'amali+",
		ar: 'أعمالي+',
	},
	'dashboard.mb.tag': {
		en: 'NEW',
		ar: 'جديد',
	},
	'dashboard.mb.description': {
		en:
			'For Riyada customers only. Unlock the Power of Simplicity with Our All-in-One Solution for Small & Medium Business.',
		ar: 'قم بتعزيز النطاق العريض لأعمالك مع أعمالي+ اليوم. ارفع مستوى اتصالك وحقق تقدمًا في الأداء اليوم.',
	},
	'dashboard.mb.view.plans.button': {
		en: 'View all plans',
		ar: 'عرض جميع الخطط',
	},
	'mb.add.new.heading': {
		en: "Please choose a new A'amali+",
		er: 'إضافة حزمة بيانات صغيرة جديدة',
	},
	// 'aamali.plus.promotional.price-1': {
	// 	en: 'Enjoy the %% plan at a special promotional price of %% OMR until 21-05-2024',
	// 	ar: 'استمتع بباقة %% بسعر ترويجي خاص %% ريال عماني لأول حتى 21-05-2024', //need arabic
	// },
	'aamali.plus.promotional.price-1': {
		en: 'The promotion is valid until 21-05-2024',
		ar: 'الخصم صالح حتى تاريخ 21-05-2024',
	},
	'aamali.plus.promotional.price-2': {
		en: 'for first 90 days',
		ar: 'احصل على هذه الخطة بسعر ترويجي قدره 28 ريال عماني للفترة الأولى 90 يومًا',
	},

	'aamali.plus.additional.info': {
		en: '**Marketing Bulk SMS is valid for 1 month free of charge   |   One year Commitment on SME Bundle',
		ar:
			'** الرسائل النصية القصيرة التسويقية صالحة لمدة شهر واحد من التغيير | التزام لمدة عام على باقة الرسائل القصيرة',
	},
	'mb.plans.column-plan_value': {
		en: 'Plan',
		ar: 'خطة',
	},
	'mb.plans.column-download_speed': {
		en: 'Download Speed',
		ar: 'سرعة التنزيل',
	},
	'mb.plans.column-microsoft_365': {
		en: 'Microsoft 365 (Basic)',
		ar: 'مايكروسوفت 365',
	},
	'mb.plans.column-marketing_bulk_sms': {
		en: '%% Marketing SMS',
		ar: '%% الرسائل القصيرة التسويقية بالجملة',
	},
	'mb.plans.column-web_hosting': {
		en: 'Web Hosting',
		ar: 'استضافة الويب',
	},
	'mb.plans.column-domain': {
		en: '%% ',
		ar: '%%',
	},
	'mb.plans.column-discount': {
		en: 'Discount',
		ar: 'خصم',
	},
	'mb.plans.column-mobile_pbx': {
		en: 'Mobile PBX',
		ar: 'الهاتف الخلوي الخاص بالأعمال',
	},
	'mb.plans.column-6': {
		en: 'Price',
		ar: 'اشتراك شهري',
	},
	'all.packages.include': {
		en: 'All Packages include the following:',
		ar: 'تشمل جميع الحزم الآتية:',
	},
	'mb.package.domain': {
		en: 'Domain',
		ar: 'نطاق',
	},
	'mb.package.web_hosting': {
		en: 'Web Hosting',
		ar: 'استضافة الويب',
	},
	'mb.package.mobile_pbx': {
		en: 'Mobile PBX',
		ar: 'الهاتف الخلوي الخاص بالأعمال',
	},
	'submit.request': {
		en: 'Submit',
		ar: 'تقديم الطلب',
	},
	'enter.contact-details': {
		en: 'Add your contact details',
		ar: 'أدخل تفاصيل الاتصال الخاصة بك',
	},
	'mb.form.label.your.plan': {
		en: 'Your Plan',
		ar: 'خطتك',
	},
	'mb.form.label.your.name': {
		en: 'Enter the applicant name',
		ar: 'أدخل اسم مقدم الطلب',
	},
	'mb.form.label.org.name': {
		en: 'Enter your organization name',
		ar: 'أدخل اسم منظمتك',
	},
	'mb.form.label.your.contact': {
		en: 'Enter your contact number',
		ar: 'ادخل رقم التواصل',
	},
	'mb.form.label.your.email': {
		en: 'Enter your email address',
		ar: 'أدخل عنوان بريدك الإلكتروني',
	},
	'mb.fbb.100.mbps.plan': {
		en: 'FBB 100 MBPS',
		ar: 'FBB 100 ميجابت في الثانية',
	},
	'mb.fbb.200.mbps.plan': {
		en: 'FBB 200 MBPS',
		ar: 'FBB 200 ميجابت في الثانية',
	},
	'mb.5G.100.Gbps.plan': {
		en: '5G 100 GBPS',
		ar: '5G 100 جيجابت في الثانية',
	},
	'mb.5G.200.Gbps.plan': {
		en: '5G 200 GBPS',
		ar: '5G 200 جيجابت في الثانية',
	},
	'country.code': {
		en: '+968',
		ar: '+968',
	},
	'mb.thankyou.header': {
		en: 'Thank you for your request.',
		ar: ' شكرا لك على طلبك.',
	},
	'mb.thankyou.body': {
		en: 'Thank you for choosing Omantel. You will be contacted within two working days.',
		ar: 'شكرا لي اختيارك عمانتل. سيتم الاتصال بك خلال يومين عمل.',
	},
	'mb.thankyou.ref': {
		en: 'Your reference number is:',
		ar: 'الرقم المرجعي الخاص بك هو:',
	},
	'mb.thankyou.body2': {
		en: 'To follow up on your request.',
		ar: 'لمتابعة طلبك',
	},
	'mb.thankyou.body3': {
		en: 'Please contact your account manager or call 1235',
		ar: 'الرجاء التواصل مع مدير الحسابات الخاص بك أو الاتصال على 1235',
	},
	'mb.failure.header': {
		en: 'Your request has not been processed.',
		ar: 'لم يتم معالجة طلبك.',
	},
	'mb.failure.body': {
		en: 'Your request has not been processed, please try again later.',
		ar: 'لم يتم معالجة طلبك، يرجى المحاولة مرة أخرى لاحقًا.',
	},
	'mb.failure.body2': {
		en: 'If the issue persist, please contact your account manager or call 1235',
		ar: 'إذا استمرت المشكلة، يرجى الاتصال بمدير حسابك أو الاتصال بالرقم 1235',
	},
	'mb.contact.validation': {
		en: 'Please enter a valid phone number',
		ar: 'الرجاء إدخال رقم هاتف صحيح',
	},
	'mb.name.validation': {
		en: 'Please enter a valid name',
		ar: 'الرجاء إدخال الاسم الصحيح',
	},
	'mb.email.validation': {
		en: 'Please enter a valid email address',
		ar: 'يرجى إدخال عنوان بريد إلكتروني صحيح',
	},
	'add.new.mb.location.tab': {
		en: 'Location',
		ar: 'الموقع',
	},
	'add.new.mb.plansServices.tab': {
		en: 'Plans',
		ar: 'الباقات',
	},
	'add.new.mb.additionalBenefits.tab': {
		en: 'Additional Benefits',
		ar: 'فوائد إضافية',
	},
	'add.new.mb.contact.details.tab': {
		en: 'Contact Details',
		ar: 'بيانات المتصل',
	},
	'add.new.mb.submit.tab': {
		en: 'Submit',
		ar: 'إرسال',
	},
	'add.new.services.add.aamali.plus': {
		en: "Add A'amali+",
		ar: 'إضافة أعمالي+ ',
	},
	'path.add.new.aamali.plus': {
		en: "Add A'amali+",
		ar: 'إضافة أعمالي+',
	},
	'riyada.customer.only': {
		en: '(For Riyada Customers Only)',
		ar: '(لعملاء الريادة فقط)',
	},
	'additional.service.heading': {
		en: 'Select Additional Services',
		ar: 'اختر الخدمات الإضافية',
	},
	'additional.service.view.details': {
		en: 'View Details',
		ar: 'عرض التفاصيل',
	},
	'additional.service.package.info': {
		en: 'package info',
		ar: 'معلومات الحزمة',
	},
	'additional.service.info.heading': {
		en: 'You are eligible for:',
		ar: 'أنت مؤهل لـ',
	},
	'prefix.download.speed': {
		en: 'up to %%',
		ar: 'حتى %%', //arabic
	},
	'mb.discount': {
		en: 'DISCOUNT',
		ar: 'خصم',
	},
	'mb.select.button': {
		en: 'Select',
		ar: 'اختر',
	},
	'mb.aamali.plus': {
		en: "A'amali+",
		ar: 'أعمالي+', //arabic
	},
	'mb.additional.benefits.plan': {
		en: "A'amali+ %% Plan",
		ar: 'أعمالي+ %% باقة',
	},
	'mb.additional.benefits.plan.activation': {
		en: '%% Plan',
		ar: 'باقة %%',
	},
	'mb.additional.benefits.select': {
		en: 'Select Additional Benefits',
		ar: 'اختر مزايا إضافية ',
	},
	'mb.additional.benefits.description': {
		en:
			'This plan includes additional benefits. Activate these benefits by checking the corresponding checkboxes next to your selected plan. If you decide not to take advantage of these benefits at this time, you can always choose them later through your account.',
		ar:
			'تشتمل هذه الباقة على مزايا إضافية. قم بتفعيل هذه المزايا عن طريق تحديد مربعات الاختيار المقابلة بجانب الباقة المحددة. إذا قررت عدم الاستفادة من هذه المزايا في الوقت الحالي، فيمكنك دائمًا اختيارها لاحقًا من خلال حسابك.',
	},
	'mb.additional.benefits.selectall': {
		en: 'Select all',
		ar: 'اختر الكل',
	},
	'currency.omr': {
		en: 'OMR',
		ar: 'ريال عماني',
	},
	'numbers.aamali': {
		en: "A'amali+",
		ar: 'أعمالي+',
	},
	'mb.additional.benefit.status.pending': {
		en: 'Pending',
		ar: 'قيد الانتظار',
	},
	'mb.additional.benefit.status.active': {
		en: 'Active',
		ar: 'مفعل',
	},
	'button.activate': {
		en: 'Activate',
		ar: 'تفعيل',
	},
	'activation.request': {
		en: 'Send activation requests for following services:',
		ar: 'طلب تفعيل الخدمات التالية:',
	},
	'info.clause.marketingsms1': {
		en: 'Marketing SMS is one time service valid for 1 month from the date of subscription',
		ar: 'خدمة الرسائل النصية القصيرة هي خدمة لاستخدم مرة واحدة فقط ، وصالحة لمدة شهر واحد من تاريخ الاشتراك',
	},
	'info.clause.marketingsms.identifier': {
		en: '|',
		ar: '|',
	},
	'info.clause.marketingsms2': {
		en: 'One year Commitment on SMS Bundle',
		ar: ' التزام لمدة عام على باقة الرسائل القصيرة',
	},
	'submit.activation.request': {
		en: 'Submit Request',
		ar: 'تقديم الطلب',
	},
	'mb.plan': {
		en: '%% Plan',
		ar: 'خطة %%', // arabic
	},
	'mb.aamali.plus.plan': {
		en: "A'amali+ %% Plan ",
		ar: 'أعمالي+ %% خطة', //arabic
	},
	'add.new.aamali.plus.price.with.start': {
		en: '%% OMR*',
		ar: '%% ريال*',
	},
	'add.new.aamali.plus.price': {
		en: '%% OMR',
		ar: '%% ريال',
	},
	'aamali.plus.service': {
		en: "A'AMALI+",
		ar: 'أعمالي+',
	},
	'add.new.aamali.plus.cut.price': {
		en: '%% OMR',
		ar: '%% ريال عماني',
	},
	'click.aamali.plus.benefits': {
		en: "Claim your A'amali+ benefits",
		ar: 'لطلب الخدمات المقدمة في باقة أعمالي+',
	},
	'bwod.2months.eligible.heading': {
		en: 'Boost your current plan and enjoy blazing speed on top of your current plan!',
		ar: 'عزز باقتك الحالية واستمتع بسرعة فائقة فوق الباقة الحالية!',
	},
	'bwod.addon': {
		en: 'Add on',
		ar: 'إضافة',
	},
	'bwod.speed.upgrade.price': {
		en: 'Speed upgrade price :',
		ar: 'سعر ترقية السرعة:',
	},
	'bwod.validity.key': {
		en: 'Validity: ',
		ar: 'صلاحية',
	},
	'bwod.2months.validity': {
		en: 'For up-to 2 months usable anytime within the base plan validity!',
		ar: 'لمدة تصل إلى شهرين قابلة للاستخدام في أي وقت ضمن صلاحية الباقة الأساسية!',
	},
	'bwod.1month.validity': {
		en: 'For up-to 1 month usable anytime within the base plan validity!',
		ar: 'لمدة تصل إلى شهر قابلة للاستخدام في أي وقت ضمن صلاحية الباقة الأساسية!',
	},
	'bwod.banner.upgradePlan': {
		en: 'Did you enjoy the speed boost? Change your plan now for an even faster online journey.',
		ar: 'هل استمتعت بزيادة السرعة؟ غير الباقة الآن لرحلة أسرع عبر الإنترنت.',
	},
	'bwod.banner.extend.link': {
		en: 'Extend now',
		ar: 'تمديد الآن',
	},
	'bwod.banner.upgrade.link': {
		en: 'Upgrade your plan',
		ar: 'ترقية الباقة ',
	},
	'bwod.banner.try.now.button': {
		en: 'Try it Now',
		ar: 'جربه الآن',
	},
	'bwod.card.expired.heading': {
		en: "You've enjoyed the %% booster for a month. Extend your smooth online journey by another month.",
		ar: '', // need arabic for that
	},
	'bwod.add.on.cost.key': {
		en: 'Add-on activation cost',
		ar: 'تكلفة تفعيل الإضافات',
	},
	'bwod.addon.cost.value': {
		en: '%% (%%% VAT Extra)',
		ar: '%% (%%% ضريبة القيمة المضافة )',
	},
	'bwod.add.on.available.key': {
		en: 'Add-on available for',
		ar: 'الإضافات متاحة لي',
	},
	'bwod.banner.expired': {
		en: 'Your current speed booster add-on has expired. You qualify for an additional month of the add-on. ',
		ar: 'انتهت صلاحية معزز السرعة. أنت مؤهل للحصول على شهر إضافي من الإضافة.',
	},
	'bwod.banner.extend.now.button': {
		en: 'Extend Now',
		ar: 'تمديد الآن',
	},
	'bwod.speed.booster.heading': {
		en: 'Speed Booster Add-on extension',
		ar: 'تمديد إضافي لمعزز السرعة ',
	},
	'bwod.base.plan.heading': {
		en: 'Your base plan details',
		ar: 'تفاصيل الباقة الأساسية',
	},
	'bwod.base.plan.name.heading': {
		en: 'Plan Name',
		ar: 'اسم الخطة',
	},
	'bwod.base.plan.end.heading': {
		en: 'Base plan ends on',
		ar: 'تنتهي الباقة الأساسية في',
	},
	'bwod.addOn.plan.heading': {
		en: 'Add-on Speed: %%',
		ar: 'سرعة إضافة: %%',
	},
	'bwod.addOn.select.duration': {
		en: 'Select a duration for your add-on',
		ar: 'حدد مدة الإضافات الخاصة بك',
	},
	'bwod.new.plan.cost.value': {
		en: '(%%% VAT Extra)',
		ar: '(%%% ضريبة القيمة المضافة )',
	},
	'bwod.new.plan.cost.heading': {
		en: 'Add-on activation cost',
		ar: 'تكلفة تفعيل  الإضافات',
	},
	'bwod.new.plan.date.heading': {
		en: 'Add-on plan ends on',
		ar: 'تنتهي الباقة الإضافية في',
	},
	'bwod.new.plan.date.value': {
		en: 'and then you will be back on your original plan.',
		ar: 'وبعد ذلك ستعود إلى خطتك الأصلية.',
	},
	'bwod.thankyou.body': {
		en: 'Your Order ID is  %%. The request will be fulfilled within 24 hours.',
		ar: 'رقم الطلب الخاص بك هو %%. سيتم تلبية الطلبك في خلال 24 ساعة عمل.',
	},
	'bwod.one.month': {
		en: '%% Month',
		ar: '%% شهر',
	},
	'bwod.two.months': {
		en: '%% Months',
		ar: '%% أشهر',
	},
	'bwod.try.againButton': {
		en: 'Try Again',
		ar: 'حاول مرة أخرى',
	},
	'bwod.card.active.heading': {
		en: 'You’re currently enjoying %% booster. Change your plan now for an even smoother online journey.',
		ar: 'أنت تستمتع حاليا بمعزز %%. غير الباقة الآن لرحلة أكثر سلاسة عبر الإنترنت.', // need arabic
	},
	'bwod.card.pending.heading': {
		en: 'Thank you for your request. Your order number is #1234. Stay tuned for updates!',
		ar: 'شكرا لك على طلبك. رقم طلبك هو "# 1234". ترقبوا التحديثات!',
	},
	'bwod.add.on.requested.on.key': {
		en: 'Add-on requested on',
		ar: 'الإضافة المطلوبة في',
	},
	'bwod.add.on.expires.on.key': {
		en: 'Add-on expires on',
		ar: 'تنتهي صلاحية الإضافية في',
	},
	'bwod.add.on.duration.key': {
		en: 'Add-on duration',
		ar: 'مدة الإضافة',
	},
	'bwod.banner.active.expiry': {
		en: 'Your current speed booster add-on expires in %% days.',
		ar: '', // need arabic
	},
	'bwod.banner.active.expiry.day': {
		en: 'Your current speed booster add-on expires in %% day.',
		ar: 'تنتهي صلاحية الإضافية الحالية لمعزز السرعة في غضون %% أيام.', // need arabic
	},
	'bwod.banner.pending': {
		en: 'To follow up on your request. Please contact your account manager or call 1235',
		ar: 'لمتابعة طلبك، يرجى الاتصال بمدير حسابك أو الاتصال بالرقم 1235',
	},
	'bwod.active.status': {
		en: 'Active',
		ar: 'نشط',
	},
	'bwod.pending.status': {
		en: 'Request Pending',
		ar: 'الطلب قيد التنفيذ',
	},
	'bwod.expired.status': {
		en: 'Expired',
		ar: 'انتهت  ',
	},
	'bwod.add.on': {
		en: 'Add-on',
		ar: 'إضافة',
	},
	'plan.change.heading': {
		en: 'Are you sure you want to change your plan?',
		ar: 'هل أنت متأكد من أنك تريد تغيير الباقة؟',
	},
	'plan.change.sub.heading': {
		en: 'The upgraded plan includes enhanced speed. Please confirm to proceed.',
		ar: 'تتضمن الباقة التي تمت ترقيتها سرعة محسنة. يرجى تأكيد المتابعة.',
	},
	'plan.change.new.plan': {
		en: 'Your New Plan',
		ar: 'الباقة الجديدة',
	},
	'plan.change.old.plan': {
		en: 'Your Old Plan',
		ar: 'الباقة القديمة ',
	},
	confirmation: {
		en: 'Confirmation',
		ar: 'تأكيد',
	},
	help: {
		en: 'Help',
		ar: 'مساعدة',
	},
	'nav.notification': {
		en: 'Notification',
		ar: 'الإشعارات',
	},
	'nav.menu': {
		en: 'Menu',
		ar: 'القائمة',
	},
	'nav.user.profile': {
		en: 'User profile',
		ar: 'الملف الشخصي',
	},
	'path.nav.subscription': {
		en: 'Subscription',
		ar: 'الاشتراك',
	},
	'path.nav.billing': {
		en: 'Billing & Payments',
		ar: 'الفواتير والدفع',
	},
	'path.nav.insights': {
		en: 'Insights',
		ar: 'رؤى',
	},
	'path.nav.support': {
		en: 'Support',
		ar: 'الدعم',
	},
	'nav.logo': {
		en: 'Omantel Website',
		ar: 'موقع عمانتل',
	},
	'enter.otp.title': {
		en: 'Enter OTP',
		ar: 'أدخل كلمة المرور لمرة واحدة (OTP)',
	},
	newDashboardLink: { en: 'Try New Dashboard', ar: 'جرب لوحة تحكم جديدة' },
};
